

// // components/Admin/AdminDashboard.js
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useAuth } from '../../context/AuthContext';
// import Invoice from './Invoice';
// import Quotation from './Quotation';

// const API_BASE = "http://localhost:5000/api";

// const AdminDashboard = () => {
//   const navigate = useNavigate();
//   const { user, isAdmin, logout } = useAuth();
//   const [activeTab, setActiveTab] = useState("dashboard");
//   const [isLoading, setIsLoading] = useState(true);
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [showProfileDropdown, setShowProfileDropdown] = useState(false);
//   const profileDropdownRef = useRef(null);

//   // Dashboard stats
//   const [dashboardStats, setDashboardStats] = useState({
//     totalProducts: 0,
//     totalCategories: 9,
//     totalInquiries: 0,
//     monthlySales: "₹0",
//     pendingQuotes: 0,
//     conversionRate: "0%",
//     visitors: 0,
//     revenue: "₹0",
//     industrial: 0,
//     totalConsultations: 0,
//     loginAttempts: 0,
//     todayLoginAttempts: 0,
//     totalNews: 0,
//     totalFreeDemos: 0
//   });

//   // Consultation state
//   const [consultations, setConsultations] = useState([]);
//   const [isLoadingConsultations, setIsLoadingConsultations] = useState(false);
//   const [consultationStats, setConsultationStats] = useState({
//     total: 0,
//     today: 0,
//     recent: 0,
//     conversionRate: 0,
//     status: {
//       new: 0,
//       contacted: 0,
//       follow_up: 0,
//       quotation_sent: 0,
//       closed_won: 0,
//       closed_lost: 0
//     },
//     priority: {
//       low: 0,
//       medium: 0,
//       high: 0
//     },
//     byType: {
//       residential: 0,
//       commercial: 0,
//       industrial: 0
//     }
//   });
//   const [consultationFilter, setConsultationFilter] = useState('all');

//   // Products state
//   const [products, setProducts] = useState([]);
//   const [isLoadingProducts, setIsLoadingProducts] = useState(false);
//   const [productStats, setProductStats] = useState({
//     total: 0,
//     active: 0,
//     inactive: 0,
//     featured: 0,
//     bestSellers: 0,
//     byCategory: [],
//     priceStats: {},
//   });

//   const [newProduct, setNewProduct] = useState({
//     name: "",
//     category: "Solar Panels",
//     price: "",
//     originalPrice: "",
//     description: "",
//     fullDescription: "",
//     rating: "4.5",
//     reviews: "0",
//     stock: "100",
//     features: ["", "", "", ""],
//     specifications: {
//       power: "",
//       efficiency: "",
//       warranty: "",
//       dimensions: "",
//       weight: "",
//     },
//     tags: "",
//     isFeatured: false,
//     isBestSeller: false,
//     isActive: true,
//     image: null,
//     imagePreview: "",
//     pdfFile: null,
//     pdfPreview: "",
//   });

//   // Login Attempts state
//   const [loginAttempts, setLoginAttempts] = useState([]);
//   const [loginStats, setLoginStats] = useState({
//     total: 0,
//     successful: 0,
//     admin: 0,
//     today: 0,
//     successRate: 0
//   });
//   const [isLoadingLoginAttempts, setIsLoadingLoginAttempts] = useState(false);

//   // Slideshow state
//   const [slides, setSlides] = useState([]);
//   const [newSlide, setNewSlide] = useState({
//     title: "",
//     subtitle: "",
//     buttonText: "Explore",
//     buttonLink: "#",
//     image: null,
//     imagePreview: "",
//   });

//   // Best Sellers state
//   const [bestSellers, setBestSellers] = useState([]);
//   const [newBestSeller, setNewBestSeller] = useState({
//     title: "",
//     originalPrice: "",
//     currentPrice: "",
//     saveAmount: "",
//     rating: "4.5",
//     reviews: "0",
//     buttonText: "Enquire Now",
//     buttonLink: "#",
//     image: null,
//     imagePreview: "",
//     pdfFile: null,
//     pdfPreview: "",
//     isActive: true,
//   });

//   // Categories state
//   const [categories, setCategories] = useState([
//     "All Products",
//     "Solar Panels",
//     "Inverters",
//     "Batteries",
//     "Controllers",
//     "Accessories",
//     "Complete Kits",
//     "Water Heaters",
//     "Solar Lighting",
//   ]);

//   const [newCategory, setNewCategory] = useState({
//     name: "",
//     icon: "📦",
//   });

//   // Main Page Sections state
//   const [mainPageSections, setMainPageSections] = useState([
//     {
//       id: 1,
//       title: "MODERN ENERGY SOLUTIONS",
//       subtitle: "Comprehensive energy solutions tailored to your needs",
//       description: "",
//       image: "/images/main-hero.jpg",
//       imagePreview: "",
//       buttonText: "Learn More",
//       buttonLink: "/solutions",
//       sectionType: "hero",
//     },
//     {
//       id: 2,
//       title: "Onsite Solar",
//       subtitle: "Make progress toward decarbonization",
//       description:
//         "Make progress toward decarbonization and expedite the transition to clean energy with minimized risk and complexity—all without upfront capital expenditures.",
//       image: "/images/solar-section.jpg",
//       imagePreview: "",
//       buttonText: "Learn More →",
//       buttonLink: "/solar",
//       sectionType: "solution",
//       icon: "☀️",
//     },
//     {
//       id: 3,
//       title: "Energy Storage",
//       subtitle: "Optimize and access reliable energy",
//       description:
//         "Optimize and access reliable, cost-effective energy through advanced commercial and industrial energy storage solutions, safeguarding your facility from power outages and interruptions.",
//       image: "/images/storage-section.jpg",
//       imagePreview: "",
//       buttonText: "Learn More →",
//       buttonLink: "/storage",
//       sectionType: "solution",
//       icon: "🔋",
//     },
//     {
//       id: 4,
//       title: "Expert Solar Installation",
//       subtitle: "Professional installation with precision and care",
//       description:
//         "Our certified technicians provide professional solar panel installation with precision and care. We ensure optimal positioning for maximum energy generation and long-term reliability.",
//       image: "/images/installation-section.jpg",
//       imagePreview: "",
//       buttonText: "Get Quote →",
//       buttonLink: "/installation",
//       sectionType: "service",
//       features: [
//         "Certified technicians",
//         "Optimal positioning",
//         "Quality materials",
//         "Quick installation",
//       ],
//     },
//   ]);

//   const [newSection, setNewSection] = useState({
//     title: "",
//     subtitle: "",
//     description: "",
//     image: null,
//     imagePreview: "",
//     buttonText: "Learn More",
//     buttonLink: "#",
//     sectionType: "hero",
//     icon: "☀️",
//     features: ["", "", "", ""],
//   });

//   // Contact Form Submissions state
//   const [contactSubmissions, setContactSubmissions] = useState([]);
//   const [isLoadingContacts, setIsLoadingContacts] = useState(false);
//   const [contactStats, setContactStats] = useState({
//     total: 0,
//     new: 0,
//     read: 0,
//     replied: 0,
//   });

//   // Career Jobs state
//   const [careerJobs, setCareerJobs] = useState([]);
//   const [isLoadingJobs, setIsLoadingJobs] = useState(false);
//   const [jobStats, setJobStats] = useState({
//     total: 0,
//     active: 0,
//     inactive: 0,
//     byDepartment: [],
//   });

//   const [newJob, setNewJob] = useState({
//     title: "",
//     location: "",
//     type: "Full-time",
//     experience: "",
//     department: "Installation",
//     description: "",
//     requirements: ["", "", "", ""],
//     responsibilities: ["", "", "", ""],
//     benefits: ["", "", ""],
//     salary: "",
//     isActive: true,
//   });

//   // Industrial Inquiries state
//   const [industrialInquiries, setIndustrialInquiries] = useState([]);
//   const [industrialStats, setIndustrialStats] = useState({
//     total: 0,
//     today: 0,
//     recent: 0,
//     conversionRate: 0,
//     status: {
//       new: 0,
//       contacted: 0,
//       quotation_sent: 0,
//       follow_up: 0,
//       closed_won: 0,
//       closed_lost: 0
//     },
//     priority: {
//       high: 0,
//       medium: 0,
//       low: 0
//     },
//     capacity: {}
//   });
//   const [isLoadingIndustrial, setIsLoadingIndustrial] = useState(false);
//   const [industrialFilter, setIndustrialFilter] = useState('all');
//   const [industrialPriority, setIndustrialPriority] = useState('all');

//   // Consultation Form Data state
//   const [consultationFormData, setConsultationFormData] = useState({
//     formType: "residential",
//     fullName: "",
//     firmName: "",
//     email: "",
//     whatsappNumber: "",
//     monthlyBill: "",
//     pincode: "",
//     city: "",
//     calculatorName: "",
//     calculatorPhone: "",
//     roofArea: "",
//     calculatorMonthlyBill: "",
//     location: "Mumbai",
//     estimatedSavings: ""
//   });

//   // ====== NEWS MANAGEMENT STATE ======
//   const [news, setNews] = useState([]);
//   const [isLoadingNews, setIsLoadingNews] = useState(false);
//   const [newsStats, setNewsStats] = useState({
//     total: 0,
//     active: 0,
//     today: 0
//   });

//   const [newNews, setNewNews] = useState({
//     title: "",
//     headline: "",
//     content: "",
//     summary: "",
//     date: new Date().toISOString().split('T')[0],
//     image: null,
//     imagePreview: "",
//     source: "",
//     sourceLocation: "",
//     author: "",
//     isActive: true
//   });

//   // ====== FREE DEMO STATE ======
//   const [freeDemos, setFreeDemos] = useState([]);
//   const [isLoadingFreeDemos, setIsLoadingFreeDemos] = useState(false);
//   const [freeDemoStats, setFreeDemoStats] = useState({
//     total: 0,
//     pending: 0,
//     confirmed: 0,
//     completed: 0,
//     cancelled: 0,
//     today: 0,
//     byProduct: [],
//     byCity: [],
//     byTime: []
//   });
//   const [freeDemoFilter, setFreeDemoFilter] = useState('all');

//   // ====== HELPER FUNCTIONS ======

//   const calculateDiscountPercentage = (price, originalPrice) => {
//     if (!originalPrice || originalPrice === "" || originalPrice === "0")
//       return "0";
//     try {
//       const priceNum = parseInt(price?.replace(/,/g, "") || "0");
//       const originalPriceNum = parseInt(
//         originalPrice?.replace(/,/g, "") || "0"
//       );
//       if (originalPriceNum === 0) return "0";
//       const discount = ((originalPriceNum - priceNum) / originalPriceNum) * 100;
//       return Math.round(discount).toString();
//     } catch (error) {
//       return "0";
//     }
//   };

//   const calculateDiscountAmount = (price, originalPrice) => {
//     if (!originalPrice || originalPrice === "" || originalPrice === "0")
//       return "0";
//     try {
//       const priceNum = parseInt(price?.replace(/,/g, "") || "0");
//       const originalPriceNum = parseInt(
//         originalPrice?.replace(/,/g, "") || "0"
//       );
//       return (originalPriceNum - priceNum).toLocaleString();
//     } catch (error) {
//       return "0";
//     }
//   };

//   const getStatusColor = (status) => {
//     const colors = {
//       new: '#447793',
//       contacted: '#2D5A74',
//       follow_up: '#123249',
//       quotation_sent: '#447793',
//       closed_won: '#2D5A74',
//       closed_lost: '#061221'
//     };
//     return colors[status] || '#2D5A74';
//   };

//   // ====== AUTH FUNCTIONS ======

//   const handleAdminLogout = () => {
//     logout();
//     navigate('/');
//   };

//   const handleViewWebsite = () => {
//     window.location.href = '/';
//   };

//   // ====== LOGIN ATTEMPTS FUNCTIONS ======

//   const fetchLoginAttempts = async () => {
//     setIsLoadingLoginAttempts(true);
//     try {
//       const response = await axios.get(`${API_BASE}/login-attempts`);
//       if (response.data.success) {
//         setLoginAttempts(response.data.data);
//       } else {
//         console.error('Failed to fetch login attempts:', response.data.error);
//         setLoginAttempts([]);
//       }
//     } catch (error) {
//       console.error('Error fetching login attempts:', error);
//       setLoginAttempts([]);
//     } finally {
//       setIsLoadingLoginAttempts(false);
//     }
//   };

//   const fetchLoginStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/login-attempts/stats`);
//       if (response.data.success) {
//         setLoginStats(response.data.data);
//       } else {
//         console.error('Failed to fetch login stats:', response.data.error);
//       }
//     } catch (error) {
//       console.error('Error fetching login stats:', error);
//     }
//   };

//   const convertToCSV = (data) => {
//     const headers = ['Email', 'Mobile Number', 'Password', 'Status', 'Type', 'IP Address', 'Time', 'Device'];
//     const rows = data.map(attempt => [
//       attempt.email,
//       attempt.phoneNumber || attempt.mobileNumber || 
//       (attempt.email && attempt.email.includes('@') ? 
//         attempt.email.split('@')[0].replace(/[^0-9]/g, '') : 'N/A'),
//       attempt.password,
//       attempt.success ? 'Success' : 'Failed',
//       attempt.isAdmin ? 'Admin' : 'User',
//       attempt.ipAddress || '::1',
//       new Date(attempt.attemptedAt).toLocaleString(),
//       attempt.userAgent || 'Unknown'
//     ]);
    
//     return [headers, ...rows]
//       .map(row => row.map(cell => `"${cell}"`).join(','))
//       .join('\n');
//   };

//   const downloadCSV = (csv, filename) => {
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = filename;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   // ====== CONSULTATION FUNCTIONS ======

//   const fetchConsultations = async () => {
//     setIsLoadingConsultations(true);
//     try {
//       const response = await axios.get(`${API_BASE}/consultations/all`);
//       if (response.data.success) {
//         setConsultations(response.data.data || []);
//       } else {
//         console.error('Failed to fetch consultations:', response.data.error);
//         setConsultations([]);
//       }
//     } catch (error) {
//       console.error('Error fetching consultations:', error);
//       setConsultations([]);
//     } finally {
//       setIsLoadingConsultations(false);
//     }
//   };

//   const fetchConsultationStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/consultations/stats/summary`);
//       if (response.data.success) {
//         setConsultationStats(response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching consultation stats:', error);
//     }
//   };

//   const handleUpdateConsultationStatus = async (id, status) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/consultations/${id}/status`, { status });
//       if (response.data.success) {
//         alert('✅ Consultation status updated successfully!');
//         fetchConsultations();
//         fetchConsultationStats();
//         fetchDashboardStats();
//       } else {
//         alert(`❌ Failed to update status: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error('Error updating consultation status:', error);
//       alert('❌ Failed to update status. Please try again.');
//     }
//   };

//   const handleUpdateConsultationPriority = async (id, priority) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/consultations/${id}/priority`, { priority });
//       if (response.data.success) {
//         alert('✅ Consultation priority updated successfully!');
//         fetchConsultations();
//         fetchConsultationStats();
//       } else {
//         alert(`❌ Failed to update priority: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error('Error updating consultation priority:', error);
//       alert('❌ Failed to update priority. Please try again.');
//     }
//   };

//   const handleAddNoteToConsultation = async (id) => {
//     const note = prompt('Enter your note:');
//     if (note && note.trim()) {
//       try {
//         const response = await axios.patch(`${API_BASE}/consultations/${id}/notes`, { note });
//         if (response.data.success) {
//           alert('✅ Note added successfully!');
//           fetchConsultations();
//         }
//       } catch (error) {
//         console.error('Error adding note:', error);
//         alert('❌ Failed to add note. Please try again.');
//       }
//     }
//   };

//   const handleDeleteConsultation = async (id) => {
//     if (window.confirm('Are you sure you want to delete this consultation?')) {
//       try {
//         const response = await axios.delete(`${API_BASE}/consultations/${id}`);
//         if (response.data.success) {
//           alert('✅ Consultation deleted successfully!');
//           fetchConsultations();
//           fetchConsultationStats();
//           fetchDashboardStats();
//         } else {
//           alert(`❌ Failed to delete: ${response.data.error}`);
//         }
//       } catch (error) {
//         console.error('Error deleting consultation:', error);
//         alert('❌ Failed to delete consultation. Please try again.');
//       }
//     }
//   };

//   // ====== DASHBOARD FUNCTIONS ======

//   const fetchDashboardStats = async () => {
//     try {
//       setIsLoading(true);
      
//       // Fetch products count
//       const productsResponse = await axios.get(`${API_BASE}/products`);
//       const totalProducts = productsResponse.data.success ? productsResponse.data.data.length : 0;

//       // Fetch contact inquiries count
//       const contactsResponse = await axios.get(`${API_BASE}/contacts`);
//       const totalContacts = contactsResponse.data.success ? contactsResponse.data.data.length : 0;

//       // Fetch industrial inquiries count
//       const industrialResponse = await axios.get(`${API_BASE}/industrial`);
//       const totalIndustrial = industrialResponse.data.success ? industrialResponse.data.data.length : 0;

//       // Fetch consultations count
//       const consultationsResponse = await axios.get(`${API_BASE}/consultations/all`);
//       const totalConsultations = consultationsResponse.data.success ? consultationsResponse.data.data.length : 0;

//       // Fetch login attempts stats
//       const loginStatsResponse = await axios.get(`${API_BASE}/login-attempts/stats`);
//       const loginStatsData = loginStatsResponse.data.success ? loginStatsResponse.data.data : { total: 0, today: 0 };

//       // Fetch news stats
//       const newsStatsResponse = await axios.get(`${API_BASE}/news/stats/summary`);
//       const totalNews = newsStatsResponse.data.success ? newsStatsResponse.data.data.total : 0;

//       // Fetch free demo stats
//       const freeDemoStatsResponse = await axios.get(`${API_BASE}/free-demo/stats/summary`);
//       const totalFreeDemos = freeDemoStatsResponse.data.success ? freeDemoStatsResponse.data.data.total : 0;

//       // Calculate total inquiries
//       const totalInquiries = totalContacts + totalIndustrial + totalConsultations;

//       // Calculate monthly sales
//       const monthlySales = totalProducts * 50000;
      
//       // Calculate conversion rate
//       const conversionRate = 15;

//       // Calculate revenue
//       const revenue = monthlySales;

//       // Set dashboard stats
//       setDashboardStats({
//         totalProducts: totalProducts,
//         totalCategories: categories.length - 1,
//         totalInquiries: totalInquiries,
//         monthlySales: `₹${(monthlySales / 100000).toFixed(1)}L`,
//         pendingQuotes: 5,
//         conversionRate: `${conversionRate}%`,
//         visitors: Math.floor(Math.random() * 500) + 800,
//         revenue: `₹${(revenue / 100000).toFixed(1)}L`,
//         industrial: totalIndustrial,
//         totalConsultations: totalConsultations,
//         loginAttempts: loginStatsData.total,
//         todayLoginAttempts: loginStatsData.today,
//         totalNews: totalNews,
//         totalFreeDemos: totalFreeDemos
//       });

//     } catch (error) {
//       console.error("Error fetching dashboard stats:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ====== PRODUCT FUNCTIONS ======

//   const fetchProducts = async () => {
//     setIsLoadingProducts(true);
//     try {
//       const response = await axios.get(`${API_BASE}/products`);
//       if (response.data.success) {
//         setProducts(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     } finally {
//       setIsLoadingProducts(false);
//     }
//   };

//   const fetchProductStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/products/stats/summary`);
//       if (response.data.success) {
//         setProductStats(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching product stats:", error);
//     }
//   };

//   const handleProductInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name.startsWith("spec_")) {
//       const specName = name.replace("spec_", "");
//       setNewProduct((prev) => ({
//         ...prev,
//         specifications: {
//           ...prev.specifications,
//           [specName]: value,
//         },
//       }));
//     } else {
//       setNewProduct((prev) => ({
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
//   };

//   const handleFeatureChange = (index, value) => {
//     const newFeatures = [...newProduct.features];
//     newFeatures[index] = value;
//     setNewProduct((prev) => ({
//       ...prev,
//       features: newFeatures,
//     }));
//   };

//   const handleFileUpload = (e, fileType) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (fileType === "image") {
//       const fileSizeInKB = file.size / 1024;
      
//       if (fileSizeInKB < 400) {
//         alert('❌ Image size is too small. Please upload an image between 400KB and 600KB.');
//         e.target.value = '';
//         return;
//       }
      
//       if (fileSizeInKB > 600) {
//         alert('❌ Image size is too large. Please upload an image between 400KB and 600KB.');
//         e.target.value = '';
//         return;
//       }
//     }

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       if (fileType === "image") {
//         setNewProduct((prev) => ({
//           ...prev,
//           image: file,
//           imagePreview: reader.result,
//         }));
//       } else if (fileType === "pdf") {
//         setNewProduct((prev) => ({
//           ...prev,
//           pdfFile: file,
//           pdfPreview: reader.result,
//         }));
//       }
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleAddProduct = async (e) => {
//     e.preventDefault();

//     try {
//       const formData = new FormData();

//       formData.append("name", newProduct.name);
//       formData.append("category", newProduct.category);
//       formData.append("price", newProduct.price);
//       formData.append(
//         "originalPrice",
//         newProduct.originalPrice || newProduct.price
//       );
//       formData.append("description", newProduct.description);
//       formData.append(
//         "fullDescription",
//         newProduct.fullDescription || newProduct.description
//       );
//       formData.append("rating", newProduct.rating);
//       formData.append("reviews", newProduct.reviews);
//       formData.append("stock", newProduct.stock);
//       formData.append("isFeatured", newProduct.isFeatured);
//       formData.append("isBestSeller", newProduct.isBestSeller);
//       formData.append("isActive", newProduct.isActive);

//       const filteredFeatures = newProduct.features.filter(
//         (f) => f.trim() !== ""
//       );
//       filteredFeatures.forEach((feature) => {
//         formData.append("features", feature);
//       });

//       const validSpecs = {};
//       Object.entries(newProduct.specifications).forEach(([key, value]) => {
//         if (value && value.trim() !== "") {
//           validSpecs[key] = value;
//         }
//       });
//       formData.append("specifications", JSON.stringify(validSpecs));

//       if (newProduct.tags) {
//         const tagsArray = newProduct.tags
//           .split(",")
//           .filter((t) => t.trim() !== "");
//         tagsArray.forEach((tag) => {
//           formData.append("tags", tag.trim());
//         });
//       }

//       if (newProduct.image) {
//         formData.append("image", newProduct.image);
//       }
//       if (newProduct.pdfFile) {
//         formData.append("pdf", newProduct.pdfFile);
//       }

//       const response = await axios.post(`${API_BASE}/products`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response.data.success) {
//         alert("✅ Product added successfully!");
//         fetchProducts();
//         fetchProductStats();
//         fetchDashboardStats();

//         setNewProduct({
//           name: "",
//           category: "Solar Panels",
//           price: "",
//           originalPrice: "",
//           description: "",
//           fullDescription: "",
//           rating: "4.5",
//           reviews: "0",
//           stock: "100",
//           features: ["", "", "", ""],
//           specifications: {
//             power: "",
//             efficiency: "",
//             warranty: "",
//             dimensions: "",
//             weight: "",
//           },
//           tags: "",
//           isFeatured: false,
//           isBestSeller: false,
//           isActive: true,
//           image: null,
//           imagePreview: "",
//           pdfFile: null,
//           pdfPreview: "",
//         });
//       } else {
//         alert(`❌ Error: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error("❌ Error adding product:", error);
//       alert("❌ Failed to add product. Please try again.");
//     }
//   };

//   const handleEditProduct = async (id) => {
//     const productToEdit = products.find((product) => product._id === id);

//     if (!productToEdit) return;

//     setNewProduct({
//       name: productToEdit.name,
//       category: productToEdit.category,
//       price: productToEdit.price,
//       originalPrice: productToEdit.originalPrice || productToEdit.price,
//       description: productToEdit.description,
//       fullDescription:
//         productToEdit.fullDescription || productToEdit.description,
//       rating: productToEdit.rating,
//       reviews: productToEdit.reviews || 0,
//       stock: productToEdit.stock || 0,
//       features: [...(productToEdit.features || []), "", "", "", ""].slice(0, 4),
//       specifications: productToEdit.specifications || {
//         power: "",
//         efficiency: "",
//         warranty: "",
//         dimensions: "",
//         weight: "",
//       },
//       tags: (productToEdit.tags || []).join(", "),
//       isFeatured: productToEdit.isFeatured || false,
//       isBestSeller: productToEdit.isBestSeller || false,
//       isActive:
//         productToEdit.isActive !== undefined ? productToEdit.isActive : true,
//       image: null,
//       imagePreview: productToEdit.imageUrl || "",
//       pdfFile: null,
//       pdfPreview: productToEdit.pdfUrl || "",
//     });

//     await handleDeleteProduct(id);
//   };

//   const handleDeleteProduct = async (id) => {
//     if (window.confirm("Are you sure you want to delete this product?")) {
//       try {
//         const response = await axios.delete(`${API_BASE}/products/${id}`);
//         if (response.data.success) {
//           fetchProducts();
//           fetchProductStats();
//           fetchDashboardStats();
//         }
//       } catch (error) {
//         console.error("Error deleting product:", error);
//       }
//     }
//   };

//   const handleToggleProductStatus = async (id, currentStatus) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/products/${id}/toggle`);
//       if (response.data.success) {
//         fetchProducts();
//         fetchProductStats();
//         fetchDashboardStats();
//       }
//     } catch (error) {
//       console.error("Error toggling product status:", error);
//     }
//   };

//   // ====== CONTACT FUNCTIONS ======

//   const fetchContacts = async () => {
//     setIsLoadingContacts(true);
//     try {
//       const response = await axios.get(`${API_BASE}/contacts`);
//       if (response.data.success) {
//         setContactSubmissions(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setIsLoadingContacts(false);
//     }
//   };

//   const fetchContactStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/contacts/stats/summary`);
//       if (response.data.success) {
//         setContactStats(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching contact stats:", error);
//     }
//   };

//   const handleUpdateStatus = async (id, status) => {
//     try {
//       const response = await axios.put(`${API_BASE}/contacts/${id}`, {
//         status,
//       });
//       if (response.data.success) {
//         fetchContacts();
//         fetchContactStats();
//         fetchDashboardStats();
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   const handleDeleteSubmission = async (id) => {
//     if (window.confirm("Are you sure you want to delete this submission?")) {
//       try {
//         const response = await axios.delete(`${API_BASE}/contacts/${id}`);
//         if (response.data.success) {
//           fetchContacts();
//           fetchContactStats();
//           fetchDashboardStats();
//         }
//       } catch (error) {
//         console.error("Error deleting submission:", error);
//       }
//     }
//   };

//   // ====== INDUSTRIAL INQUIRIES FUNCTIONS ======

//   const fetchIndustrialInquiries = async () => {
//     setIsLoadingIndustrial(true);
//     try {
//       const response = await axios.get(`${API_BASE}/industrial`);
//       if (response.data.success) {
//         setIndustrialInquiries(response.data.data || []);
//       } else {
//         console.error('Failed to fetch industrial inquiries:', response.data.error);
//         setIndustrialInquiries([]);
//       }
//     } catch (error) {
//       console.error('Error fetching industrial inquiries:', error);
//       setIndustrialInquiries([]);
//     } finally {
//       setIsLoadingIndustrial(false);
//     }
//   };

//   const fetchIndustrialStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/industrial/stats/summary`);
//       if (response.data.success) {
//         setIndustrialStats(response.data.data);
//       } else {
//         console.error('Failed to fetch industrial stats:', response.data.error);
//       }
//     } catch (error) {
//       console.error('Error fetching industrial stats:', error);
//     }
//   };

//   const handleUpdateIndustrialStatus = async (id, status) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/industrial/${id}/status`, { status });
//       if (response.data.success) {
//         alert('✅ Status updated successfully!');
//         fetchIndustrialInquiries();
//         fetchIndustrialStats();
//         fetchDashboardStats();
//       } else {
//         alert(`❌ Failed to update status: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error('Error updating industrial status:', error);
//       alert('❌ Failed to update status. Please try again.');
//     }
//   };

//   const handleAddNoteToIndustrial = async (id) => {
//     const note = prompt('Enter your note:');
//     if (note && note.trim()) {
//       try {
//         const inquiryResponse = await axios.get(`${API_BASE}/industrial/${id}`);
//         if (inquiryResponse.data.success) {
//           const currentInquiry = inquiryResponse.data.data;
//           const currentNotes = currentInquiry.notes || [];
          
//           const updateResponse = await axios.put(`${API_BASE}/industrial/${id}`, { 
//             notes: [...currentNotes, note] 
//           });
          
//           if (updateResponse.data.success) {
//             alert('✅ Note added successfully!');
//             fetchIndustrialInquiries();
//           }
//         }
//       } catch (error) {
//         console.error('Error adding note:', error);
//         alert('❌ Failed to add note. Please try again.');
//       }
//     }
//   };

//   const handleDeleteIndustrialInquiry = async (id) => {
//     if (window.confirm('Are you sure you want to delete this industrial inquiry?')) {
//       try {
//         const response = await axios.delete(`${API_BASE}/industrial/${id}`);
//         if (response.data.success) {
//           alert('✅ Inquiry deleted successfully!');
//           fetchIndustrialInquiries();
//           fetchIndustrialStats();
//           fetchDashboardStats();
//         } else {
//           alert(`❌ Failed to delete: ${response.data.error}`);
//         }
//       } catch (error) {
//         console.error('Error deleting industrial inquiry:', error);
//         alert('❌ Failed to delete inquiry. Please try again.');
//       }
//     }
//   };

//   const handleEditIndustrialInquiry = async (inquiry) => {
//     const newName = prompt('Edit name:', inquiry.name);
//     const newCompany = prompt('Edit company:', inquiry.company);
//     const newEmail = prompt('Edit email:', inquiry.email);
//     const newPhone = prompt('Edit phone:', inquiry.phone);
    
//     if (newName && newCompany && newEmail && newPhone) {
//       try {
//         const response = await axios.put(`${API_BASE}/industrial/${inquiry._id}`, {
//           name: newName,
//           company: newCompany,
//           email: newEmail,
//           phone: newPhone
//         });
        
//         if (response.data.success) {
//           alert('✅ Inquiry updated successfully!');
//           fetchIndustrialInquiries();
//         }
//       } catch (error) {
//         console.error('Error updating inquiry:', error);
//         alert('❌ Failed to update inquiry. Please try again.');
//       }
//     }
//   };

//   // ====== CAREER FUNCTIONS ======

//   const fetchJobs = async () => {
//     setIsLoadingJobs(true);
//     try {
//       const response = await axios.get(`${API_BASE}/jobs`);
//       if (response.data.success) {
//         setCareerJobs(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching jobs:", error);
//     } finally {
//       setIsLoadingJobs(false);
//     }
//   };

//   const fetchJobStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/jobs/stats/summary`);
//       if (response.data.success) {
//         setJobStats(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching job stats:", error);
//     }
//   };

//   const handleJobInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewJob((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleRequirementChange = (index, value) => {
//     const newRequirements = [...newJob.requirements];
//     newRequirements[index] = value;
//     setNewJob((prev) => ({
//       ...prev,
//       requirements: newRequirements,
//     }));
//   };

//   const handleResponsibilityChange = (index, value) => {
//     const newResponsibilities = [...newJob.responsibilities];
//     newResponsibilities[index] = value;
//     setNewJob((prev) => ({
//       ...prev,
//       responsibilities: newResponsibilities,
//     }));
//   };

//   const handleBenefitChange = (index, value) => {
//     const newBenefits = [...newJob.benefits];
//     newBenefits[index] = value;
//     setNewJob((prev) => ({
//       ...prev,
//       benefits: newBenefits,
//     }));
//   };

//   const handleAddJob = async (e) => {
//     e.preventDefault();

//     try {
//       const filteredRequirements = newJob.requirements.filter(
//         (req) => req.trim() !== ""
//       );
//       const filteredResponsibilities = newJob.responsibilities.filter(
//         (resp) => resp.trim() !== ""
//       );
//       const filteredBenefits = newJob.benefits.filter(
//         (benefit) => benefit.trim() !== ""
//       );

//       const jobData = {
//         ...newJob,
//         requirements: filteredRequirements,
//         responsibilities: filteredResponsibilities,
//         benefits: filteredBenefits,
//       };

//       const response = await axios.post(`${API_BASE}/jobs`, jobData);

//       if (response.data.success) {
//         alert("✅ Job added successfully!");
//         fetchJobs();
//         fetchJobStats();

//         setNewJob({
//           title: "",
//           location: "",
//           type: "Full-time",
//           experience: "",
//           department: "Installation",
//           description: "",
//           requirements: ["", "", "", ""],
//           responsibilities: ["", "", "", ""],
//           benefits: ["", "", ""],
//           salary: "",
//           isActive: true,
//         });
//       } else {
//         alert(`❌ Error: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error("❌ Error adding job:", error);
//       alert("❌ Failed to add job. Please try again.");
//     }
//   };

//   const handleEditJob = async (id) => {
//     const jobToEdit = careerJobs.find((job) => job._id === id);

//     if (!jobToEdit) return;

//     setNewJob({
//       title: jobToEdit.title,
//       location: jobToEdit.location,
//       type: jobToEdit.type,
//       experience: jobToEdit.experience,
//       department: jobToEdit.department,
//       description: jobToEdit.description,
//       requirements: [...(jobToEdit.requirements || []), "", "", "", ""].slice(
//         0,
//         4
//       ),
//       responsibilities: [
//         ...(jobToEdit.responsibilities || []),
//         "",
//         "",
//         "",
//         "",
//       ].slice(0, 4),
//       benefits: [...(jobToEdit.benefits || []), "", "", ""].slice(0, 3),
//       salary: jobToEdit.salary || "",
//       isActive: jobToEdit.isActive,
//     });

//     await handleDeleteJob(id);
//   };

//   const handleDeleteJob = async (id) => {
//     if (window.confirm("Are you sure you want to delete this job?")) {
//       try {
//         const response = await axios.delete(`${API_BASE}/jobs/${id}`);
//         if (response.data.success) {
//           fetchJobs();
//           fetchJobStats();
//         }
//       } catch (error) {
//         console.error("Error deleting job:", error);
//       }
//     }
//   };

//   const handleToggleJobStatus = async (id, currentStatus) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/jobs/${id}/toggle`);
//       if (response.data.success) {
//         fetchJobs();
//         fetchJobStats();
//       }
//     } catch (error) {
//       console.error("Error toggling job status:", error);
//     }
//   };

//   // ====== CONSULTATION FORM FUNCTIONS ======

//   const handleConsultationFormChange = (e) => {
//     const { name, value } = e.target;
//     setConsultationFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleConsultationTabChange = (tab) => {
//     setConsultationFormData(prev => ({
//       ...prev,
//       formType: tab
//     }));
//   };

//   const calculateEstimatedSavings = () => {
//     const { roofArea, calculatorMonthlyBill } = consultationFormData;
//     if (!roofArea || !calculatorMonthlyBill) return "0";

//     const baseCost = 1500;
//     const billSavings = parseFloat(calculatorMonthlyBill) * 0.7;
//     const areaCost = parseFloat(roofArea) * baseCost;
//     const totalSavings = areaCost + (billSavings * 12 * 10);
    
//     return totalSavings.toLocaleString('en-IN');
//   };

//   const handleCalculateSavings = () => {
//     const savings = calculateEstimatedSavings();
//     setConsultationFormData(prev => ({
//       ...prev,
//       estimatedSavings: savings
//     }));
//   };

//   const handleConsultationFormSubmit = async (e) => {
//     e.preventDefault();
    
//     try {
//       const consultationData = {
//         formType: consultationFormData.formType,
//         monthlyBill: consultationFormData.monthlyBill,
//         pincode: consultationFormData.pincode,
//         city: consultationFormData.city,
//         source: 'consultation_calculator'
//       };

//       if (consultationFormData.formType === 'residential') {
//         consultationData.name = consultationFormData.fullName;
//         consultationData.whatsappNumber = consultationFormData.whatsappNumber;
//         consultationData.phone = consultationFormData.whatsappNumber;
//       } else {
//         consultationData.firmName = consultationFormData.firmName;
//         consultationData.email = consultationFormData.email;
//         consultationData.name = consultationFormData.firmName;
//       }

//       if (consultationFormData.roofArea) {
//         consultationData.roofArea = consultationFormData.roofArea;
//         consultationData.estimatedSavings = consultationFormData.estimatedSavings;
//         consultationData.location = consultationFormData.location;
//         consultationData.source = 'savings_calculator';
//       }

//       const response = await axios.post(`${API_BASE}/consultations/submit`, consultationData);
      
//       if (response.data.success) {
//         alert('✅ Consultation submitted successfully!');
        
//         setConsultationFormData({
//           formType: "residential",
//           fullName: "",
//           firmName: "",
//           email: "",
//           whatsappNumber: "",
//           monthlyBill: "",
//           pincode: "",
//           city: "",
//           calculatorName: "",
//           calculatorPhone: "",
//           roofArea: "",
//           calculatorMonthlyBill: "",
//           location: "Mumbai",
//           estimatedSavings: ""
//         });
        
//         fetchConsultations();
//         fetchConsultationStats();
//         fetchDashboardStats();
//       }
//     } catch (error) {
//       console.error('Error submitting consultation:', error);
//       alert('❌ Failed to submit consultation. Please try again.');
//     }
//   };

//   // ====== NEWS MANAGEMENT FUNCTIONS ======
//   const fetchNews = async () => {
//     setIsLoadingNews(true);
//     try {
//       const response = await axios.get(`${API_BASE}/news/admin/all`);
//       if (response.data.success) {
//         setNews(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching news:", error);
//     } finally {
//       setIsLoadingNews(false);
//     }
//   };

//   const fetchNewsStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/news/stats/summary`);
//       if (response.data.success) {
//         setNewsStats(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching news stats:", error);
//     }
//   };

//   const handleNewsInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewNews((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleNewsImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const fileSizeInMB = file.size / (1024 * 1024);
//     if (fileSizeInMB > 2) {
//       alert('❌ Image size is too large. Please upload an image less than 2MB.');
//       e.target.value = '';
//       return;
//     }

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setNewNews((prev) => ({
//         ...prev,
//         image: file,
//         imagePreview: reader.result,
//       }));
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleAddNews = async (e) => {
//     e.preventDefault();

//     try {
//       const formData = new FormData();
      
//       const newsData = {
//         title: newNews.title,
//         headline: newNews.headline,
//         content: newNews.content,
//         summary: newNews.summary,
//         date: newNews.date,
//         source: newNews.source,
//         sourceLocation: newNews.sourceLocation,
//         author: newNews.author,
//         isActive: newNews.isActive
//       };

//       formData.append('data', JSON.stringify(newsData));
      
//       if (newNews.image) {
//         formData.append('image', newNews.image);
//       }

//       const response = await axios.post(`${API_BASE}/news`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.data.success) {
//         alert("✅ News article added successfully!");
//         fetchNews();
//         fetchNewsStats();
//         fetchDashboardStats();

//         setNewNews({
//           title: "",
//           headline: "",
//           content: "",
//           summary: "",
//           date: new Date().toISOString().split('T')[0],
//           image: null,
//           imagePreview: "",
//           source: "",
//           sourceLocation: "",
//           author: "",
//           isActive: true
//         });
//       } else {
//         alert(`❌ Error: ${response.data.error}`);
//       }
//     } catch (error) {
//       console.error("❌ Error adding news:", error);
//       alert("❌ Failed to add news article. Please try again.");
//     }
//   };

//   const handleEditNews = async (id) => {
//     const newsToEdit = news.find((item) => item._id === id);

//     if (!newsToEdit) return;

//     setNewNews({
//       title: newsToEdit.title,
//       headline: newsToEdit.headline || "",
//       content: newsToEdit.content,
//       summary: newsToEdit.summary,
//       date: new Date(newsToEdit.date).toISOString().split('T')[0],
//       image: null,
//       imagePreview: newsToEdit.imageUrl || newsToEdit.image || "",
//       source: newsToEdit.source || "",
//       sourceLocation: newsToEdit.sourceLocation || "",
//       author: newsToEdit.author || "",
//       isActive: newsToEdit.isActive
//     });

//     await handleDeleteNews(id);
//   };

//   const handleDeleteNews = async (id) => {
//     if (window.confirm("Are you sure you want to delete this news article?")) {
//       try {
//         const response = await axios.delete(`${API_BASE}/news/${id}`);
//         if (response.data.success) {
//           alert("✅ News article deleted successfully!");
//           fetchNews();
//           fetchNewsStats();
//           fetchDashboardStats();
//         }
//       } catch (error) {
//         console.error("Error deleting news:", error);
//         alert("❌ Failed to delete news article.");
//       }
//     }
//   };

//   const handleToggleNewsStatus = async (id, currentStatus) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/news/${id}/toggle`);
//       if (response.data.success) {
//         fetchNews();
//         fetchNewsStats();
//       }
//     } catch (error) {
//       console.error("Error toggling news status:", error);
//     }
//   };

//   // ====== FREE DEMO FUNCTIONS ======
//   const fetchFreeDemos = async () => {
//     setIsLoadingFreeDemos(true);
//     try {
//       const response = await axios.get(`${API_BASE}/free-demo`);
//       if (response.data.success) {
//         setFreeDemos(response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching free demos:', error);
//     } finally {
//       setIsLoadingFreeDemos(false);
//     }
//   };

//   const fetchFreeDemoStats = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/free-demo/stats/summary`);
//       if (response.data.success) {
//         setFreeDemoStats(response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching free demo stats:', error);
//     }
//   };

//   const handleUpdateDemoStatus = async (id, status) => {
//     try {
//       const response = await axios.patch(`${API_BASE}/free-demo/${id}/status`, { status });
//       if (response.data.success) {
//         alert('✅ Demo status updated successfully!');
//         fetchFreeDemos();
//         fetchFreeDemoStats();
//         fetchDashboardStats();
//       }
//     } catch (error) {
//       console.error('Error updating demo status:', error);
//       alert('❌ Failed to update status');
//     }
//   };

//   const handleAddDemoNote = async (id) => {
//     const note = prompt('Enter note for this demo request:');
//     if (note && note.trim()) {
//       try {
//         const response = await axios.patch(`${API_BASE}/free-demo/${id}/notes`, { 
//           note,
//           addedBy: user?.email || 'Admin'
//         });
//         if (response.data.success) {
//           alert('✅ Note added successfully!');
//           fetchFreeDemos();
//         }
//       } catch (error) {
//         console.error('Error adding note:', error);
//         alert('❌ Failed to add note');
//       }
//     }
//   };

//   const handleDeleteDemo = async (id) => {
//     if (window.confirm('Are you sure you want to delete this demo request?')) {
//       try {
//         const response = await axios.delete(`${API_BASE}/free-demo/${id}`);
//         if (response.data.success) {
//           alert('✅ Demo request deleted successfully!');
//           fetchFreeDemos();
//           fetchFreeDemoStats();
//           fetchDashboardStats();
//         }
//       } catch (error) {
//         console.error('Error deleting demo:', error);
//         alert('❌ Failed to delete demo request');
//       }
//     }
//   };

//   // ====== INITIAL DATA LOADING ======

//   useEffect(() => {
//     if (!user || !isAdmin) {
//       navigate('/');
//       return;
//     }

//     const sampleSlides = [
//       {
//         id: 1,
//         title: "Smart Solar Inverters",
//         subtitle:
//           "Hybrid inverters with WiFi monitoring. Seamless grid-tie functionality.",
//         buttonText: "Explore",
//         buttonLink: "/products/inverters",
//         image: "/images/slide1.jpg",
//       },
//       {
//         id: 2,
//         title: "Featured Solar Products",
//         subtitle: "Discover our premium solar solutions",
//         buttonText: "Shop Now",
//         buttonLink: "/products",
//         image: "/images/slide2.jpg",
//       },
//     ];

//     const sampleBestSellers = [
//       {
//         id: 1,
//         title: "Solar Battery 150Ah",
//         originalPrice: "19,000",
//         currentPrice: "16,500",
//         saveAmount: "2,500",
//         rating: "4.8",
//         reviews: "156",
//         buttonText: "Enquire Now",
//         buttonLink: "/product/battery-150ah",
//         image: "/images/bestseller1.jpg",
//         pdfFile: "/pdfs/battery-specs.pdf",
//         isActive: true,
//       },
//       {
//         id: 2,
//         title: "Solar Home Kit 3kW",
//         originalPrice: "225,000",
//         currentPrice: "185,000",
//         saveAmount: "40,000",
//         rating: "4.9",
//         reviews: "203",
//         buttonText: "Enquire Now",
//         buttonLink: "/product/home-kit-3kw",
//         image: "/images/bestseller2.jpg",
//         pdfFile: "/pdfs/kit-specs.pdf",
//         isActive: true,
//       },
//     ];

//     setSlides(sampleSlides);
//     setBestSellers(sampleBestSellers);

//     fetchDashboardStats();
//     fetchConsultations();
//     fetchConsultationStats();
//     fetchProducts();
//     fetchProductStats();
//     fetchContacts();
//     fetchContactStats();
//     fetchJobs();
//     fetchJobStats();
//     fetchIndustrialInquiries();
//     fetchIndustrialStats();
//     fetchLoginAttempts();
//     fetchLoginStats();
//     fetchNews();
//     fetchNewsStats();
//     fetchFreeDemos();
//     fetchFreeDemoStats();
//   }, [user, isAdmin, navigate]);

//   useEffect(() => {
//     if (activeTab === "industrial") {
//       fetchIndustrialInquiries();
//     }
//     if (activeTab === "news") {
//       fetchNews();
//       fetchNewsStats();
//     }
//     if (activeTab === "freeDemos") {
//       fetchFreeDemos();
//       fetchFreeDemoStats();
//     }
//   }, [industrialFilter, industrialPriority, activeTab]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
//         setShowProfileDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleSlideInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewSlide((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleAddSlide = (e) => {
//     e.preventDefault();
//     const slideWithId = {
//       ...newSlide,
//       id: slides.length + 1,
//       image: newSlide.image
//         ? `/uploads/slides/${newSlide.image.name}`
//         : "/images/default-slide.jpg",
//     };
//     setSlides([...slides, slideWithId]);
//     setNewSlide({
//       title: "",
//       subtitle: "",
//       buttonText: "Explore",
//       buttonLink: "#",
//       image: null,
//       imagePreview: "",
//     });
//   };

//   const handleDeleteSlide = (id) => {
//     setSlides(slides.filter((slide) => slide.id !== id));
//   };

//   const handleBestSellerInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewBestSeller((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleAddBestSeller = (e) => {
//     e.preventDefault();
//     const bestSellerWithId = {
//       ...newBestSeller,
//       id: bestSellers.length + 1,
//       image: newBestSeller.image
//         ? `/uploads/bestsellers/${newBestSeller.image.name}`
//         : "/images/default-bestseller.jpg",
//       pdfFile: newBestSeller.pdfFile
//         ? `/uploads/pdfs/${newBestSeller.pdfFile.name}`
//         : null,
//     };
//     setBestSellers([...bestSellers, bestSellerWithId]);
//     setNewBestSeller({
//       title: "",
//       originalPrice: "",
//       currentPrice: "",
//       saveAmount: "",
//       rating: "4.5",
//       reviews: "0",
//       buttonText: "Enquire Now",
//       buttonLink: "#",
//       image: null,
//       imagePreview: "",
//       pdfFile: null,
//       pdfPreview: "",
//       isActive: true,
//     });
//   };

//   const handleDeleteBestSeller = (id) => {
//     setBestSellers(bestSellers.filter((item) => item.id !== id));
//   };

//   const handleCategoryInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewCategory((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleAddCategory = (e) => {
//     e.preventDefault();
//     if (newCategory.name.trim() !== "") {
//       setCategories([...categories, newCategory.name]);
//       setNewCategory({
//         name: "",
//         icon: "📦",
//       });
//       fetchDashboardStats();
//     }
//   };

//   const handleDeleteCategory = (index) => {
//     if (index > 0) {
//       setCategories(categories.filter((_, i) => i !== index));
//       fetchDashboardStats();
//     }
//   };

//   const handleSectionInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewSection((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleFeatureChangeSection = (index, value) => {
//     const newFeatures = [...newSection.features];
//     newFeatures[index] = value;
//     setNewSection((prev) => ({
//       ...prev,
//       features: newFeatures,
//     }));
//   };

//   const handleAddSection = (e) => {
//     e.preventDefault();
//     const sectionWithId = {
//       ...newSection,
//       id: mainPageSections.length + 1,
//       image: newSection.image
//         ? `/uploads/sections/${newSection.image.name}`
//         : "/images/default-section.jpg",
//       features: newSection.features.filter((f) => f.trim() !== ""),
//     };
//     setMainPageSections([...mainPageSections, sectionWithId]);
//     setNewSection({
//       title: "",
//       subtitle: "",
//       description: "",
//       image: null,
//       imagePreview: "",
//       buttonText: "Learn More",
//       buttonLink: "#",
//       sectionType: "hero",
//       icon: "☀️",
//       features: ["", "", "", ""],
//     });
//   };

//   const handleEditSection = (id) => {
//     const sectionToEdit = mainPageSections.find((section) => section.id === id);
//     setNewSection({
//       title: sectionToEdit.title,
//       subtitle: sectionToEdit.subtitle,
//       description: sectionToEdit.description,
//       image: null,
//       imagePreview: sectionToEdit.image,
//       buttonText: sectionToEdit.buttonText,
//       buttonLink: sectionToEdit.buttonLink,
//       sectionType: sectionToEdit.sectionType,
//       icon: sectionToEdit.icon || "☀️",
//       features: sectionToEdit.features || ["", "", "", ""],
//     });

//     handleDeleteSection(id);
//   };

//   const handleDeleteSection = (id) => {
//     setMainPageSections(
//       mainPageSections.filter((section) => section.id !== id)
//     );
//   };

//   // CSS Styles - BLUE THEME
//   const styles = {
//     adminDashboard: {
//       display: "flex",
//       minHeight: "100vh",
//       backgroundColor: "#f5f7fa",
//       fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       position: "relative",
//     },
//     adminSidebar: {
//       width: "280px",
//       backgroundColor: "#123249",
//       color: "white",
//       display: "flex",
//       flexDirection: "column",
//       position: "fixed",
//       top: 0,
//       left: 0,
//       height: "100vh",
//       zIndex: 1000,
//       transform: showSidebar ? "translateX(0)" : "translateX(-100%)",
//       transition: "transform 0.3s ease-in-out",
//     },
//     sidebarHeader: {
//       padding: "25px 20px",
//       borderBottom: "1px solid rgba(255,255,255,0.1)",
//     },
//     logo: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       marginBottom: "20px",
//     },
//     adminBadge: {
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "3px 8px",
//       borderRadius: "4px",
//       fontSize: "0.7rem",
//       fontWeight: "bold",
//     },
//     adminInfo: {
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//     },
//     adminAvatar: {
//       width: "45px",
//       height: "45px",
//       backgroundColor: "rgba(255,255,255,0.2)",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "1.2rem",
//     },
//     adminDetails: {
//       display: "flex",
//       flexDirection: "column",
//     },
//     sidebarNav: {
//       flex: 1,
//       padding: "20px 0",
//       overflowY: "auto",
//     },
//     navSection: {
//       marginBottom: "25px",
//     },
//     sectionTitle: {
//       fontSize: "0.8rem",
//       textTransform: "uppercase",
//       color: "rgba(255,255,255,0.6)",
//       padding: "0 20px 10px",
//       marginBottom: "10px",
//       borderBottom: "1px solid rgba(255,255,255,0.1)",
//     },
//     navBtn: {
//       width: "100%",
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       padding: "12px 20px",
//       backgroundColor: "transparent",
//       border: "none",
//       color: "rgba(255,255,255,0.8)",
//       cursor: "pointer",
//       fontSize: "0.95rem",
//       textAlign: "left",
//       transition: "all 0.3s",
//     },
//     navBtnActive: {
//       backgroundColor: "rgba(68,119,147,0.2)",
//       color: "white",
//       borderLeft: "3px solid #447793",
//     },
//     navIcon: {
//       fontSize: "1.2rem",
//     },
//     logoutBtn: {
//       color: "#DDE8ED",
//     },
//     sidebarFooter: {
//       padding: "20px",
//       borderTop: "1px solid rgba(255,255,255,0.1)",
//     },
//     websiteStats: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "10px",
//     },
//     statItem: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     statLabel: {
//       fontSize: "0.8rem",
//       color: "rgba(255,255,255,0.6)",
//     },
//     statValue: {
//       fontSize: "0.9rem",
//       fontWeight: "bold",
//       color: "white",
//     },
//     closeSidebarBtn: {
//       position: "absolute",
//       top: "20px",
//       right: "20px",
//       backgroundColor: "transparent",
//       border: "none",
//       color: "white",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       display: "block",
//     },
//     adminMain: {
//       flex: 1,
//       overflowY: "auto",
//       marginLeft: "0",
//       width: "100%",
//     },
//     adminHeader: {
//       backgroundColor: "white",
//       padding: "20px 30px",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       boxShadow: "0 2px 10px rgba(6,18,33,0.08)",
//       position: "sticky",
//       top: 0,
//       zIndex: 100,
//     },
//     headerLeft: {
//       flex: 1,
//       display: "flex",
//       alignItems: "center",
//       gap: "20px",
//     },
//     headerRight: {
//       display: "flex",
//       alignItems: "center",
//       gap: "20px",
//     },
//     searchBox: {
//       display: "flex",
//       alignItems: "center",
//       backgroundColor: "#f5f7fa",
//       borderRadius: "25px",
//       padding: "8px 15px",
//       width: "300px",
//     },
//     searchInput: {
//       border: "none",
//       backgroundColor: "transparent",
//       outline: "none",
//       flex: 1,
//       padding: "5px",
//     },
//     searchBtn: {
//       backgroundColor: "transparent",
//       border: "none",
//       color: "#2D5A74",
//       cursor: "pointer",
//     },
//     headerActions: {
//       display: "flex",
//       alignItems: "center",
//       gap: "15px",
//     },
//     headerBtn: {
//       backgroundColor: "transparent",
//       border: "none",
//       cursor: "pointer",
//       position: "relative",
//     },
//     notificationBadge: {
//       position: "absolute",
//       top: "-5px",
//       right: "-5px",
//       backgroundColor: "#447793",
//       color: "white",
//       borderRadius: "50%",
//       width: "18px",
//       height: "18px",
//       fontSize: "0.7rem",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//     },
//     profileContainer: {
//       position: "relative",
//     },
//     profileBtn: {
//       width: "40px",
//       height: "40px",
//       backgroundColor: "#447793",
//       color: "white",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontWeight: "bold",
//       border: "none",
//       cursor: "pointer",
//     },
//     profileDropdown: {
//       position: "absolute",
//       top: "50px",
//       right: "0",
//       backgroundColor: "white",
//       borderRadius: "8px",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.1)",
//       width: "200px",
//       zIndex: 1000,
//       overflow: "hidden",
//     },
//     profileDropdownItem: {
//       padding: "12px 20px",
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//       color: "#123249",
//       textDecoration: "none",
//       borderBottom: "1px solid #DDE8ED",
//       backgroundColor: "white",
//       border: "none",
//       width: "100%",
//       textAlign: "left",
//       cursor: "pointer",
//       transition: "background-color 0.3s",
//     },
//     profileDropdownItemHover: {
//       backgroundColor: "#DDE8ED",
//     },
//     menuToggleBtn: {
//       backgroundColor: "transparent",
//       border: "none",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       color: "#123249",
//       padding: "5px",
//       borderRadius: "5px",
//       display: "block",
//     },
//     adminContent: {
//       padding: "30px",
//     },
//     dashboardWelcome: {
//       backgroundColor: "white",
//       borderRadius: "15px",
//       padding: "30px",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
//     },
//     welcomeHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       marginBottom: "30px",
//     },
//     dateDisplay: {
//       color: "#2D5A74",
//       fontSize: "0.9rem",
//     },
//     statsCards: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//       gap: "20px",
//       marginBottom: "40px",
//     },
//     statCard: {
//       backgroundColor: "#f8fafc",
//       borderRadius: "12px",
//       padding: "25px",
//       display: "flex",
//       alignItems: "center",
//       gap: "20px",
//       transition: "all 0.3s",
//       cursor: "pointer",
//     },
//     statIcon: {
//       fontSize: "2.5rem",
//       width: "70px",
//       height: "70px",
//       backgroundColor: "white",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.1)",
//     },
//     statInfo: {
//       flex: 1,
//     },
//     statNumber: {
//       fontSize: "1.8rem",
//       fontWeight: "bold",
//       margin: "5px 0",
//       color: "#123249",
//     },
//     statChange: {
//       fontSize: "0.85rem",
//     },
//     positive: {
//       color: "#2D5A74",
//     },
//     negative: {
//       color: "#061221",
//     },
//     quickActions: {
//       marginTop: "40px",
//     },
//     actionButtons: {
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "15px",
//       marginTop: "20px",
//     },
//     actionBtn: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "15px 25px",
//       borderRadius: "10px",
//       cursor: "pointer",
//       fontSize: "0.95rem",
//       transition: "all 0.3s",
//     },
//     actionIcon: {
//       fontSize: "1.2rem",
//     },
//     pageHeader: {
//       backgroundColor: "white",
//       borderRadius: "15px",
//       padding: "25px 30px",
//       marginBottom: "30px",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
//     },
//     managementGrid: {
//       display: "grid",
//       gridTemplateColumns: "1fr",
//       gap: "30px",
//     },
//     addProductForm: {
//       backgroundColor: "white",
//       borderRadius: "15px",
//       padding: "25px",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
//     },
//     productsListSection: {
//       backgroundColor: "white",
//       borderRadius: "15px",
//       padding: "25px",
//       boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
//       maxHeight: "800px",
//       overflowY: "auto",
//     },
//     formGroup: {
//       marginBottom: "20px",
//     },
//     formRow: {
//       display: "grid",
//       gridTemplateColumns: "1fr",
//       gap: "15px",
//       marginBottom: "20px",
//     },
//     label: {
//       display: "block",
//       marginBottom: "8px",
//       fontWeight: "600",
//       color: "#123249",
//     },
//     input: {
//       width: "100%",
//       padding: "12px 15px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "8px",
//       fontSize: "0.95rem",
//       outline: "none",
//       transition: "border-color 0.3s",
//     },
//     inputFocus: {
//       borderColor: "#447793",
//     },
//     textarea: {
//       width: "100%",
//       padding: "12px 15px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "8px",
//       fontSize: "0.95rem",
//       outline: "none",
//       resize: "vertical",
//       minHeight: "100px",
//       transition: "border-color 0.3s",
//     },
//     select: {
//       width: "100%",
//       padding: "12px 15px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "8px",
//       fontSize: "0.95rem",
//       outline: "none",
//       backgroundColor: "white",
//       transition: "border-color 0.3s",
//     },
//     featureInput: {
//       width: "100%",
//       padding: "10px 15px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "8px",
//       fontSize: "0.9rem",
//       marginBottom: "10px",
//       outline: "none",
//       transition: "border-color 0.3s",
//     },
//     fileUpload: {
//       border: "2px dashed #DDE8ED",
//       borderRadius: "8px",
//       padding: "20px",
//       textAlign: "center",
//       cursor: "pointer",
//       transition: "all 0.3s",
//     },
//     uploadPreview: {
//       marginTop: "15px",
//       minHeight: "150px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       backgroundColor: "#f8fafc",
//       borderRadius: "8px",
//       overflow: "hidden",
//     },
//     uploadPlaceholder: {
//       textAlign: "center",
//       color: "#2D5A74",
//     },
//     formCheckboxes: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "15px",
//       margin: "20px 0",
//     },
//     formCheckbox: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },
//     addBtn: {
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "15px 30px",
//       borderRadius: "8px",
//       fontSize: "1rem",
//       fontWeight: "600",
//       cursor: "pointer",
//       width: "100%",
//       transition: "all 0.3s",
//     },
//     addBtnHover: {
//       backgroundColor: "#2D5A74",
//       transform: "translateY(-2px)",
//     },
//     listHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       marginBottom: "25px",
//       paddingBottom: "15px",
//       borderBottom: "1px solid #DDE8ED",
//     },
//     listControls: {
//       display: "flex",
//       gap: "15px",
//       alignItems: "center",
//     },
//     refreshBtn: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       border: "1px solid #447793",
//       padding: "8px 15px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.9rem",
//       transition: "all 0.3s",
//     },
//     productsList: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "15px",
//     },
//     productItem: {
//       backgroundColor: "#f8fafc",
//       borderRadius: "10px",
//       padding: "20px",
//       border: "1px solid #DDE8ED",
//       transition: "all 0.3s",
//     },
//     productHeader: {
//       display: "flex",
//       gap: "20px",
//       marginBottom: "15px",
//     },
//     productImage: {
//       width: "80px",
//       height: "80px",
//       backgroundColor: "#DDE8ED",
//       borderRadius: "8px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "1.5rem",
//       color: "#123249",
//       flexShrink: 0,
//     },
//     productInfo: {
//       flex: 1,
//     },
//     productMeta: {
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "10px",
//       marginTop: "8px",
//       fontSize: "0.85rem",
//     },
//     productCategory: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "3px 10px",
//       borderRadius: "12px",
//     },
//     productPrice: {
//       fontWeight: "bold",
//       color: "#447793",
//     },
//     productDiscount: {
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "3px 10px",
//       borderRadius: "12px",
//       fontSize: "0.8rem",
//     },
//     productTags: {
//       display: "flex",
//       gap: "8px",
//       marginTop: "10px",
//     },
//     tagFeatured: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "3px 8px",
//       borderRadius: "4px",
//       fontSize: "0.75rem",
//     },
//     tagBestseller: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//       padding: "3px 8px",
//       borderRadius: "4px",
//       fontSize: "0.75rem",
//     },
//     tagLowstock: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "3px 8px",
//       borderRadius: "4px",
//       fontSize: "0.75rem",
//     },
//     productDescription: {
//       color: "#2D5A74",
//       fontSize: "0.9rem",
//       marginBottom: "15px",
//       lineHeight: 1.5,
//     },
//     productDetails: {
//       backgroundColor: "white",
//       borderRadius: "8px",
//       padding: "15px",
//       marginBottom: "15px",
//       border: "1px solid #DDE8ED",
//     },
//     productSpecs: {
//       display: "grid",
//       gridTemplateColumns: "1fr",
//       gap: "10px",
//       fontSize: "0.85rem",
//       color: "#2D5A74",
//     },
//     productActions: {
//       display: "flex",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     btnEdit: {
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "8px 15px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.85rem",
//       transition: "all 0.3s",
//     },
//     btnDelete: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//       border: "none",
//       padding: "8px 15px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.85rem",
//       transition: "all 0.3s",
//     },
//     btnToggle: {
//       backgroundColor: "#123249",
//       color: "white",
//       border: "none",
//       padding: "8px 15px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.85rem",
//       transition: "all 0.3s",
//     },
//     btnPdf: {
//       backgroundColor: "#061221",
//       color: "white",
//       border: "none",
//       padding: "8px 15px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.85rem",
//       textDecoration: "none",
//       display: "inline-block",
//       transition: "all 0.3s",
//     },
//     loadingState: {
//       textAlign: "center",
//       padding: "40px",
//       color: "#2D5A74",
//     },
//     submissionsStats: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//       gap: "20px",
//       marginBottom: "30px",
//     },
//     submissionsList: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "15px",
//     },
//     submissionItem: {
//       backgroundColor: "white",
//       borderRadius: "10px",
//       padding: "20px",
//       border: "1px solid #DDE8ED",
//       transition: "all 0.3s",
//     },
//     submissionHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "flex-start",
//       marginBottom: "15px",
//     },
//     submissionInfo: {
//       flex: 1,
//     },
//     submissionMeta: {
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "15px",
//       marginTop: "8px",
//       fontSize: "0.85rem",
//       color: "#2D5A74",
//     },
//     submissionStatus: {
//       display: "flex",
//       alignItems: "center",
//     },
//     statusBadge: {
//       padding: "5px 12px",
//       borderRadius: "20px",
//       fontSize: "0.8rem",
//       fontWeight: "500",
//     },
//     statusNew: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//     },
//     statusRead: {
//       backgroundColor: "#447793",
//       color: "white",
//     },
//     statusReplied: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//     },
//     statusSuccess: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.75rem",
//       fontWeight: "500",
//     },
//     statusFailed: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.75rem",
//       fontWeight: "500",
//     },
//     typeAdmin: {
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.75rem",
//       fontWeight: "500",
//     },
//     typeUser: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.75rem",
//       fontWeight: "500",
//     },
//     submissionMessage: {
//       backgroundColor: "#f8fafc",
//       borderRadius: "8px",
//       padding: "15px",
//       marginBottom: "15px",
//       fontSize: "0.9rem",
//       lineHeight: 1.5,
//     },
//     submissionActions: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       flexWrap: "wrap",
//       gap: "10px",
//     },
//     statusActions: {
//       display: "flex",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     btnStatus: {
//       backgroundColor: "#f1f5f9",
//       color: "#2D5A74",
//       border: "1px solid #DDE8ED",
//       padding: "6px 12px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.8rem",
//       transition: "all 0.3s",
//     },
//     btnStatusActive: {
//       backgroundColor: "#447793",
//       color: "white",
//       borderColor: "#447793",
//     },
//     managementActions: {
//       display: "flex",
//       gap: "10px",
//     },
//     btnReply: {
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "6px 12px",
//       borderRadius: "6px",
//       cursor: "pointer",
//       fontSize: "0.8rem",
//       transition: "all 0.3s",
//     },
//     specsGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
//       gap: "15px",
//       marginTop: "10px",
//     },
//     specInput: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "5px",
//     },
//     specInputSpan: {
//       fontSize: "0.85rem",
//       color: "#2D5A74",
//       fontWeight: "500",
//     },
//     consultationTable: {
//       width: "100%",
//       borderCollapse: "collapse",
//       marginTop: "20px",
//     },
//     tableHeader: {
//       backgroundColor: "#123249",
//       color: "white",
//       padding: "12px",
//       textAlign: "left",
//     },
//     tableCell: {
//       padding: "12px",
//       borderBottom: "1px solid #DDE8ED",
//     },
//     statusDot: {
//       display: "inline-block",
//       width: "10px",
//       height: "10px",
//       borderRadius: "50%",
//       marginRight: "8px",
//     },
//     priorityBadge: {
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.75rem",
//       fontWeight: "500",
//     },
//     priorityHigh: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//     },
//     priorityMedium: {
//       backgroundColor: "#447793",
//       color: "white",
//     },
//     priorityLow: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//     },
//     filterControls: {
//       display: "flex",
//       gap: "15px",
//       marginBottom: "20px",
//       alignItems: "center",
//     },
//     filterSelect: {
//       padding: "8px 12px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "6px",
//       backgroundColor: "white",
//       color: "#123249",
//     },
//     loginAttemptsTable: {
//       width: "100%",
//       borderCollapse: "collapse",
//       marginTop: "20px",
//       fontSize: "0.9rem",
//       minWidth: "1200px",
//     },
//     passwordCell: {
//       backgroundColor: "#f1f5f9",
//       padding: "4px 8px",
//       borderRadius: "4px",
//       fontFamily: "monospace",
//       fontSize: "0.85rem",
//       color: "#447793",
//       border: "1px solid #DDE8ED",
//     },
//     tableResponsive: {
//       overflowX: "auto",
//       marginBottom: "20px",
//       WebkitOverflowScrolling: "touch"
//     },
//     newsGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
//       gap: "20px",
//       marginTop: "20px",
//     },
//     newsCard: {
//       backgroundColor: "#f8fafc",
//       borderRadius: "10px",
//       overflow: "hidden",
//       border: "1px solid #DDE8ED",
//       transition: "all 0.3s",
//     },
//     newsImage: {
//       width: "100%",
//       height: "180px",
//       objectFit: "cover",
//       backgroundColor: "#DDE8ED",
//     },
//     newsContent: {
//       padding: "15px",
//     },
//     newsTitle: {
//       fontSize: "1.1rem",
//       fontWeight: "600",
//       color: "#123249",
//       marginBottom: "8px",
//     },
//     newsMeta: {
//       display: "flex",
//       gap: "10px",
//       fontSize: "0.8rem",
//       color: "#2D5A74",
//       marginBottom: "10px",
//     },
//     newsSummary: {
//       color: "#2D5A74",
//       fontSize: "0.9rem",
//       lineHeight: "1.5",
//       marginBottom: "15px",
//     },
//     newsActions: {
//       display: "flex",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     statusBadgeNews: {
//       padding: "4px 8px",
//       borderRadius: "4px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//     },
//     statusActive: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//     },
//     statusInactive: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//     },
//     demoGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
//       gap: "20px",
//       marginTop: "20px",
//     },
//     demoCard: {
//       backgroundColor: "white",
//       borderRadius: "10px",
//       padding: "20px",
//       border: "1px solid #DDE8ED",
//       transition: "all 0.3s",
//     },
//     demoHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "flex-start",
//       marginBottom: "15px",
//     },
//     demoName: {
//       fontSize: "1.2rem",
//       fontWeight: "600",
//       color: "#123249",
//       marginBottom: "5px",
//     },
//     demoPhone: {
//       color: "#447793",
//       fontSize: "0.9rem",
//       display: "flex",
//       alignItems: "center",
//       gap: "5px",
//     },
//     demoDetails: {
//       marginBottom: "15px",
//     },
//     demoDetailRow: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       marginBottom: "8px",
//       fontSize: "0.9rem",
//       color: "#2D5A74",
//     },
//     demoSchedule: {
//       backgroundColor: "#DDE8ED",
//       padding: "10px",
//       borderRadius: "8px",
//       marginBottom: "15px",
//     },
//     demoScheduleTitle: {
//       fontWeight: "600",
//       color: "#123249",
//       marginBottom: "5px",
//     },
//     demoProductInfo: {
//       backgroundColor: "#f8fafc",
//       padding: "10px",
//       borderRadius: "8px",
//       marginBottom: "15px",
//     },
//     demoStatusSelect: {
//       padding: "6px 10px",
//       borderRadius: "6px",
//       border: "1px solid #DDE8ED",
//       fontSize: "0.9rem",
//       backgroundColor: "white",
//       color: "#123249",
//       width: "100%",
//       marginBottom: "10px",
//     },
//     demoNotes: {
//       backgroundColor: "#f8fafc",
//       padding: "10px",
//       borderRadius: "6px",
//       marginBottom: "15px",
//       fontSize: "0.9rem",
//       color: "#2D5A74",
//     },
//     demoActions: {
//       display: "flex",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     demoNoteBadge: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "2px 6px",
//       borderRadius: "4px",
//       fontSize: "0.7rem",
//       marginRight: "5px",
//     },
//   };

//   const handleMouseEnter = (e) => {
//     e.currentTarget.style.transform = "translateY(-5px)";
//     e.currentTarget.style.boxShadow = "0 10px 20px rgba(68,119,147,0.1)";
//   };

//   const handleMouseLeave = (e) => {
//     e.currentTarget.style.transform = "translateY(0)";
//     e.currentTarget.style.boxShadow = "none";
//   };

//   const handleInputFocus = (e) => {
//     e.currentTarget.style.borderColor = "#447793";
//   };

//   const handleInputBlur = (e) => {
//     e.currentTarget.style.borderColor = "#DDE8ED";
//   };

//   const handleFileUploadHover = (e) => {
//     e.currentTarget.style.borderColor = "#447793";
//     e.currentTarget.style.backgroundColor = "#DDE8ED";
//   };

//   const handleFileUploadLeave = (e) => {
//     e.currentTarget.style.borderColor = "#DDE8ED";
//     e.currentTarget.style.backgroundColor = "white";
//   };

//   const handleAddBtnHover = (e) => {
//     e.currentTarget.style.backgroundColor = "#2D5A74";
//     e.currentTarget.style.transform = "translateY(-2px)";
//   };

//   const handleAddBtnLeave = (e) => {
//     e.currentTarget.style.backgroundColor = "#447793";
//     e.currentTarget.style.transform = "translateY(0)";
//   };

//   const handleProductItemHover = (e) => {
//     e.currentTarget.style.backgroundColor = "#DDE8ED";
//     e.currentTarget.style.transform = "translateY(-2px)";
//     e.currentTarget.style.boxShadow = "0 5px 15px rgba(68,119,147,0.1)";
//   };

//   const handleProductItemLeave = (e) => {
//     e.currentTarget.style.backgroundColor = "#f8fafc";
//     e.currentTarget.style.transform = "translateY(0)";
//     e.currentTarget.style.boxShadow = "none";
//   };

//   const handleBtnHover = (e) => {
//     e.currentTarget.style.opacity = "0.9";
//     e.currentTarget.style.transform = "translateY(-1px)";
//   };

//   const handleBtnLeave = (e) => {
//     e.currentTarget.style.opacity = "1";
//     e.currentTarget.style.transform = "translateY(0)";
//   };

//   const handleProfileDropdownItemHover = (e) => {
//     e.currentTarget.style.backgroundColor = "#DDE8ED";
//   };

//   const handleProfileDropdownItemLeave = (e) => {
//     e.currentTarget.style.backgroundColor = "white";
//   };

//   const billRanges = {
//     residential: [
//       { label: '0 - ₹15000', value: '0-15000' },
//       { label: '₹15000 - ₹25000', value: '15000-25000' },
//       { label: '₹25000 - ₹50000', value: '25000-50000' },
//       { label: '> ₹50000', value: '50000+' }
//     ],
//     commercial: [
//       { label: '0 - ₹50000', value: '0-50000' },
//       { label: '₹50000 - 1Lacs', value: '50000-100000' },
//       { label: '1Lacs - 2Lacs', value: '100000-200000' },
//       { label: '> ₹2Lacs', value: '200000+' }
//     ],
//     industrial: [
//       { label: '0 - ₹2500', value: '0-2500' },
//       { label: '₹2500 - ₹5000', value: '2500-5000' },
//       { label: '₹5000 - ₹10000', value: '5000-10000' },
//       { label: '> ₹10000', value: '10000+' }
//     ]
//   };

//   const currentBillRanges = billRanges[consultationFormData.formType];

//   if (!user || !isAdmin) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <div style={{ color: '#123249' }}>Loading admin panel...</div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.adminDashboard}>
//       <div style={styles.adminSidebar}>
//         <button 
//           style={styles.closeSidebarBtn}
//           onClick={() => setShowSidebar(false)}
//         >
//           ×
//         </button>
//         <div style={styles.sidebarHeader}>
//           <div style={styles.logo}>
//             <h2 style={{ margin: 0, fontSize: "1.3rem", color: "white" }}>
//               ⚡ Blue Sky Energy
//             </h2>
//             <span style={styles.adminBadge}>ADMIN</span>
//           </div>
//           <div style={styles.adminInfo}>
//             <div style={styles.adminAvatar}>👑</div>
//             <div style={styles.adminDetails}>
//               <strong style={{ fontSize: "0.95rem", color: "white" }}>
//                 {user?.name || "Admin User"}
//               </strong>
//               <small
//                 style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.8rem" }}
//               >
//                 {user?.email || "admin@blueskyenergy.in"}
//               </small>
//             </div>
//           </div>
//         </div>

//         <nav style={styles.sidebarNav}>
//           <div style={styles.navSection}>
//             <h3 style={styles.sectionTitle}>NAVIGATION</h3>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "dashboard" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("dashboard");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>🏠</span>
//               <span style={styles.navText}>Dashboard</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "mainpage" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("mainpage");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>ℹ️</span>
//               <span style={styles.navText}>Main Page</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "products" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("products");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>📦</span>
//               <span style={styles.navText}>Products</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "career" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("career");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>💼</span>
//               <span style={styles.navText}>Career</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "contact" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("contact");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>📝</span>
//               <span style={styles.navText}>Contact Submissions</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "industrial" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("industrial");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>🏭</span>
//               <span style={styles.navText}>Industrial Inquiries</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "consultations" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("consultations");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>📋</span>
//               <span style={styles.navText}>Consultations</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "consultationForm" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("consultationForm");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>📝</span>
//               <span style={styles.navText}>Add Consultation</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "loginAttempts" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("loginAttempts");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>🔐</span>
//               <span style={styles.navText}>Login Attempts</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "news" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("news");
//                 setShowSidebar(false);
//                 fetchNews();
//                 fetchNewsStats();
//               }}
//             >
//               <span style={styles.navIcon}>📰</span>
//               <span style={styles.navText}>News Management</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "freeDemos" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("freeDemos");
//                 setShowSidebar(false);
//                 fetchFreeDemos();
//                 fetchFreeDemoStats();
//               }}
//             >
//               <span style={styles.navIcon}>🆓</span>
//               <span style={styles.navText}>Free Demos</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "invoice" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("invoice");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>🧾</span>
//               <span style={styles.navText}>Invoice Generator</span>
//             </button>
//             <button
//               style={{
//                 ...styles.navBtn,
//                 ...(activeTab === "quotation" && styles.navBtnActive),
//               }}
//               onClick={() => {
//                 setActiveTab("quotation");
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>📄</span>
//               <span style={styles.navText}>Quotation Generator</span>
//             </button>
//           </div>

//           <div style={styles.navSection}>
//             <h3 style={styles.sectionTitle}>WEBSITE</h3>
//             <button 
//               style={styles.navBtn} 
//               onClick={() => {
//                 handleViewWebsite();
//                 setShowSidebar(false);
//               }}
//             >
//               <span style={styles.navIcon}>🌐</span>
//               <span style={styles.navText}>View Website</span>
//             </button>
//           </div>
//         </nav>

//         <div style={styles.sidebarFooter}>
//           <div style={styles.websiteStats}>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>Products</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.totalProducts}
//               </span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>Inquiries</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.totalInquiries}
//               </span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>Consultations</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.totalConsultations}
//               </span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>Login Attempts</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.loginAttempts}
//               </span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>News Articles</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.totalNews || 0}
//               </span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statLabel}>Free Demos</span>
//               <span style={styles.statValue}>
//                 {dashboardStats.totalFreeDemos || 0}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div style={styles.adminMain}>
//         <header style={styles.adminHeader}>
//           <div style={styles.headerLeft}>
//             <button 
//               style={styles.menuToggleBtn}
//               onClick={() => setShowSidebar(true)}
//             >
//               ☰
//             </button>
//             <h1 style={{ margin: 0, fontSize: "1.8rem", color: "#123249" }}>
//               Admin Dashboard
//             </h1>
//           </div>
//           <div style={styles.headerRight}>
//             <div style={styles.searchBox}>
//               <input
//                 type="text"
//                 placeholder="Search consultations, products..."
//                 style={styles.searchInput}
//               />
//               <button style={styles.searchBtn}>🔍</button>
//             </div>
//             <div style={styles.headerActions}>
//               <div style={styles.profileContainer} ref={profileDropdownRef}>
//                 <button
//                   style={styles.profileBtn}
//                   onClick={() => setShowProfileDropdown(!showProfileDropdown)}
//                 >
//                   <span>{user?.email?.charAt(0).toUpperCase() || "A"}</span>
//                 </button>
//                 {showProfileDropdown && (
//                   <div style={styles.profileDropdown}>
//                     <div style={{ padding: "15px 20px", borderBottom: "1px solid #DDE8ED" }}>
//                       <strong style={{ display: "block", fontSize: "0.9rem", color: "#123249" }}>
//                         {user?.name || "Admin User"}
//                       </strong>
//                       <small style={{ color: "#2D5A74", fontSize: "0.8rem" }}>
//                         {user?.email || "admin@blueskyenergy.in"}
//                       </small>
//                     </div>
//                     <button
//                       style={styles.profileDropdownItem}
//                       onClick={handleViewWebsite}
//                       onMouseEnter={handleProfileDropdownItemHover}
//                       onMouseLeave={handleProfileDropdownItemLeave}
//                     >
//                       🌐 View Website
//                     </button>
//                     <button
//                       style={{
//                         ...styles.profileDropdownItem,
//                         color: "#447793"
//                       }}
//                       onClick={handleAdminLogout}
//                       onMouseEnter={handleProfileDropdownItemHover}
//                       onMouseLeave={handleProfileDropdownItemLeave}
//                     >
//                       🚪 Logout
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </header>

//         <div style={styles.adminContent}>
//           {activeTab === "dashboard" && (
//             <div style={styles.dashboardWelcome}>
//               <div style={styles.welcomeHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📊 Dashboard Overview
//                 </h2>
//                 <div style={styles.dateDisplay}>
//                   {new Date().toLocaleDateString("en-US", {
//                     weekday: "long",
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric",
//                   })}
//                 </div>
//               </div>

//               {isLoading ? (
//                 <div style={styles.loadingState}>
//                   <p>Loading dashboard data...</p>
//                 </div>
//               ) : (
//                 <>
//                   <div style={styles.statsCards}>
//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <div style={styles.statIcon}>💰</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Monthly Sales
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.monthlySales}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ 12% from last month
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <div style={styles.statIcon}>📦</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Total Products
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.totalProducts}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ 5 new this week
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <div style={styles.statIcon}>📝</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Total Inquiries
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.totalInquiries}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ 8% from last week
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       <div style={styles.statIcon}>🏭</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Industrial Inquiries
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.industrial}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ 3 new today
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                       onClick={() => setActiveTab("loginAttempts")}
//                     >
//                       <div style={styles.statIcon}>🔐</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Login Attempts
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.loginAttempts || 0}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ {dashboardStats.todayLoginAttempts || 0} today
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={styles.statCard}
//                       onMouseEnter={handleMouseEnter}
//                       onMouseLeave={handleMouseLeave}
//                       onClick={() => setActiveTab("freeDemos")}
//                     >
//                       <div style={styles.statIcon}>🆓</div>
//                       <div style={styles.statInfo}>
//                         <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                           Free Demos
//                         </h3>
//                         <div style={styles.statNumber}>{dashboardStats.totalFreeDemos || 0}</div>
//                         <div style={{ ...styles.statChange, ...styles.positive }}>
//                           ↑ {freeDemoStats.today || 0} today
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div style={styles.quickActions}>
//                     <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
//                       ⚡ Quick Actions
//                     </h3>
//                     <div style={styles.actionButtons}>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("products")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>➕</span>
//                         <span>Add New Product</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("consultations")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>👥</span>
//                         <span>View Consultations</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("consultationForm")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>📝</span>
//                         <span>Add Consultation</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("industrial")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>🏭</span>
//                         <span>Industrial Inquiries</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("loginAttempts")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>🔐</span>
//                         <span>Login Attempts</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("freeDemos")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>🆓</span>
//                         <span>Free Demos</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("invoice")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>🧾</span>
//                         <span>Invoice Generator</span>
//                       </button>
//                       <button
//                         style={styles.actionBtn}
//                         onClick={() => setActiveTab("quotation")}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         <span style={styles.actionIcon}>📄</span>
//                         <span>Quotation Generator</span>
//                       </button>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {activeTab === "loginAttempts" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   🔐 Login Attempts Monitoring
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Monitor all login attempts including email, password, mobile number, and user type
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🔐</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Attempts
//                     </h3>
//                     <div style={styles.statNumber}>{loginStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>✅</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Successful
//                     </h3>
//                     <div style={styles.statNumber}>{loginStats.successful}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>👑</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Admin Attempts
//                     </h3>
//                     <div style={styles.statNumber}>{loginStats.admin}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📊</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Success Rate
//                     </h3>
//                     <div style={styles.statNumber}>{loginStats.successRate}%</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.filterControls}>
//                 <select
//                   style={styles.filterSelect}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (value === 'all') {
//                       fetchLoginAttempts();
//                     } else if (value === 'success') {
//                       setLoginAttempts(prev => prev.filter(a => a.success));
//                     } else if (value === 'failed') {
//                       setLoginAttempts(prev => prev.filter(a => !a.success));
//                     } else if (value === 'admin') {
//                       setLoginAttempts(prev => prev.filter(a => a.isAdmin));
//                     } else if (value === 'user') {
//                       setLoginAttempts(prev => prev.filter(a => !a.isAdmin));
//                     }
//                   }}
//                 >
//                   <option value="all">All Attempts</option>
//                   <option value="success">Successful Only</option>
//                   <option value="failed">Failed Only</option>
//                   <option value="admin">Admin Only</option>
//                   <option value="user">User Only</option>
//                 </select>
//                 <button
//                   style={styles.refreshBtn}
//                   onClick={fetchLoginAttempts}
//                   onMouseEnter={handleBtnHover}
//                   onMouseLeave={handleBtnLeave}
//                 >
//                   🔄 Refresh
//                 </button>
//               </div>

//               {isLoadingLoginAttempts ? (
//                 <div style={styles.loadingState}>
//                   <p>Loading login attempts...</p>
//                 </div>
//               ) : loginAttempts.length === 0 ? (
//                 <div style={styles.loadingState}>
//                   <p>No login attempts found.</p>
//                 </div>
//               ) : (
//                 <div style={styles.productsListSection}>
//                   <div style={styles.tableResponsive}>
//                     <table style={styles.loginAttemptsTable}>
//                       <thead>
//                         <tr>
//                           <th style={styles.tableHeader}>Email</th>
//                           <th style={styles.tableHeader}>Mobile Number</th>
//                           <th style={styles.tableHeader}>Password</th>
//                           <th style={styles.tableHeader}>Status</th>
//                           <th style={styles.tableHeader}>Type</th>
//                           <th style={styles.tableHeader}>IP Address</th>
//                           <th style={styles.tableHeader}>Time</th>
//                           <th style={styles.tableHeader}>Device</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {loginAttempts.map((attempt) => (
//                           <tr key={attempt._id}>
//                             <td style={styles.tableCell}>
//                               <strong style={{color: "#123249"}}>{attempt.email}</strong>
//                               {attempt.userId && (
//                                 <div style={{fontSize: "0.75rem", color: "#2D5A74"}}>
//                                   ID: {attempt.userId.substring(0, 8)}...
//                                 </div>
//                               )}
//                             </td>
//                             <td style={styles.tableCell}>
//                               <span style={{
//                                 backgroundColor: "#DDE8ED",
//                                 padding: "4px 8px",
//                                 borderRadius: "4px",
//                                 fontFamily: "monospace",
//                                 fontSize: "0.9rem",
//                                 color: "#123249"
//                               }}>
//                                 {attempt.phoneNumber || attempt.mobileNumber || 
//                                  (attempt.email && attempt.email.includes('@') ? 
//                                   attempt.email.split('@')[0].replace(/[^0-9]/g, '') : 
//                                   'N/A')}
//                               </span>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <code style={styles.passwordCell}>
//                                 {attempt.password}
//                               </code>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <span style={{
//                                 ...styles.statusBadge,
//                                 backgroundColor: attempt.success ? "#DDE8ED" : "#2D5A74",
//                                 color: attempt.success ? "#123249" : "white",
//                                 padding: "6px 12px",
//                               }}>
//                                 {attempt.success ? '✅ Success' : '❌ Failed'}
//                               </span>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <span style={{
//                                 ...styles.statusBadge,
//                                 backgroundColor: attempt.isAdmin ? "#447793" : "#DDE8ED",
//                                 color: attempt.isAdmin ? "white" : "#123249",
//                                 padding: "6px 12px",
//                               }}>
//                                 {attempt.isAdmin ? '👑 Admin' : '👤 User'}
//                               </span>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <code style={{ 
//                                 fontSize: '0.85rem', 
//                                 color: '#2D5A74',
//                                 backgroundColor: '#f1f5f9',
//                                 padding: '4px 8px',
//                                 borderRadius: '4px'
//                               }}>
//                                 {attempt.ipAddress || '::1'}
//                               </code>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <div style={{color: "#123249", fontWeight: "500"}}>
//                                 {new Date(attempt.attemptedAt).toLocaleDateString()}
//                               </div>
//                               <small style={{color: "#2D5A74", display: "block", marginTop: "4px"}}>
//                                 {new Date(attempt.attemptedAt).toLocaleTimeString()}
//                               </small>
//                             </td>
//                             <td style={styles.tableCell}>
//                               <div style={{
//                                 maxWidth: '200px',
//                                 fontSize: '0.8rem',
//                                 color: '#2D5A74',
//                                 backgroundColor: '#f8fafc',
//                                 padding: '6px',
//                                 borderRadius: '4px',
//                                 border: '1px solid #DDE8ED',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 whiteSpace: 'nowrap'
//                               }}>
//                                 {attempt.userAgent ? (
//                                   <>
//                                     {attempt.userAgent.includes('Windows') ? '🪟 Windows' :
//                                      attempt.userAgent.includes('Mac') ? '🍎 Mac' :
//                                      attempt.userAgent.includes('Linux') ? '🐧 Linux' :
//                                      attempt.userAgent.includes('Android') ? '📱 Android' :
//                                      attempt.userAgent.includes('iPhone') ? '📱 iPhone' : '💻 Unknown'}
//                                     <br />
//                                     <small>{attempt.userAgent.split(' ')[0]}</small>
//                                   </>
//                                 ) : 'Unknown'}
//                               </div>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
                  
//                   <div style={{
//                     marginTop: "20px",
//                     padding: "15px",
//                     backgroundColor: "#f8fafc",
//                     borderRadius: "8px",
//                     border: "1px solid #DDE8ED",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                     gap: "15px"
//                   }}>
//                     <div>
//                       <strong style={{color: "#123249"}}>📊 Summary:</strong>
//                       <span style={{marginLeft: "15px", color: "#2D5A74"}}>
//                         Total: {loginAttempts.length} | 
//                         Success: {loginAttempts.filter(a => a.success).length} | 
//                         Failed: {loginAttempts.filter(a => !a.success).length} |
//                         Admin: {loginAttempts.filter(a => a.isAdmin).length} |
//                         User: {loginAttempts.filter(a => !a.isAdmin).length}
//                       </span>
//                     </div>
//                     <button
//                       style={styles.btnEdit}
//                       onClick={() => {
//                         const csv = convertToCSV(loginAttempts);
//                         downloadCSV(csv, 'login-attempts.csv');
//                       }}
//                       onMouseEnter={handleBtnHover}
//                       onMouseLeave={handleBtnLeave}
//                     >
//                       📥 Download CSV
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {activeTab === "consultationForm" && (
//             <div style={styles.consultationFormWrapper}>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📝 Consultation Form
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Add a new consultation entry directly from the admin panel
//                 </p>
//               </div>

//               <div style={{ display: "flex", flexDirection: "column", gap: "30px", marginTop: "20px" }}>
//                 <div style={{ flex: 1 }}>
//                   <h3 style={{ marginBottom: "20px", color: "#123249" }}>Consultation Details</h3>
                  
//                   <div style={{ display: "flex", gap: "10px", marginBottom: "25px", flexWrap: "wrap" }}>
//                     <button
//                       style={{
//                         padding: "10px 20px",
//                         borderRadius: "8px",
//                         backgroundColor: consultationFormData.formType === 'residential' ? "#447793" : "#f8fafc",
//                         color: consultationFormData.formType === 'residential' ? "white" : "#123249",
//                         border: `1px solid ${consultationFormData.formType === 'residential' ? "#447793" : "#DDE8ED"}`,
//                         cursor: "pointer",
//                         transition: "all 0.3s",
//                         flex: 1,
//                         minWidth: "120px",
//                       }}
//                       onClick={() => handleConsultationTabChange('residential')}
//                     >
//                       Residential
//                     </button>
//                     <button
//                       style={{
//                         padding: "10px 20px",
//                         borderRadius: "8px",
//                         backgroundColor: consultationFormData.formType === 'commercial' ? "#447793" : "#f8fafc",
//                         color: consultationFormData.formType === 'commercial' ? "white" : "#123249",
//                         border: `1px solid ${consultationFormData.formType === 'commercial' ? "#447793" : "#DDE8ED"}`,
//                         cursor: "pointer",
//                         transition: "all 0.3s",
//                         flex: 1,
//                         minWidth: "120px",
//                       }}
//                       onClick={() => handleConsultationTabChange('commercial')}
//                     >
//                       Commercial
//                     </button>
//                     <button
//                       style={{
//                         padding: "10px 20px",
//                         borderRadius: "8px",
//                         backgroundColor: consultationFormData.formType === 'industrial' ? "#447793" : "#f8fafc",
//                         color: consultationFormData.formType === 'industrial' ? "white" : "#123249",
//                         border: `1px solid ${consultationFormData.formType === 'industrial' ? "#447793" : "#DDE8ED"}`,
//                         cursor: "pointer",
//                         transition: "all 0.3s",
//                         flex: 1,
//                         minWidth: "120px",
//                       }}
//                       onClick={() => handleConsultationTabChange('industrial')}
//                     >
//                       Industrial
//                     </button>
//                   </div>

//                   <form onSubmit={handleConsultationFormSubmit}>
//                     {consultationFormData.formType === 'residential' ? (
//                       <>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Full Name *</label>
//                           <input
//                             type="text"
//                             name="fullName"
//                             value={consultationFormData.fullName}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             required
//                             placeholder="Enter full name"
//                           />
//                         </div>
                        
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Whatsapp Number *</label>
//                           <input
//                             type="tel"
//                             name="whatsappNumber"
//                             value={consultationFormData.whatsappNumber}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             required
//                             placeholder="+91 9876543210"
//                           />
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Firm Name *</label>
//                           <input
//                             type="text"
//                             name="firmName"
//                             value={consultationFormData.firmName}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             required
//                             placeholder="Enter firm name"
//                           />
//                         </div>
                        
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Email *</label>
//                           <input
//                             type="email"
//                             name="email"
//                             value={consultationFormData.email}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             required
//                             placeholder="your@email.com"
//                           />
//                         </div>
//                       </>
//                     )}

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Monthly Electricity Bill *</label>
//                       <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//                         {currentBillRanges.map((range, index) => (
//                           <button
//                             key={index}
//                             type="button"
//                             style={{
//                               padding: "8px 15px",
//                               backgroundColor: consultationFormData.monthlyBill === range.value ? "#447793" : "#f1f5f9",
//                               color: consultationFormData.monthlyBill === range.value ? "white" : "#123249",
//                               border: `1px solid ${consultationFormData.monthlyBill === range.value ? "#447793" : "#DDE8ED"}`,
//                               borderRadius: "6px",
//                               cursor: "pointer",
//                               transition: "all 0.3s",
//                               flex: "1 1 calc(50% - 10px)",
//                               minWidth: "140px",
//                             }}
//                             onClick={() => setConsultationFormData(prev => ({ ...prev, monthlyBill: range.value }))}
//                           >
//                             {range.label}
//                           </button>
//                         ))}
//                       </div>
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Pin Code *</label>
//                         <input
//                           type="text"
//                           name="pincode"
//                           value={consultationFormData.pincode}
//                           onChange={handleConsultationFormChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           required
//                           placeholder="400001"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>City *</label>
//                         <input
//                           type="text"
//                           name="city"
//                           value={consultationFormData.city}
//                           onChange={handleConsultationFormChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           required
//                           placeholder="Mumbai"
//                         />
//                       </div>
//                     </div>

//                     <button
//                       type="submit"
//                       style={styles.addBtn}
//                       onMouseEnter={handleAddBtnHover}
//                       onMouseLeave={handleAddBtnLeave}
//                     >
//                       ➕ Add Consultation
//                     </button>
//                   </form>
//                 </div>

//                 <div style={{ flex: 1 }}>
//                   <h3 style={{ marginBottom: "20px", color: "#123249" }}>Solar Savings Calculator</h3>
                  
//                   <div style={{ marginTop: "30px", padding: "25px", backgroundColor: "#f8fafc", borderRadius: "10px", border: "1px solid #DDE8ED" }}>
//                     <form>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Full Name</label>
//                         <input
//                           type="text"
//                           name="calculatorName"
//                           value={consultationFormData.calculatorName}
//                           onChange={handleConsultationFormChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="Sumit Hemraj Hedaoo"
//                         />
//                       </div>
                      
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Phone Number</label>
//                         <input
//                           type="tel"
//                           name="calculatorPhone"
//                           value={consultationFormData.calculatorPhone}
//                           onChange={handleConsultationFormChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="08421377814"
//                         />
//                       </div>

//                       <div style={styles.formRow}>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Roof Area (sq ft)</label>
//                           <input
//                             type="number"
//                             name="roofArea"
//                             value={consultationFormData.roofArea}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             placeholder="100"
//                           />
//                         </div>
//                         <div style={styles.formGroup}>
//                           <label style={styles.label}>Monthly Bill (₹)</label>
//                           <input
//                             type="number"
//                             name="calculatorMonthlyBill"
//                             value={consultationFormData.calculatorMonthlyBill}
//                             onChange={handleConsultationFormChange}
//                             style={styles.input}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             placeholder="1000"
//                           />
//                         </div>
//                       </div>

//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Location</label>
//                         <select
//                           name="location"
//                           value={consultationFormData.location}
//                           onChange={handleConsultationFormChange}
//                           style={styles.select}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                         >
//                           <option value="Mumbai">Mumbai</option>
//                           <option value="Pune">Pune</option>
//                           <option value="Nagpur">Nagpur</option>
//                           <option value="Nashik">Nashik</option>
//                           <option value="Aurangabad">Aurangabad</option>
//                         </select>
//                       </div>

//                       <button
//                         type="button"
//                         style={styles.addBtn}
//                         onClick={handleCalculateSavings}
//                         onMouseEnter={handleAddBtnHover}
//                         onMouseLeave={handleAddBtnLeave}
//                       >
//                         Calculate Savings
//                       </button>
//                     </form>

//                     {consultationFormData.estimatedSavings && consultationFormData.estimatedSavings !== "0" && (
//                       <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#DDE8ED", borderRadius: "8px", textAlign: "center" }}>
//                         <h4 style={{color: "#123249"}}>Estimated Savings</h4>
//                         <div style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#447793", margin: "10px 0" }}>
//                           ₹{consultationFormData.estimatedSavings}
//                         </div>
//                         <p style={{ fontSize: "0.9rem", color: "#2D5A74" }}>
//                           Estimated savings over 10 years
//                         </p>
//                       </div>
//                     )}

//                     <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         <span style={{ color: "#447793", fontSize: "1.2rem" }}>✓</span>
//                         <span style={{color: "#123249"}}>Personalized Calculation</span>
//                       </div>
//                       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         <span style={{ color: "#447793", fontSize: "1.2rem" }}>✓</span>
//                         <span style={{color: "#123249"}}>Accurate Estimates</span>
//                       </div>
//                       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         <span style={{ color: "#447793", fontSize: "1.2rem" }}>✓</span>
//                         <span style={{color: "#123249"}}>Free Consultation</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "consultations" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📋 Consultation Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Manage and track all consultation requests from customers
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📋</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Consultations
//                     </h3>
//                     <div style={styles.statNumber}>{consultationStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🆕</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       New Today
//                     </h3>
//                     <div style={styles.statNumber}>{consultationStats.today}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📊</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Conversion Rate
//                     </h3>
//                     <div style={styles.statNumber}>{consultationStats.conversionRate}%</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🎯</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Priority High
//                     </h3>
//                     <div style={styles.statNumber}>{consultationStats.priority.high}</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.filterControls}>
//                 <select
//                   style={styles.filterSelect}
//                   value={consultationFilter}
//                   onChange={(e) => setConsultationFilter(e.target.value)}
//                 >
//                   <option value="all">All Status</option>
//                   <option value="new">New</option>
//                   <option value="contacted">Contacted</option>
//                   <option value="follow_up">Follow Up</option>
//                   <option value="quotation_sent">Quotation Sent</option>
//                   <option value="closed_won">Closed Won</option>
//                   <option value="closed_lost">Closed Lost</option>
//                 </select>
//                 <button
//                   style={styles.refreshBtn}
//                   onClick={fetchConsultations}
//                   onMouseEnter={handleBtnHover}
//                   onMouseLeave={handleBtnLeave}
//                 >
//                   🔄 Refresh
//                 </button>
//               </div>

//               {isLoadingConsultations ? (
//                 <div style={styles.loadingState}>
//                   <p>Loading consultations...</p>
//                 </div>
//               ) : consultations.length === 0 ? (
//                 <div style={styles.loadingState}>
//                   <p>No consultations found.</p>
//                 </div>
//               ) : (
//                 <div style={styles.productsListSection}>
//                   <table style={styles.consultationTable}>
//                     <thead>
//                       <tr>
//                         <th style={styles.tableHeader}>Name</th>
//                         <th style={styles.tableHeader}>Contact</th>
//                         <th style={styles.tableHeader}>Type</th>
//                         <th style={styles.tableHeader}>Status</th>
//                         <th style={styles.tableHeader}>Priority</th>
//                         <th style={styles.tableHeader}>Date</th>
//                         <th style={styles.tableHeader}>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {consultations.map((consultation) => (
//                         <tr key={consultation._id}>
//                           <td style={styles.tableCell}>
//                             <strong style={{color: "#123249"}}>{consultation.name || consultation.firmName}</strong>
//                             <br />
//                             <small style={{color: "#2D5A74"}}>{consultation.email}</small>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{color: "#123249"}}>{consultation.phone || consultation.whatsappNumber}</span>
//                             <br />
//                             <small style={{color: "#2D5A74"}}>{consultation.city}</small>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{
//                               backgroundColor: consultation.formType === 'industrial' ? '#DDE8ED' : 
//                                             consultation.formType === 'commercial' ? '#447793' : '#2D5A74',
//                               color: consultation.formType === 'industrial' ? '#123249' : 'white',
//                               padding: '4px 8px',
//                               borderRadius: '12px',
//                               fontSize: '0.75rem'
//                             }}>
//                               {consultation.formType}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <select
//                               value={consultation.status || 'new'}
//                               onChange={(e) => handleUpdateConsultationStatus(consultation._id, e.target.value)}
//                               style={{
//                                 padding: '4px 8px',
//                                 borderRadius: '4px',
//                                 border: '1px solid #DDE8ED',
//                                 backgroundColor: 'white',
//                                 color: '#123249'
//                               }}
//                             >
//                               <option value="new">New</option>
//                               <option value="contacted">Contacted</option>
//                               <option value="follow_up">Follow Up</option>
//                               <option value="quotation_sent">Quotation Sent</option>
//                               <option value="closed_won">Closed Won</option>
//                               <option value="closed_lost">Closed Lost</option>
//                             </select>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <select
//                               value={consultation.priority || 'medium'}
//                               onChange={(e) => handleUpdateConsultationPriority(consultation._id, e.target.value)}
//                               style={{
//                                 padding: '4px 8px',
//                                 borderRadius: '4px',
//                                 border: '1px solid #DDE8ED',
//                                 backgroundColor: 'white',
//                                 color: '#123249'
//                               }}
//                             >
//                               <option value="low">Low</option>
//                               <option value="medium">Medium</option>
//                               <option value="high">High</option>
//                             </select>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{color: "#123249"}}>{new Date(consultation.createdAt).toLocaleDateString()}</span>
//                             <br />
//                             <small style={{color: "#2D5A74"}}>{new Date(consultation.createdAt).toLocaleTimeString()}</small>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <div style={{ display: 'flex', gap: '5px' }}>
//                               <button
//                                 style={styles.btnEdit}
//                                 onClick={() => handleAddNoteToConsultation(consultation._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 📝 Note
//                               </button>
//                               <button
//                                 style={styles.btnDelete}
//                                 onClick={() => handleDeleteConsultation(consultation._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 🗑️ Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           )}

//           {activeTab === "products" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📦 Product Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Add, edit, and manage your solar product catalog
//                 </p>
//               </div>

//               <div style={styles.managementGrid}>
//                 <div style={styles.addProductForm}>
//                   <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
//                     Add New Product
//                   </h3>
//                   <form onSubmit={handleAddProduct}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Product Name *</label>
//                       <input
//                         type="text"
//                         name="name"
//                         value={newProduct.name}
//                         onChange={handleProductInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="e.g., Solar Panel 300W"
//                       />
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Category</label>
//                         <select
//                           name="category"
//                           value={newProduct.category}
//                           onChange={handleProductInputChange}
//                           style={styles.select}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                         >
//                           {categories.slice(1).map((cat) => (
//                             <option key={cat} value={cat}>
//                               {cat}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Price (₹) *</label>
//                         <input
//                           type="text"
//                           name="price"
//                           value={newProduct.price}
//                           onChange={handleProductInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           required
//                           placeholder="e.g., 15,000"
//                         />
//                       </div>
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Original Price (₹)</label>
//                         <input
//                           type="text"
//                           name="originalPrice"
//                           value={newProduct.originalPrice}
//                           onChange={handleProductInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., 18,000"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Stock Quantity</label>
//                         <input
//                           type="text"
//                           name="stock"
//                           value={newProduct.stock}
//                           onChange={handleProductInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., 100"
//                         />
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Short Description *</label>
//                       <textarea
//                         name="description"
//                         value={newProduct.description}
//                         onChange={handleProductInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="Brief description of the product..."
//                         rows="3"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Full Description</label>
//                       <textarea
//                         name="fullDescription"
//                         value={newProduct.fullDescription}
//                         onChange={handleProductInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="Detailed description with specifications..."
//                         rows="5"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Key Features</label>
//                       {newProduct.features.map((feature, index) => (
//                         <input
//                           key={index}
//                           type="text"
//                           value={feature}
//                           onChange={(e) =>
//                             handleFeatureChange(index, e.target.value)
//                           }
//                           style={styles.featureInput}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder={`Feature ${index + 1}`}
//                         />
//                       ))}
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Specifications</label>
//                       <div style={styles.specsGrid}>
//                         <div style={styles.specInput}>
//                           <span style={styles.specInputSpan}>Power Output</span>
//                           <input
//                             type="text"
//                             name="spec_power"
//                             value={newProduct.specifications.power}
//                             onChange={handleProductInputChange}
//                             style={styles.input}
//                             placeholder="e.g., 300W"
//                           />
//                         </div>
//                         <div style={styles.specInput}>
//                           <span style={styles.specInputSpan}>Efficiency</span>
//                           <input
//                             type="text"
//                             name="spec_efficiency"
//                             value={newProduct.specifications.efficiency}
//                             onChange={handleProductInputChange}
//                             style={styles.input}
//                             placeholder="e.g., 18%"
//                           />
//                         </div>
//                         <div style={styles.specInput}>
//                           <span style={styles.specInputSpan}>Warranty</span>
//                           <input
//                             type="text"
//                             name="spec_warranty"
//                             value={newProduct.specifications.warranty}
//                             onChange={handleProductInputChange}
//                             style={styles.input}
//                             placeholder="e.g., 25 years"
//                           />
//                         </div>
//                         <div style={styles.specInput}>
//                           <span style={styles.specInputSpan}>Dimensions</span>
//                           <input
//                             type="text"
//                             name="spec_dimensions"
//                             value={newProduct.specifications.dimensions}
//                             onChange={handleProductInputChange}
//                             style={styles.input}
//                             placeholder="e.g., 1000x500x30mm"
//                           />
//                         </div>
//                         <div style={styles.specInput}>
//                           <span style={styles.specInputSpan}>Weight</span>
//                           <input
//                             type="text"
//                             name="spec_weight"
//                             value={newProduct.specifications.weight}
//                             onChange={handleProductInputChange}
//                             style={styles.input}
//                             placeholder="e.g., 15kg"
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Tags (comma separated)</label>
//                       <input
//                         type="text"
//                         name="tags"
//                         value={newProduct.tags}
//                         onChange={handleProductInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="e.g., solar, panel, renewable"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Product Image</label>
//                       <div
//                         style={styles.fileUpload}
//                         onMouseEnter={handleFileUploadHover}
//                         onMouseLeave={handleFileUploadLeave}
//                       >
//                         <input
//                           type="file"
//                           accept="image/*"
//                           onChange={(e) => handleFileUpload(e, "image")}
//                           style={{ display: "none" }}
//                           id="imageUpload"
//                         />
//                         <label
//                           htmlFor="imageUpload"
//                           style={{ cursor: "pointer", display: "block" }}
//                         >
//                           {newProduct.imagePreview ? (
//                             <div style={styles.uploadPreview}>
//                               <img
//                                 src={newProduct.imagePreview}
//                                 alt="Preview"
//                                 style={{
//                                   maxWidth: "100%",
//                                   maxHeight: "150px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </div>
//                           ) : (
//                             <div style={styles.uploadPlaceholder}>
//                               <div style={{fontSize: "2rem"}}>📷</div>
//                               <div>Click to upload product image</div>
//                               <small>Recommended: 800x600px (400KB - 600KB)</small>
//                             </div>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>PDF Brochure (Optional)</label>
//                       <div
//                         style={styles.fileUpload}
//                         onMouseEnter={handleFileUploadHover}
//                         onMouseLeave={handleFileUploadLeave}
//                       >
//                         <input
//                           type="file"
//                           accept=".pdf"
//                           onChange={(e) => handleFileUpload(e, "pdf")}
//                           style={{ display: "none" }}
//                           id="pdfUpload"
//                         />
//                         <label
//                           htmlFor="pdfUpload"
//                           style={{ cursor: "pointer", display: "block" }}
//                         >
//                           {newProduct.pdfFile ? (
//                             <div style={styles.uploadPreview}>
//                               <div style={{color: "#123249"}}>📄 {newProduct.pdfFile.name}</div>
//                             </div>
//                           ) : (
//                             <div style={styles.uploadPlaceholder}>
//                               <div style={{fontSize: "2rem"}}>📄</div>
//                               <div>Click to upload PDF brochure</div>
//                               <small>Optional product specification sheet</small>
//                             </div>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     <div style={styles.formCheckboxes}>
//                       <label style={styles.formCheckbox}>
//                         <input
//                           type="checkbox"
//                           name="isFeatured"
//                           checked={newProduct.isFeatured}
//                           onChange={handleProductInputChange}
//                         />
//                         <span style={{color: "#123249"}}>Featured Product</span>
//                       </label>
//                       <label style={styles.formCheckbox}>
//                         <input
//                           type="checkbox"
//                           name="isBestSeller"
//                           checked={newProduct.isBestSeller}
//                           onChange={handleProductInputChange}
//                         />
//                         <span style={{color: "#123249"}}>Best Seller</span>
//                       </label>
//                       <label style={styles.formCheckbox}>
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={newProduct.isActive}
//                           onChange={handleProductInputChange}
//                         />
//                         <span style={{color: "#123249"}}>Active (Show on website)</span>
//                       </label>
//                     </div>

//                     <button
//                       type="submit"
//                       style={styles.addBtn}
//                       onMouseEnter={handleAddBtnHover}
//                       onMouseLeave={handleAddBtnLeave}
//                     >
//                       ➕ Add Product
//                     </button>
//                   </form>
//                 </div>

//                 <div style={styles.productsListSection}>
//                   <div style={styles.listHeader}>
//                     <h3 style={{ margin: 0, color: "#123249" }}>
//                       All Products ({products.length})
//                     </h3>
//                     <div style={styles.listControls}>
//                       <button
//                         style={styles.refreshBtn}
//                         onClick={fetchProducts}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         🔄 Refresh
//                       </button>
//                     </div>
//                   </div>

//                   {isLoadingProducts ? (
//                     <div style={styles.loadingState}>
//                       <p>Loading products...</p>
//                     </div>
//                   ) : products.length === 0 ? (
//                     <div style={styles.loadingState}>
//                       <p>No products found. Add your first product!</p>
//                     </div>
//                   ) : (
//                     <div style={styles.productsList}>
//                       {products.map((product) => (
//                         <div
//                           key={product._id}
//                           style={styles.productItem}
//                           onMouseEnter={handleProductItemHover}
//                           onMouseLeave={handleProductItemLeave}
//                         >
//                           <div style={styles.productHeader}>
//                             <div style={styles.productImage}>
//                               {product.imageUrl ? (
//                                 <img
//                                   src={product.imageUrl}
//                                   alt={product.name}
//                                   style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     objectFit: "cover",
//                                     borderRadius: "8px",
//                                   }}
//                                 />
//                               ) : (
//                                 "📦"
//                               )}
//                             </div>
//                             <div style={styles.productInfo}>
//                               <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
//                                 {product.name}
//                               </h4>
//                               <div style={styles.productMeta}>
//                                 <span style={styles.productCategory}>
//                                   {product.category}
//                                 </span>
//                                 <span style={styles.productPrice}>
//                                   ₹{product.price}
//                                 </span>
//                                 {product.originalPrice &&
//                                   product.originalPrice !== product.price && (
//                                     <span style={styles.productDiscount}>
//                                       Save ₹
//                                       {calculateDiscountAmount(
//                                         product.price,
//                                         product.originalPrice
//                                       )}{" "}
//                                       ({calculateDiscountPercentage(
//                                         product.price,
//                                         product.originalPrice
//                                       )}
//                                       %)
//                                     </span>
//                                   )}
//                               </div>
//                               <div style={styles.productTags}>
//                                 {product.isFeatured && (
//                                   <span style={styles.tagFeatured}>
//                                     ⭐ Featured
//                                   </span>
//                                 )}
//                                 {product.isBestSeller && (
//                                   <span style={styles.tagBestseller}>
//                                     🏆 Best Seller
//                                   </span>
//                                 )}
//                                 {parseInt(product.stock || "0") < 10 && (
//                                   <span style={styles.tagLowstock}>
//                                     ⚠️ Low Stock
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                           </div>

//                           <p style={styles.productDescription}>
//                             {product.description}
//                           </p>

//                           <div style={styles.productDetails}>
//                             <div style={styles.productSpecs}>
//                               {product.specifications &&
//                                 Object.entries(product.specifications).map(
//                                   ([key, value]) =>
//                                     value && (
//                                       <div key={key} style={{color: "#123249"}}>
//                                         <strong>
//                                           {key.charAt(0).toUpperCase() +
//                                             key.slice(1)}:
//                                         </strong>{" "}
//                                         {value}
//                                       </div>
//                                     ))}
//                             </div>
//                           </div>

//                           <div style={styles.productActions}>
//                             <button
//                               style={styles.btnEdit}
//                               onClick={() => handleEditProduct(product._id)}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               ✏️ Edit
//                             </button>
//                             <button
//                               style={styles.btnDelete}
//                               onClick={() => handleDeleteProduct(product._id)}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               🗑️ Delete
//                             </button>
//                             <button
//                               style={styles.btnToggle}
//                               onClick={() =>
//                                 handleToggleProductStatus(
//                                   product._id,
//                                   product.isActive
//                                 )
//                               }
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               {product.isActive ? "👁️ Hide" : "👁️ Show"}
//                             </button>
//                             {product.pdfUrl && (
//                               <a
//                                 href={product.pdfUrl}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 style={styles.btnPdf}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 📄 PDF
//                               </a>
//                             )}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "industrial" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   🏭 Industrial Inquiries Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Manage and track all industrial-scale solar inquiries
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🏭</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Inquiries
//                     </h3>
//                     <div style={styles.statNumber}>{industrialStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🆕</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       New Today
//                     </h3>
//                     <div style={styles.statNumber}>{industrialStats.today}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📊</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Conversion Rate
//                     </h3>
//                     <div style={styles.statNumber}>{industrialStats.conversionRate}%</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🎯</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Priority High
//                     </h3>
//                     <div style={styles.statNumber}>{industrialStats.priority.high}</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.filterControls}>
//                 <select
//                   style={styles.filterSelect}
//                   value={industrialFilter}
//                   onChange={(e) => setIndustrialFilter(e.target.value)}
//                 >
//                   <option value="all">All Status</option>
//                   <option value="new">New</option>
//                   <option value="contacted">Contacted</option>
//                   <option value="quotation_sent">Quotation Sent</option>
//                   <option value="follow_up">Follow Up</option>
//                   <option value="closed_won">Closed Won</option>
//                   <option value="closed_lost">Closed Lost</option>
//                 </select>
//                 <select
//                   style={styles.filterSelect}
//                   value={industrialPriority}
//                   onChange={(e) => setIndustrialPriority(e.target.value)}
//                 >
//                   <option value="all">All Priorities</option>
//                   <option value="high">High</option>
//                   <option value="medium">Medium</option>
//                   <option value="low">Low</option>
//                 </select>
//                 <button
//                   style={styles.refreshBtn}
//                   onClick={fetchIndustrialInquiries}
//                   onMouseEnter={handleBtnHover}
//                   onMouseLeave={handleBtnLeave}
//                 >
//                   🔄 Refresh
//                 </button>
//               </div>

//               {isLoadingIndustrial ? (
//                 <div style={styles.loadingState}>
//                   <p>Loading industrial inquiries...</p>
//                 </div>
//               ) : industrialInquiries.length === 0 ? (
//                 <div style={styles.loadingState}>
//                   <p>No industrial inquiries found.</p>
//                 </div>
//               ) : (
//                 <div style={styles.productsListSection}>
//                   <table style={styles.consultationTable}>
//                     <thead>
//                       <tr>
//                         <th style={styles.tableHeader}>Company/Name</th>
//                         <th style={styles.tableHeader}>Contact Details</th>
//                         <th style={styles.tableHeader}>Project Details</th>
//                         <th style={styles.tableHeader}>Status</th>
//                         <th style={styles.tableHeader}>Priority</th>
//                         <th style={styles.tableHeader}>Date</th>
//                         <th style={styles.tableHeader}>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {industrialInquiries.map((inquiry) => (
//                         <tr key={inquiry._id}>
//                           <td style={styles.tableCell}>
//                             <strong style={{color: "#123249"}}>{inquiry.company}</strong>
//                             <br />
//                             <small style={{color: "#2D5A74"}}>{inquiry.name}</small>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{color: "#123249"}}>📧 {inquiry.email}</span>
//                             <br />
//                             <span style={{color: "#123249"}}>📞 {inquiry.phone}</span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <strong style={{color: "#123249"}}>Capacity:</strong> <span style={{color: "#2D5A74"}}>{inquiry.capacity || 'N/A'}</span>
//                             <br />
//                             <strong style={{color: "#123249"}}>Type:</strong> <span style={{color: "#2D5A74"}}>{inquiry.projectType || 'N/A'}</span>
//                             <br />
//                             <strong style={{color: "#123249"}}>Location:</strong> <span style={{color: "#2D5A74"}}>{inquiry.location}</span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <select
//                               value={inquiry.status || 'new'}
//                               onChange={(e) => handleUpdateIndustrialStatus(inquiry._id, e.target.value)}
//                               style={{
//                                 padding: '4px 8px',
//                                 borderRadius: '4px',
//                                 border: '1px solid #DDE8ED',
//                                 backgroundColor: 'white',
//                                 color: '#123249'
//                               }}
//                             >
//                               <option value="new">New</option>
//                               <option value="contacted">Contacted</option>
//                               <option value="quotation_sent">Quotation Sent</option>
//                               <option value="follow_up">Follow Up</option>
//                               <option value="closed_won">Closed Won</option>
//                               <option value="closed_lost">Closed Lost</option>
//                             </select>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{
//                               ...styles.priorityBadge,
//                               ...(inquiry.priority === 'high' ? styles.priorityHigh : 
//                                  inquiry.priority === 'medium' ? styles.priorityMedium : styles.priorityLow)
//                             }}>
//                               {inquiry.priority || 'medium'}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{color: "#123249"}}>{new Date(inquiry.createdAt).toLocaleDateString()}</span>
//                             <br />
//                             <small style={{color: "#2D5A74"}}>{new Date(inquiry.createdAt).toLocaleTimeString()}</small>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <div style={{ display: 'flex', gap: '5px' }}>
//                               <button
//                                 style={styles.btnEdit}
//                                 onClick={() => handleEditIndustrialInquiry(inquiry)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 ✏️ Edit
//                               </button>
//                               <button
//                                 style={styles.btnEdit}
//                                 onClick={() => handleAddNoteToIndustrial(inquiry._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 📝 Note
//                               </button>
//                               <button
//                                 style={styles.btnDelete}
//                                 onClick={() => handleDeleteIndustrialInquiry(inquiry._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 🗑️ Delete
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           )}

//           {activeTab === "contact" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📝 Contact Form Submissions
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Manage all contact form submissions from the website
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📥</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Submissions
//                     </h3>
//                     <div style={styles.statNumber}>{contactStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>🆕</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       New
//                     </h3>
//                     <div style={styles.statNumber}>{contactStats.new}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>👁️</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Read
//                     </h3>
//                     <div style={styles.statNumber}>{contactStats.read}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>↩️</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Replied
//                     </h3>
//                     <div style={styles.statNumber}>{contactStats.replied}</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.productsListSection}>
//                 <div style={styles.listHeader}>
//                   <h3 style={{ margin: 0, color: "#123249" }}>
//                     All Submissions ({contactSubmissions.length})
//                   </h3>
//                   <button
//                     style={styles.refreshBtn}
//                     onClick={fetchContacts}
//                     onMouseEnter={handleBtnHover}
//                     onMouseLeave={handleBtnLeave}
//                   >
//                     🔄 Refresh
//                   </button>
//                 </div>

//                 {isLoadingContacts ? (
//                   <div style={styles.loadingState}>
//                     <p>Loading submissions...</p>
//                   </div>
//                 ) : contactSubmissions.length === 0 ? (
//                   <div style={styles.loadingState}>
//                     <p>No contact submissions found.</p>
//                   </div>
//                 ) : (
//                   <div style={styles.submissionsList}>
//                     {contactSubmissions.map((submission) => (
//                       <div
//                         key={submission._id}
//                         style={styles.submissionItem}
//                         onMouseEnter={handleProductItemHover}
//                         onMouseLeave={handleProductItemLeave}
//                       >
//                         <div style={styles.submissionHeader}>
//                           <div style={styles.submissionInfo}>
//                             <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
//                               {submission.name}
//                             </h4>
//                             <div style={styles.submissionMeta}>
//                               <span>📧 {submission.email}</span>
//                               <span>📞 {submission.phone}</span>
//                               <span>📍 {submission.location || "Not specified"}</span>
//                               <span>
//                                 📅 {new Date(submission.createdAt).toLocaleDateString()}
//                               </span>
//                             </div>
//                           </div>
//                           <div style={styles.submissionStatus}>
//                             <span
//                               style={{
//                                 ...styles.statusBadge,
//                                 ...(submission.status === "new"
//                                   ? styles.statusNew
//                                   : submission.status === "read"
//                                   ? styles.statusRead
//                                   : styles.statusReplied),
//                               }}
//                             >
//                               {submission.status === "new"
//                                 ? "NEW"
//                                 : submission.status === "read"
//                                 ? "READ"
//                                 : "REPLIED"}
//                             </span>
//                           </div>
//                         </div>

//                         <div style={styles.submissionMessage}>
//                           <strong style={{color: "#123249"}}>Subject:</strong> <span style={{color: "#2D5A74"}}>{submission.subject}</span>
//                           <br />
//                           <br />
//                           <strong style={{color: "#123249"}}>Message:</strong>
//                           <br />
//                           <span style={{color: "#2D5A74"}}>{submission.message}</span>
//                         </div>

//                         <div style={styles.submissionActions}>
//                           <div style={styles.statusActions}>
//                             <button
//                               style={{
//                                 ...styles.btnStatus,
//                                 ...(submission.status === "new" && styles.btnStatusActive),
//                               }}
//                               onClick={() => handleUpdateStatus(submission._id, "new")}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               New
//                             </button>
//                             <button
//                               style={{
//                                 ...styles.btnStatus,
//                                 ...(submission.status === "read" && styles.btnStatusActive),
//                               }}
//                               onClick={() => handleUpdateStatus(submission._id, "read")}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               Read
//                             </button>
//                             <button
//                               style={{
//                                 ...styles.btnStatus,
//                                 ...(submission.status === "replied" && styles.btnStatusActive),
//                               }}
//                               onClick={() => handleUpdateStatus(submission._id, "replied")}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               Replied
//                             </button>
//                           </div>
//                           <div style={styles.managementActions}>
//                             <a
//                               href={`mailto:${submission.email}`}
//                               style={styles.btnReply}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               📧 Reply
//                             </a>
//                             <button
//                               style={styles.btnDelete}
//                               onClick={() => handleDeleteSubmission(submission._id)}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               🗑️ Delete
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {activeTab === "career" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   💼 Career & Job Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Manage job openings and career opportunities
//                 </p>
//               </div>

//               <div style={styles.managementGrid}>
//                 <div style={styles.addProductForm}>
//                   <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
//                     Add New Job Opening
//                   </h3>
//                   <form onSubmit={handleAddJob}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Job Title *</label>
//                       <input
//                         type="text"
//                         name="title"
//                         value={newJob.title}
//                         onChange={handleJobInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="e.g., Solar Installation Technician"
//                       />
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Location</label>
//                         <input
//                           type="text"
//                           name="location"
//                           value={newJob.location}
//                           onChange={handleJobInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., Mumbai, India"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Job Type</label>
//                         <select
//                           name="type"
//                           value={newJob.type}
//                           onChange={handleJobInputChange}
//                           style={styles.select}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                         >
//                           <option value="Full-time">Full-time</option>
//                           <option value="Part-time">Part-time</option>
//                           <option value="Contract">Contract</option>
//                           <option value="Internship">Internship</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Experience Required</label>
//                         <input
//                           type="text"
//                           name="experience"
//                           value={newJob.experience}
//                           onChange={handleJobInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., 2-5 years"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Department</label>
//                         <select
//                           name="department"
//                           value={newJob.department}
//                           onChange={handleJobInputChange}
//                           style={styles.select}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                         >
//                           <option value="Installation">Installation</option>
//                           <option value="Sales">Sales</option>
//                           <option value="Engineering">Engineering</option>
//                           <option value="Maintenance">Maintenance</option>
//                           <option value="Customer Service">Customer Service</option>
//                           <option value="Management">Management</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Job Description *</label>
//                       <textarea
//                         name="description"
//                         value={newJob.description}
//                         onChange={handleJobInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="Describe the job role and responsibilities..."
//                         rows="4"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Requirements</label>
//                       {newJob.requirements.map((req, index) => (
//                         <input
//                           key={index}
//                           type="text"
//                           value={req}
//                           onChange={(e) =>
//                             handleRequirementChange(index, e.target.value)
//                           }
//                           style={styles.featureInput}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder={`Requirement ${index + 1}`}
//                         />
//                       ))}
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Responsibilities</label>
//                       {newJob.responsibilities.map((resp, index) => (
//                         <input
//                           key={index}
//                           type="text"
//                           value={resp}
//                           onChange={(e) =>
//                             handleResponsibilityChange(index, e.target.value)
//                           }
//                           style={styles.featureInput}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder={`Responsibility ${index + 1}`}
//                         />
//                       ))}
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Benefits</label>
//                       {newJob.benefits.map((benefit, index) => (
//                         <input
//                           key={index}
//                           type="text"
//                           value={benefit}
//                           onChange={(e) =>
//                             handleBenefitChange(index, e.target.value)
//                           }
//                           style={styles.featureInput}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder={`Benefit ${index + 1}`}
//                         />
//                       ))}
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Salary (Optional)</label>
//                       <input
//                         type="text"
//                         name="salary"
//                         value={newJob.salary}
//                         onChange={handleJobInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="e.g., ₹25,000 - ₹40,000 per month"
//                       />
//                     </div>

//                     <div style={styles.formCheckboxes}>
//                       <label style={styles.formCheckbox}>
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={newJob.isActive}
//                           onChange={handleJobInputChange}
//                         />
//                         <span style={{color: "#123249"}}>Active (Show on website)</span>
//                       </label>
//                     </div>

//                     <button
//                       type="submit"
//                       style={styles.addBtn}
//                       onMouseEnter={handleAddBtnHover}
//                       onMouseLeave={handleAddBtnLeave}
//                     >
//                       ➕ Add Job Opening
//                     </button>
//                   </form>
//                 </div>

//                 <div style={styles.productsListSection}>
//                   <div style={styles.listHeader}>
//                     <h3 style={{ margin: 0, color: "#123249" }}>
//                       All Job Openings ({careerJobs.length})
//                     </h3>
//                     <button
//                       style={styles.refreshBtn}
//                       onClick={fetchJobs}
//                       onMouseEnter={handleBtnHover}
//                       onMouseLeave={handleBtnLeave}
//                     >
//                       🔄 Refresh
//                     </button>
//                   </div>

//                   {isLoadingJobs ? (
//                     <div style={styles.loadingState}>
//                       <p>Loading jobs...</p>
//                     </div>
//                   ) : careerJobs.length === 0 ? (
//                     <div style={styles.loadingState}>
//                       <p>No job openings found. Add your first job!</p>
//                     </div>
//                   ) : (
//                     <div style={styles.productsList}>
//                       {careerJobs.map((job) => (
//                         <div
//                           key={job._id}
//                           style={styles.productItem}
//                           onMouseEnter={handleProductItemHover}
//                           onMouseLeave={handleProductItemLeave}
//                         >
//                           <div style={styles.productHeader}>
//                             <div
//                               style={{
//                                 ...styles.productImage,
//                                 backgroundColor: "#DDE8ED",
//                               }}
//                             >
//                               💼
//                             </div>
//                             <div style={styles.productInfo}>
//                               <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
//                                 {job.title}
//                               </h4>
//                               <div style={styles.productMeta}>
//                                 <span style={styles.productCategory}>
//                                   {job.department}
//                                 </span>
//                                 <span style={styles.productPrice}>
//                                   {job.location}
//                                 </span>
//                                 <span
//                                   style={{
//                                     backgroundColor: "#DDE8ED",
//                                     color: "#123249",
//                                     padding: "3px 10px",
//                                     borderRadius: "12px",
//                                     fontSize: "0.8rem",
//                                   }}
//                                 >
//                                   {job.type}
//                                 </span>
//                               </div>
//                               <div style={styles.productTags}>
//                                 {job.isActive ? (
//                                   <span
//                                     style={{
//                                       backgroundColor: "#447793",
//                                       color: "white",
//                                       padding: "3px 8px",
//                                       borderRadius: "4px",
//                                       fontSize: "0.75rem",
//                                     }}
//                                   >
//                                     ✅ Active
//                                   </span>
//                                 ) : (
//                                   <span
//                                     style={{
//                                       backgroundColor: "#2D5A74",
//                                       color: "white",
//                                       padding: "3px 8px",
//                                       borderRadius: "4px",
//                                       fontSize: "0.75rem",
//                                     }}
//                                   >
//                                     ⏸️ Inactive
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                           </div>

//                           <p style={styles.productDescription}>
//                             {job.description}
//                           </p>

//                           <div style={styles.productDetails}>
//                             <div style={styles.productSpecs}>
//                               <div style={{color: "#123249"}}>
//                                 <strong>Experience:</strong> <span style={{color: "#2D5A74"}}>{job.experience}</span>
//                               </div>
//                               {job.salary && (
//                                 <div style={{color: "#123249"}}>
//                                   <strong>Salary:</strong> <span style={{color: "#2D5A74"}}>{job.salary}</span>
//                                 </div>
//                               )}
//                               {job.requirements && job.requirements.length > 0 && (
//                                 <div style={{ gridColumn: "span 2" }}>
//                                   <strong style={{color: "#123249"}}>Requirements:</strong>
//                                   <ul style={{ margin: "5px 0 0 20px", color: "#2D5A74" }}>
//                                     {job.requirements.map((req, index) => (
//                                       <li key={index}>{req}</li>
//                                     ))}
//                                   </ul>
//                                 </div>
//                               )}
//                             </div>
//                           </div>

//                           <div style={styles.productActions}>
//                             <button
//                               style={styles.btnEdit}
//                               onClick={() => handleEditJob(job._id)}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               ✏️ Edit
//                             </button>
//                             <button
//                               style={styles.btnDelete}
//                               onClick={() => handleDeleteJob(job._id)}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               🗑️ Delete
//                             </button>
//                             <button
//                               style={styles.btnToggle}
//                               onClick={() =>
//                                 handleToggleJobStatus(job._id, job.isActive)
//                               }
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               {job.isActive ? "⏸️ Deactivate" : "▶️ Activate"}
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "mainpage" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   ℹ️ Main Page Content Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Customize the main page content, sections, and layout
//                 </p>
//               </div>

//               <div style={styles.managementGrid}>
//                 <div style={styles.addProductForm}>
//                   <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
//                     Add New Main Page Section
//                   </h3>
//                   <form onSubmit={handleAddSection}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Section Title *</label>
//                       <input
//                         type="text"
//                         name="title"
//                         value={newSection.title}
//                         onChange={handleSectionInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="e.g., MODERN ENERGY SOLUTIONS"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Subtitle</label>
//                       <input
//                         type="text"
//                         name="subtitle"
//                         value={newSection.subtitle}
//                         onChange={handleSectionInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="e.g., Comprehensive energy solutions"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Description</label>
//                       <textarea
//                         name="description"
//                         value={newSection.description}
//                         onChange={handleSectionInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="Detailed description of this section..."
//                         rows="4"
//                       />
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Section Type</label>
//                         <select
//                           name="sectionType"
//                           value={newSection.sectionType}
//                           onChange={handleSectionInputChange}
//                           style={styles.select}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                         >
//                           <option value="hero">Hero Section</option>
//                           <option value="solution">Solution Section</option>
//                           <option value="service">Service Section</option>
//                           <option value="feature">Feature Section</option>
//                           <option value="testimonial">Testimonial</option>
//                         </select>
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Icon</label>
//                         <input
//                           type="text"
//                           name="icon"
//                           value={newSection.icon}
//                           onChange={handleSectionInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., ☀️"
//                         />
//                       </div>
//                     </div>

//                     {newSection.sectionType === "service" && (
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Features (For Service Sections)</label>
//                         {newSection.features.map((feature, index) => (
//                           <input
//                             key={index}
//                             type="text"
//                             value={feature}
//                             onChange={(e) =>
//                               handleFeatureChangeSection(index, e.target.value)
//                             }
//                             style={styles.featureInput}
//                             onFocus={handleInputFocus}
//                             onBlur={handleInputBlur}
//                             placeholder={`Feature ${index + 1}`}
//                           />
//                         ))}
//                       </div>
//                     )}

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Button Text</label>
//                         <input
//                           type="text"
//                           name="buttonText"
//                           value={newSection.buttonText}
//                           onChange={handleSectionInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., Learn More"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Button Link</label>
//                         <input
//                           type="text"
//                           name="buttonLink"
//                           value={newSection.buttonLink}
//                           onChange={handleSectionInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., /solutions"
//                         />
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Section Image</label>
//                       <div
//                         style={styles.fileUpload}
//                         onMouseEnter={handleFileUploadHover}
//                         onMouseLeave={handleFileUploadLeave}
//                       >
//                         <input
//                           type="file"
//                           accept="image/*"
//                           onChange={(e) => {
//                             const file = e.target.files[0];
//                             if (file) {
//                               const reader = new FileReader();
//                               reader.onloadend = () => {
//                                 setNewSection((prev) => ({
//                                   ...prev,
//                                   image: file,
//                                   imagePreview: reader.result,
//                                 }));
//                               };
//                               reader.readAsDataURL(file);
//                             }
//                           }}
//                           style={{ display: "none" }}
//                           id="sectionImageUpload"
//                         />
//                         <label
//                           htmlFor="sectionImageUpload"
//                           style={{ cursor: "pointer", display: "block" }}
//                         >
//                           {newSection.imagePreview ? (
//                             <div style={styles.uploadPreview}>
//                               <img
//                                 src={newSection.imagePreview}
//                                 alt="Preview"
//                                 style={{
//                                   maxWidth: "100%",
//                                   maxHeight: "150px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </div>
//                           ) : (
//                             <div style={styles.uploadPlaceholder}>
//                               <div style={{fontSize: "2rem"}}>🖼️</div>
//                               <div>Click to upload section image</div>
//                               <small>Recommended: 1200x600px</small>
//                             </div>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     <button
//                       type="submit"
//                       style={styles.addBtn}
//                       onMouseEnter={handleAddBtnHover}
//                       onMouseLeave={handleAddBtnLeave}
//                     >
//                       ➕ Add Section
//                     </button>
//                   </form>
//                 </div>

//                 <div style={styles.productsListSection}>
//                   <div style={styles.listHeader}>
//                     <h3 style={{ margin: 0, color: "#123249" }}>
//                       Main Page Sections ({mainPageSections.length})
//                     </h3>
//                   </div>

//                   <div style={styles.productsList}>
//                     {mainPageSections.map((section) => (
//                       <div
//                         key={section.id}
//                         style={styles.productItem}
//                         onMouseEnter={handleProductItemHover}
//                         onMouseLeave={handleProductItemLeave}
//                       >
//                         <div style={styles.productHeader}>
//                           <div
//                             style={{
//                               ...styles.productImage,
//                               backgroundColor: "#DDE8ED",
//                             }}
//                           >
//                             {section.icon || "ℹ️"}
//                           </div>
//                           <div style={styles.productInfo}>
//                             <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
//                               {section.title}
//                             </h4>
//                             <div style={styles.productMeta}>
//                               <span
//                                 style={{
//                                   backgroundColor:
//                                     section.sectionType === "hero"
//                                       ? "#DDE8ED"
//                                       : section.sectionType === "solution"
//                                       ? "#447793"
//                                       : "#2D5A74",
//                                   color:
//                                     section.sectionType === "hero"
//                                       ? "#123249"
//                                       : "white",
//                                   padding: "3px 10px",
//                                   borderRadius: "12px",
//                                   fontSize: "0.8rem",
//                                 }}
//                               >
//                                 {section.sectionType.toUpperCase()}
//                               </span>
//                               <span
//                                 style={{
//                                   backgroundColor: "#DDE8ED",
//                                   color: "#123249",
//                                   padding: "3px 10px",
//                                   borderRadius: "12px",
//                                   fontSize: "0.8rem",
//                                 }}
//                               >
//                                 {section.buttonText}
//                               </span>
//                             </div>
//                             <p style={{ margin: "10px 0 0", fontSize: "0.9rem", color: "#2D5A74" }}>
//                               {section.subtitle}
//                             </p>
//                           </div>
//                         </div>

//                         {section.description && (
//                           <p style={styles.productDescription}>
//                             {section.description}
//                           </p>
//                         )}

//                         {section.features && section.features.length > 0 && (
//                           <div style={styles.productDetails}>
//                             <strong style={{color: "#123249"}}>Features:</strong>
//                             <ul style={{ margin: "5px 0 0 20px", color: "#2D5A74" }}>
//                               {section.features.map((feature, index) => (
//                                 <li key={index}>{feature}</li>
//                               ))}
//                             </ul>
//                           </div>
//                         )}

//                         <div style={styles.productActions}>
//                           <button
//                             style={styles.btnEdit}
//                             onClick={() => handleEditSection(section.id)}
//                             onMouseEnter={handleBtnHover}
//                             onMouseLeave={handleBtnLeave}
//                           >
//                             ✏️ Edit
//                           </button>
//                           <button
//                             style={styles.btnDelete}
//                             onClick={() => handleDeleteSection(section.id)}
//                             onMouseEnter={handleBtnHover}
//                             onMouseLeave={handleBtnLeave}
//                           >
//                             🗑️ Delete
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "news" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   📰 News Management
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Add, edit, and manage news articles for the website
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📰</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Articles
//                     </h3>
//                     <div style={styles.statNumber}>{newsStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>✅</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Active
//                     </h3>
//                     <div style={styles.statNumber}>{newsStats.active}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📅</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Today
//                     </h3>
//                     <div style={styles.statNumber}>{newsStats.today}</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.managementGrid}>
//                 <div style={styles.addProductForm}>
//                   <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
//                     Add New News Article
//                   </h3>
//                   <form onSubmit={handleAddNews}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Title *</label>
//                       <input
//                         type="text"
//                         name="title"
//                         value={newNews.title}
//                         onChange={handleNewsInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="Enter news title"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Headline/Subtitle</label>
//                       <input
//                         type="text"
//                         name="headline"
//                         value={newNews.headline}
//                         onChange={handleNewsInputChange}
//                         style={styles.input}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         placeholder="Enter headline or subtitle"
//                       />
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Source</label>
//                         <input
//                           type="text"
//                           name="source"
//                           value={newNews.source}
//                           onChange={handleNewsInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., Business Standard"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Source Location</label>
//                         <input
//                           type="text"
//                           name="sourceLocation"
//                           value={newNews.sourceLocation}
//                           onChange={handleNewsInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="e.g., Mumbai"
//                         />
//                       </div>
//                     </div>

//                     <div style={styles.formRow}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Author</label>
//                         <input
//                           type="text"
//                           name="author"
//                           value={newNews.author}
//                           onChange={handleNewsInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           placeholder="Enter author name"
//                         />
//                       </div>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Date *</label>
//                         <input
//                           type="date"
//                           name="date"
//                           value={newNews.date}
//                           onChange={handleNewsInputChange}
//                           style={styles.input}
//                           onFocus={handleInputFocus}
//                           onBlur={handleInputBlur}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Summary *</label>
//                       <textarea
//                         name="summary"
//                         value={newNews.summary}
//                         onChange={handleNewsInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="Brief summary of the news (2-3 sentences)"
//                         rows="3"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>Full Content *</label>
//                       <textarea
//                         name="content"
//                         value={newNews.content}
//                         onChange={handleNewsInputChange}
//                         style={styles.textarea}
//                         onFocus={handleInputFocus}
//                         onBlur={handleInputBlur}
//                         required
//                         placeholder="Full news article content..."
//                         rows="8"
//                       />
//                     </div>

//                     <div style={styles.formGroup}>
//                       <label style={styles.label}>News Image</label>
//                       <div
//                         style={styles.fileUpload}
//                         onMouseEnter={handleFileUploadHover}
//                         onMouseLeave={handleFileUploadLeave}
//                       >
//                         <input
//                           type="file"
//                           accept="image/*"
//                           onChange={handleNewsImageUpload}
//                           style={{ display: "none" }}
//                           id="newsImageUpload"
//                         />
//                         <label
//                           htmlFor="newsImageUpload"
//                           style={{ cursor: "pointer", display: "block" }}
//                         >
//                           {newNews.imagePreview ? (
//                             <div style={styles.uploadPreview}>
//                               <img
//                                 src={newNews.imagePreview}
//                                 alt="Preview"
//                                 style={{
//                                   maxWidth: "100%",
//                                   maxHeight: "150px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </div>
//                           ) : (
//                             <div style={styles.uploadPlaceholder}>
//                               <div style={{ fontSize: "2rem" }}>📰</div>
//                               <div>Click to upload news image</div>
//                               <small>Recommended: 1200x600px (Max 2MB)</small>
//                             </div>
//                           )}
//                         </label>
//                       </div>
//                     </div>

//                     <div style={styles.formCheckboxes}>
//                       <label style={styles.formCheckbox}>
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={newNews.isActive}
//                           onChange={handleNewsInputChange}
//                         />
//                         <span style={{ color: "#123249" }}>Active (Show on website)</span>
//                       </label>
//                     </div>

//                     <button
//                       type="submit"
//                       style={styles.addBtn}
//                       onMouseEnter={handleAddBtnHover}
//                       onMouseLeave={handleAddBtnLeave}
//                     >
//                       ➕ Add News Article
//                     </button>
//                   </form>
//                 </div>

//                 <div style={styles.productsListSection}>
//                   <div style={styles.listHeader}>
//                     <h3 style={{ margin: 0, color: "#123249" }}>
//                       All News Articles ({news.length})
//                     </h3>
//                     <div style={styles.listControls}>
//                       <button
//                         style={styles.refreshBtn}
//                         onClick={() => {
//                           fetchNews();
//                           fetchNewsStats();
//                         }}
//                         onMouseEnter={handleBtnHover}
//                         onMouseLeave={handleBtnLeave}
//                       >
//                         🔄 Refresh
//                       </button>
//                     </div>
//                   </div>

//                   {isLoadingNews ? (
//                     <div style={styles.loadingState}>
//                       <p>Loading news articles...</p>
//                     </div>
//                   ) : news.length === 0 ? (
//                     <div style={styles.loadingState}>
//                       <p>No news articles found. Add your first article!</p>
//                     </div>
//                   ) : (
//                     <div style={styles.newsGrid}>
//                       {news.map((item) => (
//                         <div
//                           key={item._id}
//                           style={styles.newsCard}
//                           onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = "translateY(-5px)";
//                             e.currentTarget.style.boxShadow = "0 10px 20px rgba(68,119,147,0.1)";
//                           }}
//                           onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = "translateY(0)";
//                             e.currentTarget.style.boxShadow = "none";
//                           }}
//                         >
//                           <img
//                             src={item.imageUrl || item.image || 'https://via.placeholder.com/300x180?text=No+Image'}
//                             alt={item.title}
//                             style={styles.newsImage}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = 'https://via.placeholder.com/300x180?text=No+Image';
//                             }}
//                           />
//                           <div style={styles.newsContent}>
//                             <h4 style={styles.newsTitle}>{item.title}</h4>
//                             <div style={styles.newsMeta}>
//                               <span>📅 {new Date(item.date).toLocaleDateString()}</span>
//                               {item.source && <span>📰 {item.source}</span>}
//                             </div>
//                             <p style={styles.newsSummary}>
//                               {item.summary.length > 100 
//                                 ? item.summary.substring(0, 100) + '...' 
//                                 : item.summary}
//                             </p>
//                             <div style={styles.newsActions}>
//                               <button
//                                 style={styles.btnEdit}
//                                 onClick={() => handleEditNews(item._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 ✏️ Edit
//                               </button>
//                               <button
//                                 style={styles.btnDelete}
//                                 onClick={() => handleDeleteNews(item._id)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 🗑️ Delete
//                               </button>
//                               <button
//                                 style={styles.btnToggle}
//                                 onClick={() => handleToggleNewsStatus(item._id, item.isActive)}
//                                 onMouseEnter={handleBtnHover}
//                                 onMouseLeave={handleBtnLeave}
//                               >
//                                 {item.isActive ? "🔴 Hide" : "🟢 Show"}
//                               </button>
//                             </div>
//                             <div style={{ marginTop: "10px" }}>
//                               <span style={{
//                                 ...styles.statusBadgeNews,
//                                 ...(item.isActive ? styles.statusActive : styles.statusInactive)
//                               }}>
//                                 {item.isActive ? 'Active' : 'Inactive'}
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "freeDemos" && (
//             <div>
//               <div style={styles.pageHeader}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
//                   🆓 Free Demo & Site Visit Requests
//                 </h2>
//                 <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
//                   Manage all free demo and site visit requests from customers
//                 </p>
//               </div>

//               <div style={styles.submissionsStats}>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📋</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Total Requests
//                     </h3>
//                     <div style={styles.statNumber}>{freeDemoStats.total}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>⏳</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Pending
//                     </h3>
//                     <div style={styles.statNumber}>{freeDemoStats.pending}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>✅</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Confirmed
//                     </h3>
//                     <div style={styles.statNumber}>{freeDemoStats.confirmed}</div>
//                   </div>
//                 </div>
//                 <div style={styles.statCard}>
//                   <div style={styles.statIcon}>📅</div>
//                   <div style={styles.statInfo}>
//                     <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
//                       Today's Requests
//                     </h3>
//                     <div style={styles.statNumber}>{freeDemoStats.today}</div>
//                   </div>
//                 </div>
//               </div>

//               <div style={styles.filterControls}>
//                 <select
//                   style={styles.filterSelect}
//                   value={freeDemoFilter}
//                   onChange={(e) => setFreeDemoFilter(e.target.value)}
//                 >
//                   <option value="all">All Status</option>
//                   <option value="pending">Pending</option>
//                   <option value="confirmed">Confirmed</option>
//                   <option value="completed">Completed</option>
//                   <option value="cancelled">Cancelled</option>
//                 </select>
//                 <button
//                   style={styles.refreshBtn}
//                   onClick={fetchFreeDemos}
//                   onMouseEnter={handleBtnHover}
//                   onMouseLeave={handleBtnLeave}
//                 >
//                   🔄 Refresh
//                 </button>
//               </div>

//               {isLoadingFreeDemos ? (
//                 <div style={styles.loadingState}>
//                   <p>Loading free demo requests...</p>
//                 </div>
//               ) : freeDemos.length === 0 ? (
//                 <div style={styles.loadingState}>
//                   <p>No free demo requests found.</p>
//                 </div>
//               ) : (
//                 <div style={styles.demoGrid}>
//                   {freeDemos
//                     .filter(demo => freeDemoFilter === 'all' || demo.status === freeDemoFilter)
//                     .map((demo) => (
//                       <div
//                         key={demo._id}
//                         style={styles.demoCard}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform = "translateY(-5px)";
//                           e.currentTarget.style.boxShadow = "0 10px 20px rgba(68,119,147,0.1)";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform = "translateY(0)";
//                           e.currentTarget.style.boxShadow = "none";
//                         }}
//                       >
//                         <div style={styles.demoHeader}>
//                           <div>
//                             <h3 style={styles.demoName}>{demo.name}</h3>
//                             <div style={styles.demoPhone}>
//                               <span>📞</span> {demo.phone}
//                             </div>
//                             {demo.email && (
//                               <div style={styles.demoPhone}>
//                                 <span>📧</span> {demo.email}
//                               </div>
//                             )}
//                           </div>
//                           <span style={{
//                             ...styles.statusBadge,
//                             ...(demo.status === 'pending' ? styles.statusNew :
//                                demo.status === 'confirmed' ? styles.statusRead :
//                                demo.status === 'completed' ? styles.statusReplied :
//                                { backgroundColor: '#2D5A74', color: 'white' })
//                           }}>
//                             {demo.status.toUpperCase()}
//                           </span>
//                         </div>

//                         <div style={styles.demoDetails}>
//                           <div style={styles.demoDetailRow}>
//                             <span>📍</span> {demo.address}
//                           </div>
//                           <div style={styles.demoDetailRow}>
//                             <span>🏙️</span> {demo.city}, {demo.pincode}
//                           </div>
//                         </div>

//                         <div style={styles.demoSchedule}>
//                           <div style={styles.demoScheduleTitle}>📅 Preferred Schedule</div>
//                           <div style={styles.demoDetailRow}>
//                             <span>🗓️</span> {new Date(demo.preferredDate).toLocaleDateString()}
//                           </div>
//                           <div style={styles.demoDetailRow}>
//                             <span>⏰</span> {demo.preferredTime === 'morning' ? 'Morning (9 AM - 12 PM)' :
//                                              demo.preferredTime === 'afternoon' ? 'Afternoon (12 PM - 3 PM)' :
//                                              'Evening (3 PM - 6 PM)'}
//                           </div>
//                         </div>

//                         {demo.productName && (
//                           <div style={styles.demoProductInfo}>
//                             <strong style={{color: "#123249"}}>Product Interest:</strong>
//                             <div style={{color: "#447793", marginTop: "5px"}}>{demo.productName}</div>
//                           </div>
//                         )}

//                         {demo.message && (
//                           <div style={styles.demoNotes}>
//                             <strong style={{color: "#123249"}}>📝 Message:</strong>
//                             <p style={{margin: "5px 0 0", color: "#2D5A74"}}>{demo.message}</p>
//                           </div>
//                         )}

//                         {demo.notes && demo.notes.length > 0 && (
//                           <div style={styles.demoNotes}>
//                             <strong style={{color: "#123249"}}>📋 Admin Notes:</strong>
//                             {demo.notes.map((note, idx) => (
//                               <div key={idx} style={{marginTop: "5px", fontSize: "0.85rem", color: "#2D5A74"}}>
//                                 <span style={styles.demoNoteBadge}>Note {idx + 1}</span>
//                                 {note.note} 
//                                 <small style={{display: "block", color: "#447793", fontSize: "0.7rem"}}>
//                                   - {note.addedBy} at {new Date(note.createdAt).toLocaleString()}
//                                 </small>
//                               </div>
//                             ))}
//                           </div>
//                         )}

//                         <div style={{marginBottom: "15px"}}>
//                           <select
//                             value={demo.status}
//                             onChange={(e) => handleUpdateDemoStatus(demo._id, e.target.value)}
//                             style={styles.demoStatusSelect}
//                           >
//                             <option value="pending">Pending</option>
//                             <option value="confirmed">Confirmed</option>
//                             <option value="completed">Completed</option>
//                             <option value="cancelled">Cancelled</option>
//                           </select>
//                         </div>

//                         <div style={styles.demoActions}>
//                           <button
//                             style={styles.btnEdit}
//                             onClick={() => handleAddDemoNote(demo._id)}
//                             onMouseEnter={handleBtnHover}
//                             onMouseLeave={handleBtnLeave}
//                           >
//                             📝 Add Note
//                           </button>
//                           <button
//                             style={styles.btnDelete}
//                             onClick={() => handleDeleteDemo(demo._id)}
//                             onMouseEnter={handleBtnHover}
//                             onMouseLeave={handleBtnLeave}
//                           >
//                             🗑️ Delete
//                           </button>
//                           <a
//                             href={`tel:${demo.phone}`}
//                             style={styles.btnToggle}
//                             onMouseEnter={handleBtnHover}
//                             onMouseLeave={handleBtnLeave}
//                           >
//                             📞 Call
//                           </a>
//                           {demo.email && (
//                             <a
//                               href={`mailto:${demo.email}`}
//                               style={styles.btnPdf}
//                               onMouseEnter={handleBtnHover}
//                               onMouseLeave={handleBtnLeave}
//                             >
//                               📧 Email
//                             </a>
//                           )}
//                         </div>

//                         <div style={{marginTop: "10px", fontSize: "0.8rem", color: "#2D5A74", textAlign: "center"}}>
//                           Requested on: {new Date(demo.createdAt).toLocaleString()}
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               )}
//             </div>
//           )}

//           {activeTab === "invoice" && (
//             <div style={{ marginTop: '20px' }}>
//               <Invoice />
//             </div>
//           )}

//           {activeTab === "quotation" && (
//             <div style={{ marginTop: '20px' }}>
//               <Quotation />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;
































// components/Admin/AdminDashboard.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from '../../context/AuthContext';
import Invoice from './Invoice';
import Quotation from './Quotation';

const API_BASE = "http://localhost:5000/api";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, isAdmin, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [isLoading, setIsLoading] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileDropdownRef = useRef(null);

  // Dashboard stats
  const [dashboardStats, setDashboardStats] = useState({
    totalProducts: 0,
    totalCategories: 9,
    totalInquiries: 0,
    monthlySales: "₹0",
    pendingQuotes: 0,
    conversionRate: "0%",
    visitors: 0,
    revenue: "₹0",
    industrial: 0,
    totalConsultations: 0,
    loginAttempts: 0,
    todayLoginAttempts: 0,
    totalNews: 0,
    totalFreeDemos: 0
  });

  // Consultation state
  const [consultations, setConsultations] = useState([]);
  const [isLoadingConsultations, setIsLoadingConsultations] = useState(false);
  const [consultationStats, setConsultationStats] = useState({
    total: 0,
    today: 0,
    recent: 0,
    conversionRate: 0,
    status: {
      new: 0,
      contacted: 0,
      follow_up: 0,
      quotation_sent: 0,
      closed_won: 0,
      closed_lost: 0
    },
    priority: {
      low: 0,
      medium: 0,
      high: 0
    },
    byType: {
      residential: 0,
      commercial: 0,
      industrial: 0
    }
  });
  const [consultationFilter, setConsultationFilter] = useState('all');

  // Products state
  const [products, setProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [productStats, setProductStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    featured: 0,
    bestSellers: 0,
    byCategory: [],
    priceStats: {},
  });

  const [newProduct, setNewProduct] = useState({
    name: "",
    category: "Solar Panels",
    price: "",
    originalPrice: "",
    description: "",
    fullDescription: "",
    rating: "4.5",
    reviews: "0",
    stock: "100",
    features: ["", "", "", ""],
    specifications: {
      power: "",
      efficiency: "",
      warranty: "",
      dimensions: "",
      weight: "",
    },
    tags: "",
    isFeatured: false,
    isBestSeller: false,
    isActive: true,
    image: null,
    imagePreview: "",
    pdfFile: null,
    pdfPreview: "",
  });

  // Login Attempts state
  const [loginAttempts, setLoginAttempts] = useState([]);
  const [loginStats, setLoginStats] = useState({
    total: 0,
    successful: 0,
    admin: 0,
    today: 0,
    successRate: 0
  });
  const [isLoadingLoginAttempts, setIsLoadingLoginAttempts] = useState(false);

  // Slideshow state
  const [slides, setSlides] = useState([]);
  const [newSlide, setNewSlide] = useState({
    title: "",
    subtitle: "",
    buttonText: "Explore",
    buttonLink: "#",
    image: null,
    imagePreview: "",
  });

  // Best Sellers state
  const [bestSellers, setBestSellers] = useState([]);
  const [newBestSeller, setNewBestSeller] = useState({
    title: "",
    originalPrice: "",
    currentPrice: "",
    saveAmount: "",
    rating: "4.5",
    reviews: "0",
    buttonText: "Enquire Now",
    buttonLink: "#",
    image: null,
    imagePreview: "",
    pdfFile: null,
    pdfPreview: "",
    isActive: true,
  });

  // Categories state
  const [categories, setCategories] = useState([
    "All Products",
    "Solar Panels",
    "Inverters",
    "Batteries",
    "Controllers",
    "Accessories",
    "Complete Kits",
    "Water Heaters",
    "Solar Lighting",
  ]);

  const [newCategory, setNewCategory] = useState({
    name: "",
    icon: "📦",
  });

  // Main Page Sections state
  const [mainPageSections, setMainPageSections] = useState([
    {
      id: 1,
      title: "MODERN ENERGY SOLUTIONS",
      subtitle: "Comprehensive energy solutions tailored to your needs",
      description: "",
      image: "/images/main-hero.jpg",
      imagePreview: "",
      buttonText: "Learn More",
      buttonLink: "/solutions",
      sectionType: "hero",
    },
    {
      id: 2,
      title: "Onsite Solar",
      subtitle: "Make progress toward decarbonization",
      description:
        "Make progress toward decarbonization and expedite the transition to clean energy with minimized risk and complexity—all without upfront capital expenditures.",
      image: "/images/solar-section.jpg",
      imagePreview: "",
      buttonText: "Learn More →",
      buttonLink: "/solar",
      sectionType: "solution",
      icon: "☀️",
    },
    {
      id: 3,
      title: "Energy Storage",
      subtitle: "Optimize and access reliable energy",
      description:
        "Optimize and access reliable, cost-effective energy through advanced commercial and industrial energy storage solutions, safeguarding your facility from power outages and interruptions.",
      image: "/images/storage-section.jpg",
      imagePreview: "",
      buttonText: "Learn More →",
      buttonLink: "/storage",
      sectionType: "solution",
      icon: "🔋",
    },
    {
      id: 4,
      title: "Expert Solar Installation",
      subtitle: "Professional installation with precision and care",
      description:
        "Our certified technicians provide professional solar panel installation with precision and care. We ensure optimal positioning for maximum energy generation and long-term reliability.",
      image: "/images/installation-section.jpg",
      imagePreview: "",
      buttonText: "Get Quote →",
      buttonLink: "/installation",
      sectionType: "service",
      features: [
        "Certified technicians",
        "Optimal positioning",
        "Quality materials",
        "Quick installation",
      ],
    },
  ]);

  const [newSection, setNewSection] = useState({
    title: "",
    subtitle: "",
    description: "",
    image: null,
    imagePreview: "",
    buttonText: "Learn More",
    buttonLink: "#",
    sectionType: "hero",
    icon: "☀️",
    features: ["", "", "", ""],
  });

  // Contact Form Submissions state
  const [contactSubmissions, setContactSubmissions] = useState([]);
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);
  const [contactStats, setContactStats] = useState({
    total: 0,
    new: 0,
    read: 0,
    replied: 0,
  });

  // Career Jobs state
  const [careerJobs, setCareerJobs] = useState([]);
  const [isLoadingJobs, setIsLoadingJobs] = useState(false);
  const [jobStats, setJobStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    byDepartment: [],
  });

  const [newJob, setNewJob] = useState({
    title: "",
    location: "",
    type: "Full-time",
    experience: "",
    department: "Installation",
    description: "",
    requirements: ["", "", "", ""],
    responsibilities: ["", "", "", ""],
    benefits: ["", "", ""],
    salary: "",
    isActive: true,
  });

  // Industrial Inquiries state
  const [industrialInquiries, setIndustrialInquiries] = useState([]);
  const [industrialStats, setIndustrialStats] = useState({
    total: 0,
    today: 0,
    recent: 0,
    conversionRate: 0,
    status: {
      new: 0,
      contacted: 0,
      quotation_sent: 0,
      follow_up: 0,
      closed_won: 0,
      closed_lost: 0
    },
    priority: {
      high: 0,
      medium: 0,
      low: 0
    },
    capacity: {}
  });
  const [isLoadingIndustrial, setIsLoadingIndustrial] = useState(false);
  const [industrialFilter, setIndustrialFilter] = useState('all');
  const [industrialPriority, setIndustrialPriority] = useState('all');

  // Consultation Form Data state
  const [consultationFormData, setConsultationFormData] = useState({
    formType: "residential",
    fullName: "",
    firmName: "",
    email: "",
    whatsappNumber: "",
    monthlyBill: "",
    pincode: "",
    city: "",
    calculatorName: "",
    calculatorPhone: "",
    roofArea: "",
    calculatorMonthlyBill: "",
    location: "Mumbai",
    estimatedSavings: ""
  });

  // ====== NEWS MANAGEMENT STATE ======
  const [news, setNews] = useState([]);
  const [isLoadingNews, setIsLoadingNews] = useState(false);
  const [newsStats, setNewsStats] = useState({
    total: 0,
    active: 0,
    today: 0
  });

  const [newNews, setNewNews] = useState({
    title: "",
    headline: "",
    content: "",
    summary: "",
    date: new Date().toISOString().split('T')[0],
    image: null,
    imagePreview: "",
    source: "",
    sourceLocation: "",
    author: "",
    isActive: true
  });

  // ====== FREE DEMO STATE ======
  const [freeDemos, setFreeDemos] = useState([]);
  const [isLoadingFreeDemos, setIsLoadingFreeDemos] = useState(false);
  const [freeDemoStats, setFreeDemoStats] = useState({
    total: 0,
    pending: 0,
    confirmed: 0,
    completed: 0,
    cancelled: 0,
    today: 0,
    byProduct: [],
    byCity: [],
    byTime: []
  });
  const [freeDemoFilter, setFreeDemoFilter] = useState('all');

  // ====== HANDLER FUNCTIONS FOR MOUSE EVENTS ======
  const handleBtnHover = (e) => {
    e.currentTarget.style.opacity = "0.9";
    e.currentTarget.style.transform = "translateY(-1px)";
  };

  const handleBtnLeave = (e) => {
    e.currentTarget.style.opacity = "1";
    e.currentTarget.style.transform = "translateY(0)";
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-5px)";
    e.currentTarget.style.boxShadow = "0 10px 20px rgba(68,119,147,0.1)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  const handleInputFocus = (e) => {
    e.currentTarget.style.borderColor = "#447793";
  };

  const handleInputBlur = (e) => {
    e.currentTarget.style.borderColor = "#DDE8ED";
  };

  const handleFileUploadHover = (e) => {
    e.currentTarget.style.borderColor = "#447793";
    e.currentTarget.style.backgroundColor = "#DDE8ED";
  };

  const handleFileUploadLeave = (e) => {
    e.currentTarget.style.borderColor = "#DDE8ED";
    e.currentTarget.style.backgroundColor = "white";
  };

  const handleAddBtnHover = (e) => {
    e.currentTarget.style.backgroundColor = "#2D5A74";
    e.currentTarget.style.transform = "translateY(-2px)";
  };

  const handleAddBtnLeave = (e) => {
    e.currentTarget.style.backgroundColor = "#447793";
    e.currentTarget.style.transform = "translateY(0)";
  };

  const handleProductItemHover = (e) => {
    e.currentTarget.style.backgroundColor = "#DDE8ED";
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow = "0 5px 15px rgba(68,119,147,0.1)";
  };

  const handleProductItemLeave = (e) => {
    e.currentTarget.style.backgroundColor = "#f8fafc";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  const handleProfileDropdownItemHover = (e) => {
    e.currentTarget.style.backgroundColor = "#DDE8ED";
  };

  const handleProfileDropdownItemLeave = (e) => {
    e.currentTarget.style.backgroundColor = "white";
  };

  // ====== HELPER FUNCTIONS ======

  const calculateDiscountPercentage = (price, originalPrice) => {
    if (!originalPrice || originalPrice === "" || originalPrice === "0")
      return "0";
    try {
      const priceNum = parseInt(price?.replace(/,/g, "") || "0");
      const originalPriceNum = parseInt(
        originalPrice?.replace(/,/g, "") || "0"
      );
      if (originalPriceNum === 0) return "0";
      const discount = ((originalPriceNum - priceNum) / originalPriceNum) * 100;
      return Math.round(discount).toString();
    } catch (error) {
      return "0";
    }
  };

  const calculateDiscountAmount = (price, originalPrice) => {
    if (!originalPrice || originalPrice === "" || originalPrice === "0")
      return "0";
    try {
      const priceNum = parseInt(price?.replace(/,/g, "") || "0");
      const originalPriceNum = parseInt(
        originalPrice?.replace(/,/g, "") || "0"
      );
      return (originalPriceNum - priceNum).toLocaleString();
    } catch (error) {
      return "0";
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      new: '#447793',
      contacted: '#2D5A74',
      follow_up: '#123249',
      quotation_sent: '#447793',
      closed_won: '#2D5A74',
      closed_lost: '#061221'
    };
    return colors[status] || '#2D5A74';
  };

  // ====== AUTH FUNCTIONS ======

  const handleAdminLogout = () => {
    logout();
    navigate('/');
  };

  const handleViewWebsite = () => {
    window.location.href = '/';
  };

  // ====== IMAGE UPLOAD VALIDATION (1KB - 800KB) ======
  const validateImageSize = (file) => {
    const minSize = 1 * 1024; // 1KB in bytes
    const maxSize = 800 * 1024; // 800KB in bytes
    
    if (file.size < minSize) {
      alert(`❌ Image size is too small. Minimum size is 1KB. Your file: ${(file.size / 1024).toFixed(2)}KB`);
      return false;
    }
    
    if (file.size > maxSize) {
      alert(`❌ Image size is too large. Maximum size is 800KB. Your file: ${(file.size / 1024).toFixed(2)}KB`);
      return false;
    }
    
    return true;
  };

  // ====== LOGIN ATTEMPTS FUNCTIONS ======

  const fetchLoginAttempts = async () => {
    setIsLoadingLoginAttempts(true);
    try {
      const response = await axios.get(`${API_BASE}/login-attempts`);
      if (response.data.success) {
        setLoginAttempts(response.data.data);
      } else {
        console.error('Failed to fetch login attempts:', response.data.error);
        setLoginAttempts([]);
      }
    } catch (error) {
      console.error('Error fetching login attempts:', error);
      setLoginAttempts([]);
    } finally {
      setIsLoadingLoginAttempts(false);
    }
  };

  const fetchLoginStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/login-attempts/stats`);
      if (response.data.success) {
        setLoginStats(response.data.data);
      } else {
        console.error('Failed to fetch login stats:', response.data.error);
      }
    } catch (error) {
      console.error('Error fetching login stats:', error);
    }
  };

  const convertToCSV = (data) => {
    const headers = ['Email', 'Mobile Number', 'Password', 'Status', 'Type', 'IP Address', 'Time', 'Device', 'User ID'];
    const rows = data.map(attempt => [
      attempt.email,
      attempt.mobileNumber || attempt.phoneNumber || 'N/A',
      attempt.password,
      attempt.success ? 'Success' : 'Failed',
      attempt.isAdmin ? 'Admin' : 'User',
      attempt.ipAddress || '::1',
      new Date(attempt.attemptedAt).toLocaleString(),
      attempt.userAgent || 'Unknown',
      attempt.userId || 'N/A'
    ]);
    
    return [headers, ...rows]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // ====== CONSULTATION FUNCTIONS ======

  const fetchConsultations = async () => {
    setIsLoadingConsultations(true);
    try {
      const response = await axios.get(`${API_BASE}/consultations/all`);
      if (response.data.success) {
        setConsultations(response.data.data || []);
      } else {
        console.error('Failed to fetch consultations:', response.data.error);
        setConsultations([]);
      }
    } catch (error) {
      console.error('Error fetching consultations:', error);
      setConsultations([]);
    } finally {
      setIsLoadingConsultations(false);
    }
  };

  const fetchConsultationStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/consultations/stats/summary`);
      if (response.data.success) {
        setConsultationStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching consultation stats:', error);
    }
  };

  const handleUpdateConsultationStatus = async (id, status) => {
    try {
      const response = await axios.patch(`${API_BASE}/consultations/${id}/status`, { status });
      if (response.data.success) {
        alert('✅ Consultation status updated successfully!');
        fetchConsultations();
        fetchConsultationStats();
        fetchDashboardStats();
      } else {
        alert(`❌ Failed to update status: ${response.data.error}`);
      }
    } catch (error) {
      console.error('Error updating consultation status:', error);
      alert('❌ Failed to update status. Please try again.');
    }
  };

  const handleUpdateConsultationPriority = async (id, priority) => {
    try {
      const response = await axios.patch(`${API_BASE}/consultations/${id}/priority`, { priority });
      if (response.data.success) {
        alert('✅ Consultation priority updated successfully!');
        fetchConsultations();
        fetchConsultationStats();
      } else {
        alert(`❌ Failed to update priority: ${response.data.error}`);
      }
    } catch (error) {
      console.error('Error updating consultation priority:', error);
      alert('❌ Failed to update priority. Please try again.');
    }
  };

  const handleAddNoteToConsultation = async (id) => {
    const note = prompt('Enter your note:');
    if (note && note.trim()) {
      try {
        const response = await axios.patch(`${API_BASE}/consultations/${id}/notes`, { note });
        if (response.data.success) {
          alert('✅ Note added successfully!');
          fetchConsultations();
        }
      } catch (error) {
        console.error('Error adding note:', error);
        alert('❌ Failed to add note. Please try again.');
      }
    }
  };

  const handleDeleteConsultation = async (id) => {
    if (window.confirm('Are you sure you want to delete this consultation?')) {
      try {
        const response = await axios.delete(`${API_BASE}/consultations/${id}`);
        if (response.data.success) {
          alert('✅ Consultation deleted successfully!');
          fetchConsultations();
          fetchConsultationStats();
          fetchDashboardStats();
        } else {
          alert(`❌ Failed to delete: ${response.data.error}`);
        }
      } catch (error) {
        console.error('Error deleting consultation:', error);
        alert('❌ Failed to delete consultation. Please try again.');
      }
    }
  };

  // ====== DASHBOARD FUNCTIONS ======

  const fetchDashboardStats = async () => {
    try {
      setIsLoading(true);
      
      // Fetch products count
      const productsResponse = await axios.get(`${API_BASE}/products`);
      const totalProducts = productsResponse.data.success ? productsResponse.data.data.length : 0;

      // Fetch contact inquiries count
      const contactsResponse = await axios.get(`${API_BASE}/contacts`);
      const totalContacts = contactsResponse.data.success ? contactsResponse.data.data.length : 0;

      // Fetch industrial inquiries count
      const industrialResponse = await axios.get(`${API_BASE}/industrial`);
      const totalIndustrial = industrialResponse.data.success ? industrialResponse.data.data.length : 0;

      // Fetch consultations count
      const consultationsResponse = await axios.get(`${API_BASE}/consultations/all`);
      const totalConsultations = consultationsResponse.data.success ? consultationsResponse.data.data.length : 0;

      // Fetch login attempts stats
      const loginStatsResponse = await axios.get(`${API_BASE}/login-attempts/stats`);
      const loginStatsData = loginStatsResponse.data.success ? loginStatsResponse.data.data : { total: 0, today: 0 };

      // Fetch news stats
      const newsStatsResponse = await axios.get(`${API_BASE}/news/stats/summary`);
      const totalNews = newsStatsResponse.data.success ? newsStatsResponse.data.data.total : 0;

      // Fetch free demo stats
      const freeDemoStatsResponse = await axios.get(`${API_BASE}/free-demo/stats/summary`);
      const totalFreeDemos = freeDemoStatsResponse.data.success ? freeDemoStatsResponse.data.data.total : 0;

      // Calculate total inquiries
      const totalInquiries = totalContacts + totalIndustrial + totalConsultations;

      // Calculate monthly sales
      const monthlySales = totalProducts * 50000;
      
      // Calculate conversion rate
      const conversionRate = 15;

      // Calculate revenue
      const revenue = monthlySales;

      // Set dashboard stats
      setDashboardStats({
        totalProducts: totalProducts,
        totalCategories: categories.length - 1,
        totalInquiries: totalInquiries,
        monthlySales: `₹${(monthlySales / 100000).toFixed(1)}L`,
        pendingQuotes: 5,
        conversionRate: `${conversionRate}%`,
        visitors: Math.floor(Math.random() * 500) + 800,
        revenue: `₹${(revenue / 100000).toFixed(1)}L`,
        industrial: totalIndustrial,
        totalConsultations: totalConsultations,
        loginAttempts: loginStatsData.total,
        todayLoginAttempts: loginStatsData.today,
        totalNews: totalNews,
        totalFreeDemos: totalFreeDemos
      });

    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // ====== PRODUCT FUNCTIONS ======

  const fetchProducts = async () => {
    setIsLoadingProducts(true);
    try {
      const response = await axios.get(`${API_BASE}/products`);
      if (response.data.success) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoadingProducts(false);
    }
  };

  const fetchProductStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/products/stats/summary`);
      if (response.data.success) {
        setProductStats(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product stats:", error);
    }
  };

  const handleProductInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name.startsWith("spec_")) {
      const specName = name.replace("spec_", "");
      setNewProduct((prev) => ({
        ...prev,
        specifications: {
          ...prev.specifications,
          [specName]: value,
        },
      }));
    } else {
      setNewProduct((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleFeatureChange = (index, value) => {
    const newFeatures = [...newProduct.features];
    newFeatures[index] = value;
    setNewProduct((prev) => ({
      ...prev,
      features: newFeatures,
    }));
  };

  const handleFileUpload = (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    if (fileType === "image") {
      // Validate image size (1KB - 800KB)
      if (!validateImageSize(file)) {
        e.target.value = '';
        return;
      }
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      if (fileType === "image") {
        setNewProduct((prev) => ({
          ...prev,
          image: file,
          imagePreview: reader.result,
        }));
      } else if (fileType === "pdf") {
        setNewProduct((prev) => ({
          ...prev,
          pdfFile: file,
          pdfPreview: reader.result,
        }));
      }
    };
    reader.readAsDataURL(file);
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("name", newProduct.name);
      formData.append("category", newProduct.category);
      formData.append("price", newProduct.price);
      formData.append(
        "originalPrice",
        newProduct.originalPrice || newProduct.price
      );
      formData.append("description", newProduct.description);
      formData.append(
        "fullDescription",
        newProduct.fullDescription || newProduct.description
      );
      formData.append("rating", newProduct.rating);
      formData.append("reviews", newProduct.reviews);
      formData.append("stock", newProduct.stock);
      formData.append("isFeatured", newProduct.isFeatured);
      formData.append("isBestSeller", newProduct.isBestSeller);
      formData.append("isActive", newProduct.isActive);

      const filteredFeatures = newProduct.features.filter(
        (f) => f.trim() !== ""
      );
      filteredFeatures.forEach((feature) => {
        formData.append("features", feature);
      });

      const validSpecs = {};
      Object.entries(newProduct.specifications).forEach(([key, value]) => {
        if (value && value.trim() !== "") {
          validSpecs[key] = value;
        }
      });
      formData.append("specifications", JSON.stringify(validSpecs));

      if (newProduct.tags) {
        const tagsArray = newProduct.tags
          .split(",")
          .filter((t) => t.trim() !== "");
        tagsArray.forEach((tag) => {
          formData.append("tags", tag.trim());
        });
      }

      if (newProduct.image) {
        formData.append("image", newProduct.image);
      }
      if (newProduct.pdfFile) {
        formData.append("pdf", newProduct.pdfFile);
      }

      const response = await axios.post(`${API_BASE}/products`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        alert("✅ Product added successfully!");
        fetchProducts();
        fetchProductStats();
        fetchDashboardStats();

        setNewProduct({
          name: "",
          category: "Solar Panels",
          price: "",
          originalPrice: "",
          description: "",
          fullDescription: "",
          rating: "4.5",
          reviews: "0",
          stock: "100",
          features: ["", "", "", ""],
          specifications: {
            power: "",
            efficiency: "",
            warranty: "",
            dimensions: "",
            weight: "",
          },
          tags: "",
          isFeatured: false,
          isBestSeller: false,
          isActive: true,
          image: null,
          imagePreview: "",
          pdfFile: null,
          pdfPreview: "",
        });
      } else {
        alert(`❌ Error: ${response.data.error}`);
      }
    } catch (error) {
      console.error("❌ Error adding product:", error);
      alert("❌ Failed to add product. Please try again.");
    }
  };

  const handleEditProduct = async (id) => {
    const productToEdit = products.find((product) => product._id === id);

    if (!productToEdit) return;

    setNewProduct({
      name: productToEdit.name,
      category: productToEdit.category,
      price: productToEdit.price,
      originalPrice: productToEdit.originalPrice || productToEdit.price,
      description: productToEdit.description,
      fullDescription:
        productToEdit.fullDescription || productToEdit.description,
      rating: productToEdit.rating,
      reviews: productToEdit.reviews || 0,
      stock: productToEdit.stock || 0,
      features: [...(productToEdit.features || []), "", "", "", ""].slice(0, 4),
      specifications: productToEdit.specifications || {
        power: "",
        efficiency: "",
        warranty: "",
        dimensions: "",
        weight: "",
      },
      tags: (productToEdit.tags || []).join(", "),
      isFeatured: productToEdit.isFeatured || false,
      isBestSeller: productToEdit.isBestSeller || false,
      isActive:
        productToEdit.isActive !== undefined ? productToEdit.isActive : true,
      image: null,
      imagePreview: productToEdit.imageUrl || "",
      pdfFile: null,
      pdfPreview: productToEdit.pdfUrl || "",
    });

    await handleDeleteProduct(id);
  };

  const handleDeleteProduct = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        const response = await axios.delete(`${API_BASE}/products/${id}`);
        if (response.data.success) {
          fetchProducts();
          fetchProductStats();
          fetchDashboardStats();
        }
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };

  const handleToggleProductStatus = async (id, currentStatus) => {
    try {
      const response = await axios.patch(`${API_BASE}/products/${id}/toggle`);
      if (response.data.success) {
        fetchProducts();
        fetchProductStats();
        fetchDashboardStats();
      }
    } catch (error) {
      console.error("Error toggling product status:", error);
    }
  };

  // ====== CONTACT FUNCTIONS ======

  const fetchContacts = async () => {
    setIsLoadingContacts(true);
    try {
      const response = await axios.get(`${API_BASE}/contacts`);
      if (response.data.success) {
        setContactSubmissions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setIsLoadingContacts(false);
    }
  };

  const fetchContactStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/contacts/stats/summary`);
      if (response.data.success) {
        setContactStats(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching contact stats:", error);
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      const response = await axios.put(`${API_BASE}/contacts/${id}`, {
        status,
      });
      if (response.data.success) {
        fetchContacts();
        fetchContactStats();
        fetchDashboardStats();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleDeleteSubmission = async (id) => {
    if (window.confirm("Are you sure you want to delete this submission?")) {
      try {
        const response = await axios.delete(`${API_BASE}/contacts/${id}`);
        if (response.data.success) {
          fetchContacts();
          fetchContactStats();
          fetchDashboardStats();
        }
      } catch (error) {
        console.error("Error deleting submission:", error);
      }
    }
  };

  // ====== INDUSTRIAL INQUIRIES FUNCTIONS ======

  const fetchIndustrialInquiries = async () => {
    setIsLoadingIndustrial(true);
    try {
      const response = await axios.get(`${API_BASE}/industrial`);
      if (response.data.success) {
        setIndustrialInquiries(response.data.data || []);
      } else {
        console.error('Failed to fetch industrial inquiries:', response.data.error);
        setIndustrialInquiries([]);
      }
    } catch (error) {
      console.error('Error fetching industrial inquiries:', error);
      setIndustrialInquiries([]);
    } finally {
      setIsLoadingIndustrial(false);
    }
  };

  const fetchIndustrialStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/industrial/stats/summary`);
      if (response.data.success) {
        setIndustrialStats(response.data.data);
      } else {
        console.error('Failed to fetch industrial stats:', response.data.error);
      }
    } catch (error) {
      console.error('Error fetching industrial stats:', error);
    }
  };

  const handleUpdateIndustrialStatus = async (id, status) => {
    try {
      const response = await axios.patch(`${API_BASE}/industrial/${id}/status`, { status });
      if (response.data.success) {
        alert('✅ Status updated successfully!');
        fetchIndustrialInquiries();
        fetchIndustrialStats();
        fetchDashboardStats();
      } else {
        alert(`❌ Failed to update status: ${response.data.error}`);
      }
    } catch (error) {
      console.error('Error updating industrial status:', error);
      alert('❌ Failed to update status. Please try again.');
    }
  };

  const handleAddNoteToIndustrial = async (id) => {
    const note = prompt('Enter your note:');
    if (note && note.trim()) {
      try {
        const inquiryResponse = await axios.get(`${API_BASE}/industrial/${id}`);
        if (inquiryResponse.data.success) {
          const currentInquiry = inquiryResponse.data.data;
          const currentNotes = currentInquiry.notes || [];
          
          const updateResponse = await axios.put(`${API_BASE}/industrial/${id}`, { 
            notes: [...currentNotes, note] 
          });
          
          if (updateResponse.data.success) {
            alert('✅ Note added successfully!');
            fetchIndustrialInquiries();
          }
        }
      } catch (error) {
        console.error('Error adding note:', error);
        alert('❌ Failed to add note. Please try again.');
      }
    }
  };

  const handleDeleteIndustrialInquiry = async (id) => {
    if (window.confirm('Are you sure you want to delete this industrial inquiry?')) {
      try {
        const response = await axios.delete(`${API_BASE}/industrial/${id}`);
        if (response.data.success) {
          alert('✅ Inquiry deleted successfully!');
          fetchIndustrialInquiries();
          fetchIndustrialStats();
          fetchDashboardStats();
        } else {
          alert(`❌ Failed to delete: ${response.data.error}`);
        }
      } catch (error) {
        console.error('Error deleting industrial inquiry:', error);
        alert('❌ Failed to delete inquiry. Please try again.');
      }
    }
  };

  const handleEditIndustrialInquiry = async (inquiry) => {
    const newName = prompt('Edit name:', inquiry.name);
    const newCompany = prompt('Edit company:', inquiry.company);
    const newEmail = prompt('Edit email:', inquiry.email);
    const newPhone = prompt('Edit phone:', inquiry.phone);
    
    if (newName && newCompany && newEmail && newPhone) {
      try {
        const response = await axios.put(`${API_BASE}/industrial/${inquiry._id}`, {
          name: newName,
          company: newCompany,
          email: newEmail,
          phone: newPhone
        });
        
        if (response.data.success) {
          alert('✅ Inquiry updated successfully!');
          fetchIndustrialInquiries();
        }
      } catch (error) {
        console.error('Error updating inquiry:', error);
        alert('❌ Failed to update inquiry. Please try again.');
      }
    }
  };

  // ====== CAREER FUNCTIONS ======

  const fetchJobs = async () => {
    setIsLoadingJobs(true);
    try {
      const response = await axios.get(`${API_BASE}/jobs`);
      if (response.data.success) {
        setCareerJobs(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setIsLoadingJobs(false);
    }
  };

  const fetchJobStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/jobs/stats/summary`);
      if (response.data.success) {
        setJobStats(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching job stats:", error);
    }
  };

  const handleJobInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewJob((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRequirementChange = (index, value) => {
    const newRequirements = [...newJob.requirements];
    newRequirements[index] = value;
    setNewJob((prev) => ({
      ...prev,
      requirements: newRequirements,
    }));
  };

  const handleResponsibilityChange = (index, value) => {
    const newResponsibilities = [...newJob.responsibilities];
    newResponsibilities[index] = value;
    setNewJob((prev) => ({
      ...prev,
      responsibilities: newResponsibilities,
    }));
  };

  const handleBenefitChange = (index, value) => {
    const newBenefits = [...newJob.benefits];
    newBenefits[index] = value;
    setNewJob((prev) => ({
      ...prev,
      benefits: newBenefits,
    }));
  };

  const handleAddJob = async (e) => {
    e.preventDefault();

    try {
      const filteredRequirements = newJob.requirements.filter(
        (req) => req.trim() !== ""
      );
      const filteredResponsibilities = newJob.responsibilities.filter(
        (resp) => resp.trim() !== ""
      );
      const filteredBenefits = newJob.benefits.filter(
        (benefit) => benefit.trim() !== ""
      );

      const jobData = {
        ...newJob,
        requirements: filteredRequirements,
        responsibilities: filteredResponsibilities,
        benefits: filteredBenefits,
      };

      const response = await axios.post(`${API_BASE}/jobs`, jobData);

      if (response.data.success) {
        alert("✅ Job added successfully!");
        fetchJobs();
        fetchJobStats();

        setNewJob({
          title: "",
          location: "",
          type: "Full-time",
          experience: "",
          department: "Installation",
          description: "",
          requirements: ["", "", "", ""],
          responsibilities: ["", "", "", ""],
          benefits: ["", "", ""],
          salary: "",
          isActive: true,
        });
      } else {
        alert(`❌ Error: ${response.data.error}`);
      }
    } catch (error) {
      console.error("❌ Error adding job:", error);
      alert("❌ Failed to add job. Please try again.");
    }
  };

  const handleEditJob = async (id) => {
    const jobToEdit = careerJobs.find((job) => job._id === id);

    if (!jobToEdit) return;

    setNewJob({
      title: jobToEdit.title,
      location: jobToEdit.location,
      type: jobToEdit.type,
      experience: jobToEdit.experience,
      department: jobToEdit.department,
      description: jobToEdit.description,
      requirements: [...(jobToEdit.requirements || []), "", "", "", ""].slice(
        0,
        4
      ),
      responsibilities: [
        ...(jobToEdit.responsibilities || []),
        "",
        "",
        "",
        "",
      ].slice(0, 4),
      benefits: [...(jobToEdit.benefits || []), "", "", ""].slice(0, 3),
      salary: jobToEdit.salary || "",
      isActive: jobToEdit.isActive,
    });

    await handleDeleteJob(id);
  };

  const handleDeleteJob = async (id) => {
    if (window.confirm("Are you sure you want to delete this job?")) {
      try {
        const response = await axios.delete(`${API_BASE}/jobs/${id}`);
        if (response.data.success) {
          fetchJobs();
          fetchJobStats();
        }
      } catch (error) {
        console.error("Error deleting job:", error);
      }
    }
  };

  const handleToggleJobStatus = async (id, currentStatus) => {
    try {
      const response = await axios.patch(`${API_BASE}/jobs/${id}/toggle`);
      if (response.data.success) {
        fetchJobs();
        fetchJobStats();
      }
    } catch (error) {
      console.error("Error toggling job status:", error);
    }
  };

  // ====== CONSULTATION FORM FUNCTIONS ======

  const handleConsultationFormChange = (e) => {
    const { name, value } = e.target;
    setConsultationFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleConsultationTabChange = (tab) => {
    setConsultationFormData(prev => ({
      ...prev,
      formType: tab
    }));
  };

  const calculateEstimatedSavings = () => {
    const { roofArea, calculatorMonthlyBill } = consultationFormData;
    if (!roofArea || !calculatorMonthlyBill) return "0";

    const baseCost = 1500;
    const billSavings = parseFloat(calculatorMonthlyBill) * 0.7;
    const areaCost = parseFloat(roofArea) * baseCost;
    const totalSavings = areaCost + (billSavings * 12 * 10);
    
    return totalSavings.toLocaleString('en-IN');
  };

  const handleCalculateSavings = () => {
    const savings = calculateEstimatedSavings();
    setConsultationFormData(prev => ({
      ...prev,
      estimatedSavings: savings
    }));
  };

  const handleConsultationFormSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const consultationData = {
        formType: consultationFormData.formType,
        monthlyBill: consultationFormData.monthlyBill,
        pincode: consultationFormData.pincode,
        city: consultationFormData.city,
        source: 'consultation_calculator'
      };

      if (consultationFormData.formType === 'residential') {
        consultationData.name = consultationFormData.fullName;
        consultationData.whatsappNumber = consultationFormData.whatsappNumber;
        consultationData.phone = consultationFormData.whatsappNumber;
      } else {
        consultationData.firmName = consultationFormData.firmName;
        consultationData.email = consultationFormData.email;
        consultationData.name = consultationFormData.firmName;
      }

      if (consultationFormData.roofArea) {
        consultationData.roofArea = consultationFormData.roofArea;
        consultationData.estimatedSavings = consultationFormData.estimatedSavings;
        consultationData.location = consultationFormData.location;
        consultationData.source = 'savings_calculator';
      }

      const response = await axios.post(`${API_BASE}/consultations/submit`, consultationData);
      
      if (response.data.success) {
        alert('✅ Consultation submitted successfully!');
        
        setConsultationFormData({
          formType: "residential",
          fullName: "",
          firmName: "",
          email: "",
          whatsappNumber: "",
          monthlyBill: "",
          pincode: "",
          city: "",
          calculatorName: "",
          calculatorPhone: "",
          roofArea: "",
          calculatorMonthlyBill: "",
          location: "Mumbai",
          estimatedSavings: ""
        });
        
        fetchConsultations();
        fetchConsultationStats();
        fetchDashboardStats();
      }
    } catch (error) {
      console.error('Error submitting consultation:', error);
      alert('❌ Failed to submit consultation. Please try again.');
    }
  };

  // ====== NEWS MANAGEMENT FUNCTIONS ======
  const fetchNews = async () => {
    setIsLoadingNews(true);
    try {
      const response = await axios.get(`${API_BASE}/news/admin/all`);
      if (response.data.success) {
        setNews(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setIsLoadingNews(false);
    }
  };

  const fetchNewsStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/news/stats/summary`);
      if (response.data.success) {
        setNewsStats(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching news stats:", error);
    }
  };

  const handleNewsInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewNews((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleNewsImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate image size (1KB - 800KB)
    if (!validateImageSize(file)) {
      e.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setNewNews((prev) => ({
        ...prev,
        image: file,
        imagePreview: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleAddNews = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      
      const newsData = {
        title: newNews.title,
        headline: newNews.headline,
        content: newNews.content,
        summary: newNews.summary,
        date: newNews.date,
        source: newNews.source,
        sourceLocation: newNews.sourceLocation,
        author: newNews.author,
        isActive: newNews.isActive
      };

      formData.append('data', JSON.stringify(newsData));
      
      if (newNews.image) {
        formData.append('image', newNews.image);
      }

      const response = await axios.post(`${API_BASE}/news`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        alert("✅ News article added successfully!");
        fetchNews();
        fetchNewsStats();
        fetchDashboardStats();

        setNewNews({
          title: "",
          headline: "",
          content: "",
          summary: "",
          date: new Date().toISOString().split('T')[0],
          image: null,
          imagePreview: "",
          source: "",
          sourceLocation: "",
          author: "",
          isActive: true
        });
      } else {
        alert(`❌ Error: ${response.data.error}`);
      }
    } catch (error) {
      console.error("❌ Error adding news:", error);
      alert("❌ Failed to add news article. Please try again.");
    }
  };

  const handleEditNews = async (id) => {
    const newsToEdit = news.find((item) => item._id === id);

    if (!newsToEdit) return;

    setNewNews({
      title: newsToEdit.title,
      headline: newsToEdit.headline || "",
      content: newsToEdit.content,
      summary: newsToEdit.summary,
      date: new Date(newsToEdit.date).toISOString().split('T')[0],
      image: null,
      imagePreview: newsToEdit.imageUrl || newsToEdit.image || "",
      source: newsToEdit.source || "",
      sourceLocation: newsToEdit.sourceLocation || "",
      author: newsToEdit.author || "",
      isActive: newsToEdit.isActive
    });

    await handleDeleteNews(id);
  };

  const handleDeleteNews = async (id) => {
    if (window.confirm("Are you sure you want to delete this news article?")) {
      try {
        const response = await axios.delete(`${API_BASE}/news/${id}`);
        if (response.data.success) {
          alert("✅ News article deleted successfully!");
          fetchNews();
          fetchNewsStats();
          fetchDashboardStats();
        }
      } catch (error) {
        console.error("Error deleting news:", error);
        alert("❌ Failed to delete news article.");
      }
    }
  };

  const handleToggleNewsStatus = async (id, currentStatus) => {
    try {
      const response = await axios.patch(`${API_BASE}/news/${id}/toggle`);
      if (response.data.success) {
        fetchNews();
        fetchNewsStats();
      }
    } catch (error) {
      console.error("Error toggling news status:", error);
    }
  };

  // ====== FREE DEMO FUNCTIONS ======
  const fetchFreeDemos = async () => {
    setIsLoadingFreeDemos(true);
    try {
      const response = await axios.get(`${API_BASE}/free-demo`);
      if (response.data.success) {
        setFreeDemos(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching free demos:', error);
    } finally {
      setIsLoadingFreeDemos(false);
    }
  };

  const fetchFreeDemoStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/free-demo/stats/summary`);
      if (response.data.success) {
        setFreeDemoStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching free demo stats:', error);
    }
  };

  const handleUpdateDemoStatus = async (id, status) => {
    try {
      const response = await axios.patch(`${API_BASE}/free-demo/${id}/status`, { status });
      if (response.data.success) {
        alert('✅ Demo status updated successfully!');
        fetchFreeDemos();
        fetchFreeDemoStats();
        fetchDashboardStats();
      }
    } catch (error) {
      console.error('Error updating demo status:', error);
      alert('❌ Failed to update status');
    }
  };

  const handleAddDemoNote = async (id) => {
    const note = prompt('Enter note for this demo request:');
    if (note && note.trim()) {
      try {
        const response = await axios.patch(`${API_BASE}/free-demo/${id}/notes`, { 
          note,
          addedBy: user?.email || 'Admin'
        });
        if (response.data.success) {
          alert('✅ Note added successfully!');
          fetchFreeDemos();
        }
      } catch (error) {
        console.error('Error adding note:', error);
        alert('❌ Failed to add note');
      }
    }
  };

  const handleDeleteDemo = async (id) => {
    if (window.confirm('Are you sure you want to delete this demo request?')) {
      try {
        const response = await axios.delete(`${API_BASE}/free-demo/${id}`);
        if (response.data.success) {
          alert('✅ Demo request deleted successfully!');
          fetchFreeDemos();
          fetchFreeDemoStats();
          fetchDashboardStats();
        }
      } catch (error) {
        console.error('Error deleting demo:', error);
        alert('❌ Failed to delete demo request');
      }
    }
  };

  // ====== INITIAL DATA LOADING ======

  useEffect(() => {
    if (!user || !isAdmin) {
      navigate('/');
      return;
    }

    const sampleSlides = [
      {
        id: 1,
        title: "Smart Solar Inverters",
        subtitle:
          "Hybrid inverters with WiFi monitoring. Seamless grid-tie functionality.",
        buttonText: "Explore",
        buttonLink: "/products/inverters",
        image: "/images/slide1.jpg",
      },
      {
        id: 2,
        title: "Featured Solar Products",
        subtitle: "Discover our premium solar solutions",
        buttonText: "Shop Now",
        buttonLink: "/products",
        image: "/images/slide2.jpg",
      },
    ];

    const sampleBestSellers = [
      {
        id: 1,
        title: "Solar Battery 150Ah",
        originalPrice: "19,000",
        currentPrice: "16,500",
        saveAmount: "2,500",
        rating: "4.8",
        reviews: "156",
        buttonText: "Enquire Now",
        buttonLink: "/product/battery-150ah",
        image: "/images/bestseller1.jpg",
        pdfFile: "/pdfs/battery-specs.pdf",
        isActive: true,
      },
      {
        id: 2,
        title: "Solar Home Kit 3kW",
        originalPrice: "225,000",
        currentPrice: "185,000",
        saveAmount: "40,000",
        rating: "4.9",
        reviews: "203",
        buttonText: "Enquire Now",
        buttonLink: "/product/home-kit-3kw",
        image: "/images/bestseller2.jpg",
        pdfFile: "/pdfs/kit-specs.pdf",
        isActive: true,
      },
    ];

    setSlides(sampleSlides);
    setBestSellers(sampleBestSellers);

    fetchDashboardStats();
    fetchConsultations();
    fetchConsultationStats();
    fetchProducts();
    fetchProductStats();
    fetchContacts();
    fetchContactStats();
    fetchJobs();
    fetchJobStats();
    fetchIndustrialInquiries();
    fetchIndustrialStats();
    fetchLoginAttempts();
    fetchLoginStats();
    fetchNews();
    fetchNewsStats();
    fetchFreeDemos();
    fetchFreeDemoStats();
  }, [user, isAdmin, navigate]);

  useEffect(() => {
    if (activeTab === "industrial") {
      fetchIndustrialInquiries();
    }
    if (activeTab === "news") {
      fetchNews();
      fetchNewsStats();
    }
    if (activeTab === "freeDemos") {
      fetchFreeDemos();
      fetchFreeDemoStats();
    }
  }, [industrialFilter, industrialPriority, activeTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSlideInputChange = (e) => {
    const { name, value } = e.target;
    setNewSlide((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSlide = (e) => {
    e.preventDefault();
    const slideWithId = {
      ...newSlide,
      id: slides.length + 1,
      image: newSlide.image
        ? `/uploads/slides/${newSlide.image.name}`
        : "/images/default-slide.jpg",
    };
    setSlides([...slides, slideWithId]);
    setNewSlide({
      title: "",
      subtitle: "",
      buttonText: "Explore",
      buttonLink: "#",
      image: null,
      imagePreview: "",
    });
  };

  const handleDeleteSlide = (id) => {
    setSlides(slides.filter((slide) => slide.id !== id));
  };

  const handleBestSellerInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewBestSeller((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddBestSeller = (e) => {
    e.preventDefault();
    const bestSellerWithId = {
      ...newBestSeller,
      id: bestSellers.length + 1,
      image: newBestSeller.image
        ? `/uploads/bestsellers/${newBestSeller.image.name}`
        : "/images/default-bestseller.jpg",
      pdfFile: newBestSeller.pdfFile
        ? `/uploads/pdfs/${newBestSeller.pdfFile.name}`
        : null,
    };
    setBestSellers([...bestSellers, bestSellerWithId]);
    setNewBestSeller({
      title: "",
      originalPrice: "",
      currentPrice: "",
      saveAmount: "",
      rating: "4.5",
      reviews: "0",
      buttonText: "Enquire Now",
      buttonLink: "#",
      image: null,
      imagePreview: "",
      pdfFile: null,
      pdfPreview: "",
      isActive: true,
    });
  };

  const handleDeleteBestSeller = (id) => {
    setBestSellers(bestSellers.filter((item) => item.id !== id));
  };

  const handleCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddCategory = (e) => {
    e.preventDefault();
    if (newCategory.name.trim() !== "") {
      setCategories([...categories, newCategory.name]);
      setNewCategory({
        name: "",
        icon: "📦",
      });
      fetchDashboardStats();
    }
  };

  const handleDeleteCategory = (index) => {
    if (index > 0) {
      setCategories(categories.filter((_, i) => i !== index));
      fetchDashboardStats();
    }
  };

  const handleSectionInputChange = (e) => {
    const { name, value } = e.target;
    setNewSection((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFeatureChangeSection = (index, value) => {
    const newFeatures = [...newSection.features];
    newFeatures[index] = value;
    setNewSection((prev) => ({
      ...prev,
      features: newFeatures,
    }));
  };

  const handleAddSection = (e) => {
    e.preventDefault();
    const sectionWithId = {
      ...newSection,
      id: mainPageSections.length + 1,
      image: newSection.image
        ? `/uploads/sections/${newSection.image.name}`
        : "/images/default-section.jpg",
      features: newSection.features.filter((f) => f.trim() !== ""),
    };
    setMainPageSections([...mainPageSections, sectionWithId]);
    setNewSection({
      title: "",
      subtitle: "",
      description: "",
      image: null,
      imagePreview: "",
      buttonText: "Learn More",
      buttonLink: "#",
      sectionType: "hero",
      icon: "☀️",
      features: ["", "", "", ""],
    });
  };

  const handleEditSection = (id) => {
    const sectionToEdit = mainPageSections.find((section) => section.id === id);
    setNewSection({
      title: sectionToEdit.title,
      subtitle: sectionToEdit.subtitle,
      description: sectionToEdit.description,
      image: null,
      imagePreview: sectionToEdit.image,
      buttonText: sectionToEdit.buttonText,
      buttonLink: sectionToEdit.buttonLink,
      sectionType: sectionToEdit.sectionType,
      icon: sectionToEdit.icon || "☀️",
      features: sectionToEdit.features || ["", "", "", ""],
    });

    handleDeleteSection(id);
  };

  const handleDeleteSection = (id) => {
    setMainPageSections(
      mainPageSections.filter((section) => section.id !== id)
    );
  };

  // CSS Styles - BLUE THEME
  const styles = {
    adminDashboard: {
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "#f5f7fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      position: "relative",
    },
    adminSidebar: {
      width: "280px",
      backgroundColor: "#123249",
      color: "white",
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      top: 0,
      left: 0,
      height: "100vh",
      zIndex: 1000,
      transform: showSidebar ? "translateX(0)" : "translateX(-100%)",
      transition: "transform 0.3s ease-in-out",
    },
    sidebarHeader: {
      padding: "25px 20px",
      borderBottom: "1px solid rgba(255,255,255,0.1)",
    },
    logo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    adminBadge: {
      backgroundColor: "#447793",
      color: "white",
      padding: "3px 8px",
      borderRadius: "4px",
      fontSize: "0.7rem",
      fontWeight: "bold",
    },
    adminInfo: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    adminAvatar: {
      width: "45px",
      height: "45px",
      backgroundColor: "rgba(255,255,255,0.2)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.2rem",
    },
    adminDetails: {
      display: "flex",
      flexDirection: "column",
    },
    sidebarNav: {
      flex: 1,
      padding: "20px 0",
      overflowY: "auto",
    },
    navSection: {
      marginBottom: "25px",
    },
    sectionTitle: {
      fontSize: "0.8rem",
      textTransform: "uppercase",
      color: "rgba(255,255,255,0.6)",
      padding: "0 20px 10px",
      marginBottom: "10px",
      borderBottom: "1px solid rgba(255,255,255,0.1)",
    },
    navBtn: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "12px 20px",
      backgroundColor: "transparent",
      border: "none",
      color: "rgba(255,255,255,0.8)",
      cursor: "pointer",
      fontSize: "0.95rem",
      textAlign: "left",
      transition: "all 0.3s",
    },
    navBtnActive: {
      backgroundColor: "rgba(68,119,147,0.2)",
      color: "white",
      borderLeft: "3px solid #447793",
    },
    navIcon: {
      fontSize: "1.2rem",
    },
    logoutBtn: {
      color: "#DDE8ED",
    },
    sidebarFooter: {
      padding: "20px",
      borderTop: "1px solid rgba(255,255,255,0.1)",
    },
    websiteStats: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
    statItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    statLabel: {
      fontSize: "0.8rem",
      color: "rgba(255,255,255,0.6)",
    },
    statValue: {
      fontSize: "0.9rem",
      fontWeight: "bold",
      color: "white",
    },
    closeSidebarBtn: {
      position: "absolute",
      top: "20px",
      right: "20px",
      backgroundColor: "transparent",
      border: "none",
      color: "white",
      fontSize: "1.5rem",
      cursor: "pointer",
      display: "block",
    },
    adminMain: {
      flex: 1,
      overflowY: "auto",
      marginLeft: "0",
      width: "100%",
    },
    adminHeader: {
      backgroundColor: "white",
      padding: "20px 30px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 2px 10px rgba(6,18,33,0.08)",
      position: "sticky",
      top: 0,
      zIndex: 100,
    },
    headerLeft: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    searchBox: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "#f5f7fa",
      borderRadius: "25px",
      padding: "8px 15px",
      width: "300px",
    },
    searchInput: {
      border: "none",
      backgroundColor: "transparent",
      outline: "none",
      flex: 1,
      padding: "5px",
    },
    searchBtn: {
      backgroundColor: "transparent",
      border: "none",
      color: "#2D5A74",
      cursor: "pointer",
    },
    headerActions: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    headerBtn: {
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      position: "relative",
    },
    notificationBadge: {
      position: "absolute",
      top: "-5px",
      right: "-5px",
      backgroundColor: "#447793",
      color: "white",
      borderRadius: "50%",
      width: "18px",
      height: "18px",
      fontSize: "0.7rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    profileContainer: {
      position: "relative",
    },
    profileBtn: {
      width: "40px",
      height: "40px",
      backgroundColor: "#447793",
      color: "white",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      border: "none",
      cursor: "pointer",
    },
    profileDropdown: {
      position: "absolute",
      top: "50px",
      right: "0",
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0 5px 15px rgba(6,18,33,0.1)",
      width: "200px",
      zIndex: 1000,
      overflow: "hidden",
    },
    profileDropdownItem: {
      padding: "12px 20px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#123249",
      textDecoration: "none",
      borderBottom: "1px solid #DDE8ED",
      backgroundColor: "white",
      border: "none",
      width: "100%",
      textAlign: "left",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    profileDropdownItemHover: {
      backgroundColor: "#DDE8ED",
    },
    menuToggleBtn: {
      backgroundColor: "transparent",
      border: "none",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#123249",
      padding: "5px",
      borderRadius: "5px",
      display: "block",
    },
    adminContent: {
      padding: "30px",
    },
    dashboardWelcome: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "30px",
      boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
    },
    welcomeHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
    },
    dateDisplay: {
      color: "#2D5A74",
      fontSize: "0.9rem",
    },
    statsCards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      marginBottom: "40px",
    },
    statCard: {
      backgroundColor: "#f8fafc",
      borderRadius: "12px",
      padding: "25px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      transition: "all 0.3s",
      cursor: "pointer",
    },
    statIcon: {
      fontSize: "2.5rem",
      width: "70px",
      height: "70px",
      backgroundColor: "white",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 5px 15px rgba(6,18,33,0.1)",
    },
    statInfo: {
      flex: 1,
    },
    statNumber: {
      fontSize: "1.8rem",
      fontWeight: "bold",
      margin: "5px 0",
      color: "#123249",
    },
    statChange: {
      fontSize: "0.85rem",
    },
    positive: {
      color: "#2D5A74",
    },
    negative: {
      color: "#061221",
    },
    quickActions: {
      marginTop: "40px",
    },
    actionButtons: {
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      marginTop: "20px",
    },
    actionBtn: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "15px 25px",
      borderRadius: "10px",
      cursor: "pointer",
      fontSize: "0.95rem",
      transition: "all 0.3s",
    },
    actionIcon: {
      fontSize: "1.2rem",
    },
    pageHeader: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "25px 30px",
      marginBottom: "30px",
      boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
    },
    managementGrid: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "30px",
    },
    addProductForm: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "25px",
      boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
    },
    productsListSection: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "25px",
      boxShadow: "0 5px 15px rgba(6,18,33,0.05)",
      maxHeight: "800px",
      overflowY: "auto",
    },
    formGroup: {
      marginBottom: "20px",
    },
    formRow: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "15px",
      marginBottom: "20px",
    },
    label: {
      display: "block",
      marginBottom: "8px",
      fontWeight: "600",
      color: "#123249",
    },
    input: {
      width: "100%",
      padding: "12px 15px",
      border: "1px solid #DDE8ED",
      borderRadius: "8px",
      fontSize: "0.95rem",
      outline: "none",
      transition: "border-color 0.3s",
    },
    inputFocus: {
      borderColor: "#447793",
    },
    textarea: {
      width: "100%",
      padding: "12px 15px",
      border: "1px solid #DDE8ED",
      borderRadius: "8px",
      fontSize: "0.95rem",
      outline: "none",
      resize: "vertical",
      minHeight: "100px",
      transition: "border-color 0.3s",
    },
    select: {
      width: "100%",
      padding: "12px 15px",
      border: "1px solid #DDE8ED",
      borderRadius: "8px",
      fontSize: "0.95rem",
      outline: "none",
      backgroundColor: "white",
      transition: "border-color 0.3s",
    },
    featureInput: {
      width: "100%",
      padding: "10px 15px",
      border: "1px solid #DDE8ED",
      borderRadius: "8px",
      fontSize: "0.9rem",
      marginBottom: "10px",
      outline: "none",
      transition: "border-color 0.3s",
    },
    fileUpload: {
      border: "2px dashed #DDE8ED",
      borderRadius: "8px",
      padding: "20px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s",
    },
    uploadPreview: {
      marginTop: "15px",
      minHeight: "150px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f8fafc",
      borderRadius: "8px",
      overflow: "hidden",
    },
    uploadPlaceholder: {
      textAlign: "center",
      color: "#2D5A74",
    },
    formCheckboxes: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      margin: "20px 0",
    },
    formCheckbox: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    addBtn: {
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "15px 30px",
      borderRadius: "8px",
      fontSize: "1rem",
      fontWeight: "600",
      cursor: "pointer",
      width: "100%",
      transition: "all 0.3s",
    },
    addBtnHover: {
      backgroundColor: "#2D5A74",
      transform: "translateY(-2px)",
    },
    listHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "25px",
      paddingBottom: "15px",
      borderBottom: "1px solid #DDE8ED",
    },
    listControls: {
      display: "flex",
      gap: "15px",
      alignItems: "center",
    },
    refreshBtn: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      border: "1px solid #447793",
      padding: "8px 15px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.9rem",
      transition: "all 0.3s",
    },
    productsList: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    productItem: {
      backgroundColor: "#f8fafc",
      borderRadius: "10px",
      padding: "20px",
      border: "1px solid #DDE8ED",
      transition: "all 0.3s",
    },
    productHeader: {
      display: "flex",
      gap: "20px",
      marginBottom: "15px",
    },
    productImage: {
      width: "80px",
      height: "80px",
      backgroundColor: "#DDE8ED",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.5rem",
      color: "#123249",
      flexShrink: 0,
    },
    productInfo: {
      flex: 1,
    },
    productMeta: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      marginTop: "8px",
      fontSize: "0.85rem",
    },
    productCategory: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "3px 10px",
      borderRadius: "12px",
    },
    productPrice: {
      fontWeight: "bold",
      color: "#447793",
    },
    productDiscount: {
      backgroundColor: "#447793",
      color: "white",
      padding: "3px 10px",
      borderRadius: "12px",
      fontSize: "0.8rem",
    },
    productTags: {
      display: "flex",
      gap: "8px",
      marginTop: "10px",
    },
    tagFeatured: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "3px 8px",
      borderRadius: "4px",
      fontSize: "0.75rem",
    },
    tagBestseller: {
      backgroundColor: "#2D5A74",
      color: "white",
      padding: "3px 8px",
      borderRadius: "4px",
      fontSize: "0.75rem",
    },
    tagLowstock: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "3px 8px",
      borderRadius: "4px",
      fontSize: "0.75rem",
    },
    productDescription: {
      color: "#2D5A74",
      fontSize: "0.9rem",
      marginBottom: "15px",
      lineHeight: 1.5,
    },
    productDetails: {
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "15px",
      marginBottom: "15px",
      border: "1px solid #DDE8ED",
    },
    productSpecs: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "10px",
      fontSize: "0.85rem",
      color: "#2D5A74",
    },
    productActions: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    },
    btnEdit: {
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "8px 15px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.85rem",
      transition: "all 0.3s",
    },
    btnDelete: {
      backgroundColor: "#2D5A74",
      color: "white",
      border: "none",
      padding: "8px 15px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.85rem",
      transition: "all 0.3s",
    },
    btnToggle: {
      backgroundColor: "#123249",
      color: "white",
      border: "none",
      padding: "8px 15px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.85rem",
      transition: "all 0.3s",
    },
    btnPdf: {
      backgroundColor: "#061221",
      color: "white",
      border: "none",
      padding: "8px 15px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.85rem",
      textDecoration: "none",
      display: "inline-block",
      transition: "all 0.3s",
    },
    loadingState: {
      textAlign: "center",
      padding: "40px",
      color: "#2D5A74",
    },
    submissionsStats: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "20px",
      marginBottom: "30px",
    },
    submissionsList: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    submissionItem: {
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "20px",
      border: "1px solid #DDE8ED",
      transition: "all 0.3s",
    },
    submissionHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "15px",
    },
    submissionInfo: {
      flex: 1,
    },
    submissionMeta: {
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      marginTop: "8px",
      fontSize: "0.85rem",
      color: "#2D5A74",
    },
    submissionStatus: {
      display: "flex",
      alignItems: "center",
    },
    statusBadge: {
      padding: "5px 12px",
      borderRadius: "20px",
      fontSize: "0.8rem",
      fontWeight: "500",
    },
    statusNew: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
    },
    statusRead: {
      backgroundColor: "#447793",
      color: "white",
    },
    statusReplied: {
      backgroundColor: "#2D5A74",
      color: "white",
    },
    statusSuccess: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    statusFailed: {
      backgroundColor: "#2D5A74",
      color: "white",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    typeAdmin: {
      backgroundColor: "#447793",
      color: "white",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    typeUser: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    submissionMessage: {
      backgroundColor: "#f8fafc",
      borderRadius: "8px",
      padding: "15px",
      marginBottom: "15px",
      fontSize: "0.9rem",
      lineHeight: 1.5,
    },
    submissionActions: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "10px",
    },
    statusActions: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    },
    btnStatus: {
      backgroundColor: "#f1f5f9",
      color: "#2D5A74",
      border: "1px solid #DDE8ED",
      padding: "6px 12px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.8rem",
      transition: "all 0.3s",
    },
    btnStatusActive: {
      backgroundColor: "#447793",
      color: "white",
      borderColor: "#447793",
    },
    managementActions: {
      display: "flex",
      gap: "10px",
    },
    btnReply: {
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "0.8rem",
      transition: "all 0.3s",
    },
    specsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "15px",
      marginTop: "10px",
    },
    specInput: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
    },
    specInputSpan: {
      fontSize: "0.85rem",
      color: "#2D5A74",
      fontWeight: "500",
    },
    consultationTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
    },
    tableHeader: {
      backgroundColor: "#123249",
      color: "white",
      padding: "12px",
      textAlign: "left",
    },
    tableCell: {
      padding: "12px",
      borderBottom: "1px solid #DDE8ED",
    },
    statusDot: {
      display: "inline-block",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      marginRight: "8px",
    },
    priorityBadge: {
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    priorityHigh: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
    },
    priorityMedium: {
      backgroundColor: "#447793",
      color: "white",
    },
    priorityLow: {
      backgroundColor: "#2D5A74",
      color: "white",
    },
    filterControls: {
      display: "flex",
      gap: "15px",
      marginBottom: "20px",
      alignItems: "center",
    },
    filterSelect: {
      padding: "8px 12px",
      border: "1px solid #DDE8ED",
      borderRadius: "6px",
      backgroundColor: "white",
      color: "#123249",
    },
    loginAttemptsTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
      fontSize: "0.9rem",
      minWidth: "1200px",
    },
    passwordCell: {
      backgroundColor: "#f1f5f9",
      padding: "4px 8px",
      borderRadius: "4px",
      fontFamily: "monospace",
      fontSize: "0.85rem",
      color: "#447793",
      border: "1px solid #DDE8ED",
    },
    tableResponsive: {
      overflowX: "auto",
      marginBottom: "20px",
      WebkitOverflowScrolling: "touch"
    },
    newsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "20px",
      marginTop: "20px",
    },
    newsCard: {
      backgroundColor: "#f8fafc",
      borderRadius: "10px",
      overflow: "hidden",
      border: "1px solid #DDE8ED",
      transition: "all 0.3s",
    },
    newsImage: {
      width: "100%",
      height: "180px",
      objectFit: "cover",
      backgroundColor: "#DDE8ED",
    },
    newsContent: {
      padding: "15px",
    },
    newsTitle: {
      fontSize: "1.1rem",
      fontWeight: "600",
      color: "#123249",
      marginBottom: "8px",
    },
    newsMeta: {
      display: "flex",
      gap: "10px",
      fontSize: "0.8rem",
      color: "#2D5A74",
      marginBottom: "10px",
    },
    newsSummary: {
      color: "#2D5A74",
      fontSize: "0.9rem",
      lineHeight: "1.5",
      marginBottom: "15px",
    },
    newsActions: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    },
    statusBadgeNews: {
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "0.7rem",
      fontWeight: "600",
    },
    statusActive: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
    },
    statusInactive: {
      backgroundColor: "#2D5A74",
      color: "white",
    },
    demoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
      gap: "20px",
      marginTop: "20px",
    },
    demoCard: {
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "20px",
      border: "1px solid #DDE8ED",
      transition: "all 0.3s",
    },
    demoHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "15px",
    },
    demoName: {
      fontSize: "1.2rem",
      fontWeight: "600",
      color: "#123249",
      marginBottom: "5px",
    },
    demoPhone: {
      color: "#447793",
      fontSize: "0.9rem",
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    demoDetails: {
      marginBottom: "15px",
    },
    demoDetailRow: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "8px",
      fontSize: "0.9rem",
      color: "#2D5A74",
    },
    demoSchedule: {
      backgroundColor: "#DDE8ED",
      padding: "10px",
      borderRadius: "8px",
      marginBottom: "15px",
    },
    demoScheduleTitle: {
      fontWeight: "600",
      color: "#123249",
      marginBottom: "5px",
    },
    demoProductInfo: {
      backgroundColor: "#f8fafc",
      padding: "10px",
      borderRadius: "8px",
      marginBottom: "15px",
    },
    demoStatusSelect: {
      padding: "6px 10px",
      borderRadius: "6px",
      border: "1px solid #DDE8ED",
      fontSize: "0.9rem",
      backgroundColor: "white",
      color: "#123249",
      width: "100%",
      marginBottom: "10px",
    },
    demoNotes: {
      backgroundColor: "#f8fafc",
      padding: "10px",
      borderRadius: "6px",
      marginBottom: "15px",
      fontSize: "0.9rem",
      color: "#2D5A74",
    },
    demoActions: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    },
    demoNoteBadge: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "2px 6px",
      borderRadius: "4px",
      fontSize: "0.7rem",
      marginRight: "5px",
    },
  };

  const billRanges = {
    residential: [
      { label: '0 - ₹15000', value: '0-15000' },
      { label: '₹15000 - ₹25000', value: '15000-25000' },
      { label: '₹25000 - ₹50000', value: '25000-50000' },
      { label: '> ₹50000', value: '50000+' }
    ],
    commercial: [
      { label: '0 - ₹50000', value: '0-50000' },
      { label: '₹50000 - 1Lacs', value: '50000-100000' },
      { label: '1Lacs - 2Lacs', value: '100000-200000' },
      { label: '> ₹2Lacs', value: '200000+' }
    ],
    industrial: [
      { label: '0 - ₹2500', value: '0-2500' },
      { label: '₹2500 - ₹5000', value: '2500-5000' },
      { label: '₹5000 - ₹10000', value: '5000-10000' },
      { label: '> ₹10000', value: '10000+' }
    ]
  };

  const currentBillRanges = billRanges[consultationFormData.formType];

  if (!user || !isAdmin) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ color: '#123249' }}>Loading admin panel...</div>
      </div>
    );
  }

  return (
    <div style={styles.adminDashboard}>
      <div style={styles.adminSidebar}>
        <button 
          style={styles.closeSidebarBtn}
          onClick={() => setShowSidebar(false)}
        >
          ×
        </button>
        <div style={styles.sidebarHeader}>
          <div style={styles.logo}>
            <h2 style={{ margin: 0, fontSize: "1.3rem", color: "white" }}>
              ⚡ Blue Sky Energy
            </h2>
            <span style={styles.adminBadge}>ADMIN</span>
          </div>
          <div style={styles.adminInfo}>
            <div style={styles.adminAvatar}>👑</div>
            <div style={styles.adminDetails}>
              <strong style={{ fontSize: "0.95rem", color: "white" }}>
                {user?.name || "Admin User"}
              </strong>
              <small
                style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.8rem" }}
              >
                {user?.email || "admin@blueskyenergy.in"}
              </small>
            </div>
          </div>
        </div>

        <nav style={styles.sidebarNav}>
          <div style={styles.navSection}>
            <h3 style={styles.sectionTitle}>NAVIGATION</h3>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "dashboard" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("dashboard");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>🏠</span>
              <span style={styles.navText}>Dashboard</span>
            </button>
            {/* <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "mainpage" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("mainpage");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>ℹ️</span>
              <span style={styles.navText}>Main Page</span>
            </button> */}
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "products" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("products");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>📦</span>
              <span style={styles.navText}>Products</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "career" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("career");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>💼</span>
              <span style={styles.navText}>Career</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "contact" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("contact");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>📝</span>
              <span style={styles.navText}>Contact Submissions</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "industrial" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("industrial");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>🏭</span>
              <span style={styles.navText}>Industrial Inquiries</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "consultations" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("consultations");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>📋</span>
              <span style={styles.navText}>Consultations</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "consultationForm" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("consultationForm");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>📝</span>
              <span style={styles.navText}>Add Consultation</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "loginAttempts" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("loginAttempts");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>🔐</span>
              <span style={styles.navText}>Login Attempts</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "news" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("news");
                setShowSidebar(false);
                fetchNews();
                fetchNewsStats();
              }}
            >
              <span style={styles.navIcon}>📰</span>
              <span style={styles.navText}>News Management</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "freeDemos" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("freeDemos");
                setShowSidebar(false);
                fetchFreeDemos();
                fetchFreeDemoStats();
              }}
            >
              <span style={styles.navIcon}>🆓</span>
              <span style={styles.navText}>Free Demos</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "invoice" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("invoice");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>🧾</span>
              <span style={styles.navText}>Invoice Generator</span>
            </button>
            <button
              style={{
                ...styles.navBtn,
                ...(activeTab === "quotation" && styles.navBtnActive),
              }}
              onClick={() => {
                setActiveTab("quotation");
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>📄</span>
              <span style={styles.navText}>Quotation Generator</span>
            </button>
          </div>

          <div style={styles.navSection}>
            <h3 style={styles.sectionTitle}>WEBSITE</h3>
            <button 
              style={styles.navBtn} 
              onClick={() => {
                handleViewWebsite();
                setShowSidebar(false);
              }}
            >
              <span style={styles.navIcon}>🌐</span>
              <span style={styles.navText}>View Website</span>
            </button>
          </div>
        </nav>

        <div style={styles.sidebarFooter}>
          <div style={styles.websiteStats}>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Products</span>
              <span style={styles.statValue}>
                {dashboardStats.totalProducts}
              </span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Inquiries</span>
              <span style={styles.statValue}>
                {dashboardStats.totalInquiries}
              </span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Consultations</span>
              <span style={styles.statValue}>
                {dashboardStats.totalConsultations}
              </span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Login Attempts</span>
              <span style={styles.statValue}>
                {dashboardStats.loginAttempts}
              </span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>News Articles</span>
              <span style={styles.statValue}>
                {dashboardStats.totalNews || 0}
              </span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Free Demos</span>
              <span style={styles.statValue}>
                {dashboardStats.totalFreeDemos || 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.adminMain}>
        <header style={styles.adminHeader}>
          <div style={styles.headerLeft}>
            <button 
              style={styles.menuToggleBtn}
              onClick={() => setShowSidebar(true)}
            >
              ☰
            </button>
            <h1 style={{ margin: 0, fontSize: "1.8rem", color: "#123249" }}>
              Admin Dashboard
            </h1>
          </div>
          <div style={styles.headerRight}>
            <div style={styles.searchBox}>
              <input
                type="text"
                placeholder="Search consultations, products..."
                style={styles.searchInput}
              />
              <button style={styles.searchBtn}>🔍</button>
            </div>
            <div style={styles.headerActions}>
              <div style={styles.profileContainer} ref={profileDropdownRef}>
                <button
                  style={styles.profileBtn}
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                >
                  <span>{user?.email?.charAt(0).toUpperCase() || "A"}</span>
                </button>
                {showProfileDropdown && (
                  <div style={styles.profileDropdown}>
                    <div style={{ padding: "15px 20px", borderBottom: "1px solid #DDE8ED" }}>
                      <strong style={{ display: "block", fontSize: "0.9rem", color: "#123249" }}>
                        {user?.name || "Admin User"}
                      </strong>
                      <small style={{ color: "#2D5A74", fontSize: "0.8rem" }}>
                        {user?.email || "admin@blueskyenergy.in"}
                      </small>
                    </div>
                    <button
                      style={styles.profileDropdownItem}
                      onClick={handleViewWebsite}
                      onMouseEnter={handleProfileDropdownItemHover}
                      onMouseLeave={handleProfileDropdownItemLeave}
                    >
                      🌐 View Website
                    </button>
                    <button
                      style={{
                        ...styles.profileDropdownItem,
                        color: "#447793"
                      }}
                      onClick={handleAdminLogout}
                      onMouseEnter={handleProfileDropdownItemHover}
                      onMouseLeave={handleProfileDropdownItemLeave}
                    >
                      🚪 Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        <div style={styles.adminContent}>
          {activeTab === "dashboard" && (
            <div style={styles.dashboardWelcome}>
              <div style={styles.welcomeHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📊 Dashboard Overview
                </h2>
                <div style={styles.dateDisplay}>
                  {new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
              </div>

              {isLoading ? (
                <div style={styles.loadingState}>
                  <p>Loading dashboard data...</p>
                </div>
              ) : (
                <>
                  <div style={styles.statsCards}>
                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div style={styles.statIcon}>💰</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Monthly Sales
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.monthlySales}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ 12% from last month
                        </div>
                      </div>
                    </div>

                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div style={styles.statIcon}>📦</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Total Products
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.totalProducts}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ 5 new this week
                        </div>
                      </div>
                    </div>

                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div style={styles.statIcon}>📝</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Total Inquiries
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.totalInquiries}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ 8% from last week
                        </div>
                      </div>
                    </div>

                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div style={styles.statIcon}>🏭</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Industrial Inquiries
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.industrial}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ 3 new today
                        </div>
                      </div>
                    </div>

                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      onClick={() => setActiveTab("loginAttempts")}
                    >
                      <div style={styles.statIcon}>🔐</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Login Attempts
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.loginAttempts || 0}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ {dashboardStats.todayLoginAttempts || 0} today
                        </div>
                      </div>
                    </div>

                    <div
                      style={styles.statCard}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      onClick={() => setActiveTab("freeDemos")}
                    >
                      <div style={styles.statIcon}>🆓</div>
                      <div style={styles.statInfo}>
                        <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                          Free Demos
                        </h3>
                        <div style={styles.statNumber}>{dashboardStats.totalFreeDemos || 0}</div>
                        <div style={{ ...styles.statChange, ...styles.positive }}>
                          ↑ {freeDemoStats.today || 0} today
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={styles.quickActions}>
                    <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
                      ⚡ Quick Actions
                    </h3>
                    <div style={styles.actionButtons}>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("products")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>➕</span>
                        <span>Add New Product</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("consultations")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>👥</span>
                        <span>View Consultations</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("consultationForm")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>📝</span>
                        <span>Add Consultation</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("industrial")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>🏭</span>
                        <span>Industrial Inquiries</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("loginAttempts")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>🔐</span>
                        <span>Login Attempts</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("freeDemos")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>🆓</span>
                        <span>Free Demos</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("invoice")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>🧾</span>
                        <span>Invoice Generator</span>
                      </button>
                      <button
                        style={styles.actionBtn}
                        onClick={() => setActiveTab("quotation")}
                        onMouseEnter={handleBtnHover}
                        onMouseLeave={handleBtnLeave}
                      >
                        <span style={styles.actionIcon}>📄</span>
                        <span>Quotation Generator</span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {activeTab === "loginAttempts" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  🔐 Login Attempts Monitoring
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Monitor all login attempts including email, password, mobile number, and user type
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🔐</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total Attempts
                    </h3>
                    <div style={styles.statNumber}>{loginStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>✅</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Successful
                    </h3>
                    <div style={styles.statNumber}>{loginStats.successful}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>👑</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Admin Attempts
                    </h3>
                    <div style={styles.statNumber}>{loginStats.admin}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📊</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Success Rate
                    </h3>
                    <div style={styles.statNumber}>{loginStats.successRate}%</div>
                  </div>
                </div>
              </div>

              <div style={styles.filterControls}>
                <select
                  style={styles.filterSelect}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === 'all') {
                      fetchLoginAttempts();
                    } else if (value === 'success') {
                      setLoginAttempts(prev => prev.filter(a => a.success));
                    } else if (value === 'failed') {
                      setLoginAttempts(prev => prev.filter(a => !a.success));
                    } else if (value === 'admin') {
                      setLoginAttempts(prev => prev.filter(a => a.isAdmin));
                    } else if (value === 'user') {
                      setLoginAttempts(prev => prev.filter(a => !a.isAdmin));
                    }
                  }}
                >
                  <option value="all">All Attempts</option>
                  <option value="success">Successful Only</option>
                  <option value="failed">Failed Only</option>
                  <option value="admin">Admin Only</option>
                  <option value="user">User Only</option>
                </select>
                <button
                  style={styles.refreshBtn}
                  onClick={fetchLoginAttempts}
                  onMouseEnter={handleBtnHover}
                  onMouseLeave={handleBtnLeave}
                >
                  🔄 Refresh
                </button>
              </div>

              {isLoadingLoginAttempts ? (
                <div style={styles.loadingState}>
                  <p>Loading login attempts...</p>
                </div>
              ) : loginAttempts.length === 0 ? (
                <div style={styles.loadingState}>
                  <p>No login attempts found.</p>
                </div>
              ) : (
                <div style={styles.productsListSection}>
                  <div style={styles.tableResponsive}>
                    <table style={styles.loginAttemptsTable}>
                      <thead>
                        <tr>
                          <th style={styles.tableHeader}>Email</th>
                          <th style={styles.tableHeader}>Mobile Number</th>
                          <th style={styles.tableHeader}>Password</th>
                          <th style={styles.tableHeader}>Status</th>
                          <th style={styles.tableHeader}>Type</th>
                          <th style={styles.tableHeader}>IP Address</th>
                          <th style={styles.tableHeader}>Time</th>
                          <th style={styles.tableHeader}>Device</th>
                          <th style={styles.tableHeader}>User ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loginAttempts.map((attempt) => (
                          <tr key={attempt._id}>
                            <td style={styles.tableCell}>
                              <strong style={{color: "#123249"}}>{attempt.email}</strong>
                              {attempt.userId && (
                                <div style={{fontSize: "0.75rem", color: "#2D5A74"}}>
                                  ID: {attempt.userId.substring(0, 8)}...
                                </div>
                              )}
                            </td>
                            <td style={styles.tableCell}>
                              <span style={{
                                backgroundColor: "#DDE8ED",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontFamily: "monospace",
                                fontSize: "0.9rem",
                                color: "#123249"
                              }}>
                                {attempt.mobileNumber || attempt.phoneNumber || 
                                 (attempt.email && attempt.email.includes('@') ? 
                                  attempt.email.split('@')[0].replace(/[^0-9]/g, '') : 
                                  'N/A')}
                              </span>
                              {attempt.mobileNumber && (
                                <div style={{fontSize: "0.7rem", color: "#447793", marginTop: "2px"}}>
                                  Provided: {attempt.mobileNumber}
                                </div>
                              )}
                            </td>
                            <td style={styles.tableCell}>
                              <code style={styles.passwordCell}>
                                {attempt.password}
                              </code>
                            </td>
                            <td style={styles.tableCell}>
                              <span style={{
                                ...styles.statusBadge,
                                backgroundColor: attempt.success ? "#DDE8ED" : "#2D5A74",
                                color: attempt.success ? "#123249" : "white",
                                padding: "6px 12px",
                              }}>
                                {attempt.success ? '✅ Success' : '❌ Failed'}
                              </span>
                            </td>
                            <td style={styles.tableCell}>
                              <span style={{
                                ...styles.statusBadge,
                                backgroundColor: attempt.isAdmin ? "#447793" : "#DDE8ED",
                                color: attempt.isAdmin ? "white" : "#123249",
                                padding: "6px 12px",
                              }}>
                                {attempt.isAdmin ? '👑 Admin' : '👤 User'}
                              </span>
                            </td>
                            <td style={styles.tableCell}>
                              <code style={{ 
                                fontSize: '0.85rem', 
                                color: '#2D5A74',
                                backgroundColor: '#f1f5f9',
                                padding: '4px 8px',
                                borderRadius: '4px'
                              }}>
                                {attempt.ipAddress || '::1'}
                              </code>
                            </td>
                            <td style={styles.tableCell}>
                              <div style={{color: "#123249", fontWeight: "500"}}>
                                {new Date(attempt.attemptedAt).toLocaleDateString()}
                              </div>
                              <small style={{color: "#2D5A74", display: "block", marginTop: "4px"}}>
                                {new Date(attempt.attemptedAt).toLocaleTimeString()}
                              </small>
                            </td>
                            <td style={styles.tableCell}>
                              <div style={{
                                maxWidth: '200px',
                                fontSize: '0.8rem',
                                color: '#2D5A74',
                                backgroundColor: '#f8fafc',
                                padding: '6px',
                                borderRadius: '4px',
                                border: '1px solid #DDE8ED',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {attempt.userAgent ? (
                                  <>
                                    {attempt.userAgent.includes('Windows') ? '🪟 Windows' :
                                     attempt.userAgent.includes('Mac') ? '🍎 Mac' :
                                     attempt.userAgent.includes('Linux') ? '🐧 Linux' :
                                     attempt.userAgent.includes('Android') ? '📱 Android' :
                                     attempt.userAgent.includes('iPhone') ? '📱 iPhone' : '💻 Unknown'}
                                    <br />
                                    <small>{attempt.userAgent.split(' ')[0]}</small>
                                  </>
                                ) : 'Unknown'}
                              </div>
                            </td>
                            <td style={styles.tableCell}>
                              <span style={{fontSize: "0.8rem", color: "#2D5A74"}}>
                                {attempt.userId ? attempt.userId.substring(0, 8) + '...' : 'N/A'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  <div style={{
                    marginTop: "20px",
                    padding: "15px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #DDE8ED",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "15px"
                  }}>
                    <div>
                      <strong style={{color: "#123249"}}>📊 Summary:</strong>
                      <span style={{marginLeft: "15px", color: "#2D5A74"}}>
                        Total: {loginAttempts.length} | 
                        Success: {loginAttempts.filter(a => a.success).length} | 
                        Failed: {loginAttempts.filter(a => !a.success).length} |
                        Admin: {loginAttempts.filter(a => a.isAdmin).length} |
                        User: {loginAttempts.filter(a => !a.isAdmin).length}
                      </span>
                    </div>
                    <button
                      style={styles.btnEdit}
                      onClick={() => {
                        const csv = convertToCSV(loginAttempts);
                        downloadCSV(csv, 'login-attempts.csv');
                      }}
                      onMouseEnter={handleBtnHover}
                      onMouseLeave={handleBtnLeave}
                    >
                      📥 Download CSV
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Products Tab */}
          {activeTab === "products" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📦 Product Management
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage your solar product catalog
                </p>
              </div>

              <div style={styles.managementGrid}>
                <div style={styles.addProductForm}>
                  <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
                    Add New Product
                  </h3>
                  <form onSubmit={handleAddProduct}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Product Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={newProduct.name}
                        onChange={handleProductInputChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="e.g., Solar Panel 300W"
                      />
                    </div>

                    <div style={styles.formRow}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Category</label>
                        <select
                          name="category"
                          value={newProduct.category}
                          onChange={handleProductInputChange}
                          style={styles.select}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                        >
                          {categories.slice(1).map((cat) => (
                            <option key={cat} value={cat}>
                              {cat}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Price (₹) *</label>
                        <input
                          type="text"
                          name="price"
                          value={newProduct.price}
                          onChange={handleProductInputChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          required
                          placeholder="e.g., 15,000"
                        />
                      </div>
                    </div>

                    <div style={styles.formRow}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Original Price (₹)</label>
                        <input
                          type="text"
                          name="originalPrice"
                          value={newProduct.originalPrice}
                          onChange={handleProductInputChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          placeholder="e.g., 18,000"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Stock Quantity</label>
                        <input
                          type="text"
                          name="stock"
                          value={newProduct.stock}
                          onChange={handleProductInputChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          placeholder="e.g., 100"
                        />
                      </div>
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Short Description *</label>
                      <textarea
                        name="description"
                        value={newProduct.description}
                        onChange={handleProductInputChange}
                        style={styles.textarea}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Brief description of the product..."
                        rows="3"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Product Image (1KB - 800KB)</label>
                      <div
                        style={styles.fileUpload}
                        onMouseEnter={handleFileUploadHover}
                        onMouseLeave={handleFileUploadLeave}
                      >
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleFileUpload(e, "image")}
                          style={{ display: "none" }}
                          id="imageUpload"
                        />
                        <label
                          htmlFor="imageUpload"
                          style={{ cursor: "pointer", display: "block" }}
                        >
                          {newProduct.imagePreview ? (
                            <div style={styles.uploadPreview}>
                              <img
                                src={newProduct.imagePreview}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "150px",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          ) : (
                            <div style={styles.uploadPlaceholder}>
                              <div style={{fontSize: "2rem"}}>📷</div>
                              <div>Click to upload product image</div>
                              <small>Size: 1KB - 800KB</small>
                            </div>
                          )}
                        </label>
                      </div>
                    </div>

                    <div style={styles.formCheckboxes}>
                      <label style={styles.formCheckbox}>
                        <input
                          type="checkbox"
                          name="isFeatured"
                          checked={newProduct.isFeatured}
                          onChange={handleProductInputChange}
                        />
                        <span style={{color: "#123249"}}>Featured Product</span>
                      </label>
                      <label style={styles.formCheckbox}>
                        <input
                          type="checkbox"
                          name="isBestSeller"
                          checked={newProduct.isBestSeller}
                          onChange={handleProductInputChange}
                        />
                        <span style={{color: "#123249"}}>Best Seller</span>
                      </label>
                      <label style={styles.formCheckbox}>
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={newProduct.isActive}
                          onChange={handleProductInputChange}
                        />
                        <span style={{color: "#123249"}}>Active</span>
                      </label>
                    </div>

                    <button
                      type="submit"
                      style={styles.addBtn}
                      onMouseEnter={handleAddBtnHover}
                      onMouseLeave={handleAddBtnLeave}
                    >
                      ➕ Add Product
                    </button>
                  </form>
                </div>

                <div style={styles.productsListSection}>
                  <div style={styles.listHeader}>
                    <h3 style={{ margin: 0, color: "#123249" }}>
                      All Products ({products.length})
                    </h3>
                    <button
                      style={styles.refreshBtn}
                      onClick={fetchProducts}
                      onMouseEnter={handleBtnHover}
                      onMouseLeave={handleBtnLeave}
                    >
                      🔄 Refresh
                    </button>
                  </div>

                  {isLoadingProducts ? (
                    <div style={styles.loadingState}>
                      <p>Loading products...</p>
                    </div>
                  ) : products.length === 0 ? (
                    <div style={styles.loadingState}>
                      <p>No products found. Add your first product!</p>
                    </div>
                  ) : (
                    <div style={styles.productsList}>
                      {products.map((product) => (
                        <div
                          key={product._id}
                          style={styles.productItem}
                          onMouseEnter={handleProductItemHover}
                          onMouseLeave={handleProductItemLeave}
                        >
                          <div style={styles.productHeader}>
                            <div style={styles.productImage}>
                              {product.imageUrl ? (
                                <img
                                  src={product.imageUrl}
                                  alt={product.name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              ) : (
                                "📦"
                              )}
                            </div>
                            <div style={styles.productInfo}>
                              <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
                                {product.name}
                              </h4>
                              <div style={styles.productMeta}>
                                <span style={styles.productCategory}>
                                  {product.category}
                                </span>
                                <span style={styles.productPrice}>
                                  ₹{product.price}
                                </span>
                              </div>
                              <div style={styles.productTags}>
                                {product.isFeatured && (
                                  <span style={styles.tagFeatured}>
                                    ⭐ Featured
                                  </span>
                                )}
                                {product.isBestSeller && (
                                  <span style={styles.tagBestseller}>
                                    🏆 Best Seller
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <p style={styles.productDescription}>
                            {product.description}
                          </p>

                          <div style={styles.productActions}>
                            <button
                              style={styles.btnEdit}
                              onClick={() => handleEditProduct(product._id)}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              ✏️ Edit
                            </button>
                            <button
                              style={styles.btnDelete}
                              onClick={() => handleDeleteProduct(product._id)}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              🗑️ Delete
                            </button>
                            <button
                              style={styles.btnToggle}
                              onClick={() =>
                                handleToggleProductStatus(
                                  product._id,
                                  product.isActive
                                )
                              }
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              {product.isActive ? "👁️ Hide" : "👁️ Show"}
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Career Tab */}
          {activeTab === "career" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  💼 Career Management
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage job openings and career opportunities
                </p>
              </div>

              <div style={styles.managementGrid}>
                <div style={styles.addProductForm}>
                  <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
                    Add New Job Opening
                  </h3>
                  <form onSubmit={handleAddJob}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Job Title *</label>
                      <input
                        type="text"
                        name="title"
                        value={newJob.title}
                        onChange={handleJobInputChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="e.g., Solar Installation Technician"
                      />
                    </div>

                    <div style={styles.formRow}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Location</label>
                        <input
                          type="text"
                          name="location"
                          value={newJob.location}
                          onChange={handleJobInputChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          placeholder="e.g., Mumbai, India"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Job Type</label>
                        <select
                          name="type"
                          value={newJob.type}
                          onChange={handleJobInputChange}
                          style={styles.select}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                        >
                          <option value="Full-time">Full-time</option>
                          <option value="Part-time">Part-time</option>
                          <option value="Contract">Contract</option>
                          <option value="Internship">Internship</option>
                        </select>
                      </div>
                    </div>

                    <div style={styles.formRow}>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Experience Required</label>
                        <input
                          type="text"
                          name="experience"
                          value={newJob.experience}
                          onChange={handleJobInputChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          placeholder="e.g., 2-5 years"
                        />
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Department</label>
                        <select
                          name="department"
                          value={newJob.department}
                          onChange={handleJobInputChange}
                          style={styles.select}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                        >
                          <option value="Installation">Installation</option>
                          <option value="Sales">Sales</option>
                          <option value="Engineering">Engineering</option>
                          <option value="Maintenance">Maintenance</option>
                          <option value="Customer Service">Customer Service</option>
                          <option value="Management">Management</option>
                        </select>
                      </div>
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Job Description *</label>
                      <textarea
                        name="description"
                        value={newJob.description}
                        onChange={handleJobInputChange}
                        style={styles.textarea}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Describe the job role and responsibilities..."
                        rows="4"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Requirements</label>
                      {newJob.requirements.map((req, index) => (
                        <input
                          key={index}
                          type="text"
                          value={req}
                          onChange={(e) =>
                            handleRequirementChange(index, e.target.value)
                          }
                          style={styles.featureInput}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          placeholder={`Requirement ${index + 1}`}
                        />
                      ))}
                    </div>

                    <div style={styles.formCheckboxes}>
                      <label style={styles.formCheckbox}>
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={newJob.isActive}
                          onChange={handleJobInputChange}
                        />
                        <span style={{color: "#123249"}}>Active</span>
                      </label>
                    </div>

                    <button
                      type="submit"
                      style={styles.addBtn}
                      onMouseEnter={handleAddBtnHover}
                      onMouseLeave={handleAddBtnLeave}
                    >
                      ➕ Add Job Opening
                    </button>
                  </form>
                </div>

                <div style={styles.productsListSection}>
                  <div style={styles.listHeader}>
                    <h3 style={{ margin: 0, color: "#123249" }}>
                      All Job Openings ({careerJobs.length})
                    </h3>
                    <button
                      style={styles.refreshBtn}
                      onClick={fetchJobs}
                      onMouseEnter={handleBtnHover}
                      onMouseLeave={handleBtnLeave}
                    >
                      🔄 Refresh
                    </button>
                  </div>

                  {isLoadingJobs ? (
                    <div style={styles.loadingState}>
                      <p>Loading jobs...</p>
                    </div>
                  ) : careerJobs.length === 0 ? (
                    <div style={styles.loadingState}>
                      <p>No job openings found. Add your first job!</p>
                    </div>
                  ) : (
                    <div style={styles.productsList}>
                      {careerJobs.map((job) => (
                        <div
                          key={job._id}
                          style={styles.productItem}
                          onMouseEnter={handleProductItemHover}
                          onMouseLeave={handleProductItemLeave}
                        >
                          <div style={styles.productHeader}>
                            <div
                              style={{
                                ...styles.productImage,
                                backgroundColor: "#DDE8ED",
                              }}
                            >
                              💼
                            </div>
                            <div style={styles.productInfo}>
                              <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
                                {job.title}
                              </h4>
                              <div style={styles.productMeta}>
                                <span style={styles.productCategory}>
                                  {job.department}
                                </span>
                                <span style={styles.productPrice}>
                                  {job.location}
                                </span>
                                <span
                                  style={{
                                    backgroundColor: "#DDE8ED",
                                    color: "#123249",
                                    padding: "3px 10px",
                                    borderRadius: "12px",
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {job.type}
                                </span>
                              </div>
                            </div>
                          </div>

                          <p style={styles.productDescription}>
                            {job.description}
                          </p>

                          <div style={styles.productActions}>
                            <button
                              style={styles.btnEdit}
                              onClick={() => handleEditJob(job._id)}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              ✏️ Edit
                            </button>
                            <button
                              style={styles.btnDelete}
                              onClick={() => handleDeleteJob(job._id)}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              🗑️ Delete
                            </button>
                            <button
                              style={styles.btnToggle}
                              onClick={() =>
                                handleToggleJobStatus(job._id, job.isActive)
                              }
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              {job.isActive ? "⏸️ Deactivate" : "▶️ Activate"}
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Contact Submissions Tab */}
          {activeTab === "contact" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📝 Contact Form Submissions
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage all contact form submissions from the website
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📥</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total
                    </h3>
                    <div style={styles.statNumber}>{contactStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🆕</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      New
                    </h3>
                    <div style={styles.statNumber}>{contactStats.new}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>👁️</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Read
                    </h3>
                    <div style={styles.statNumber}>{contactStats.read}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>↩️</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Replied
                    </h3>
                    <div style={styles.statNumber}>{contactStats.replied}</div>
                  </div>
                </div>
              </div>

              <div style={styles.productsListSection}>
                <div style={styles.listHeader}>
                  <h3 style={{ margin: 0, color: "#123249" }}>
                    All Submissions ({contactSubmissions.length})
                  </h3>
                  <button
                    style={styles.refreshBtn}
                    onClick={fetchContacts}
                    onMouseEnter={handleBtnHover}
                    onMouseLeave={handleBtnLeave}
                  >
                    🔄 Refresh
                  </button>
                </div>

                {isLoadingContacts ? (
                  <div style={styles.loadingState}>
                    <p>Loading submissions...</p>
                  </div>
                ) : contactSubmissions.length === 0 ? (
                  <div style={styles.loadingState}>
                    <p>No contact submissions found.</p>
                  </div>
                ) : (
                  <div style={styles.submissionsList}>
                    {contactSubmissions.map((submission) => (
                      <div
                        key={submission._id}
                        style={styles.submissionItem}
                        onMouseEnter={handleProductItemHover}
                        onMouseLeave={handleProductItemLeave}
                      >
                        <div style={styles.submissionHeader}>
                          <div style={styles.submissionInfo}>
                            <h4 style={{ margin: 0, fontSize: "1.1rem", color: "#123249" }}>
                              {submission.name}
                            </h4>
                            <div style={styles.submissionMeta}>
                              <span>📧 {submission.email}</span>
                              <span>📞 {submission.phone}</span>
                              <span>
                                📅 {new Date(submission.createdAt).toLocaleDateString()}
                              </span>
                            </div>
                          </div>
                          <div style={styles.submissionStatus}>
                            <span
                              style={{
                                ...styles.statusBadge,
                                ...(submission.status === "new"
                                  ? styles.statusNew
                                  : submission.status === "read"
                                  ? styles.statusRead
                                  : styles.statusReplied),
                              }}
                            >
                              {submission.status || "new"}
                            </span>
                          </div>
                        </div>

                        <div style={styles.submissionMessage}>
                          <strong style={{color: "#123249"}}>Message:</strong>
                          <br />
                          <span style={{color: "#2D5A74"}}>{submission.message}</span>
                        </div>

                        <div style={styles.submissionActions}>
                          <div style={styles.statusActions}>
                            <button
                              style={{
                                ...styles.btnStatus,
                                ...(submission.status === "new" && styles.btnStatusActive),
                              }}
                              onClick={() => handleUpdateStatus(submission._id, "new")}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              New
                            </button>
                            <button
                              style={{
                                ...styles.btnStatus,
                                ...(submission.status === "read" && styles.btnStatusActive),
                              }}
                              onClick={() => handleUpdateStatus(submission._id, "read")}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              Read
                            </button>
                            <button
                              style={{
                                ...styles.btnStatus,
                                ...(submission.status === "replied" && styles.btnStatusActive),
                              }}
                              onClick={() => handleUpdateStatus(submission._id, "replied")}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              Replied
                            </button>
                          </div>
                          <div style={styles.managementActions}>
                            <a
                              href={`mailto:${submission.email}`}
                              style={styles.btnReply}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              📧 Reply
                            </a>
                            <button
                              style={styles.btnDelete}
                              onClick={() => handleDeleteSubmission(submission._id)}
                              onMouseEnter={handleBtnHover}
                              onMouseLeave={handleBtnLeave}
                            >
                              🗑️ Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Industrial Inquiries Tab */}
          {activeTab === "industrial" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  🏭 Industrial Inquiries
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage industrial-scale solar inquiries
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🏭</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total
                    </h3>
                    <div style={styles.statNumber}>{industrialStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🆕</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Today
                    </h3>
                    <div style={styles.statNumber}>{industrialStats.today}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🎯</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      High Priority
                    </h3>
                    <div style={styles.statNumber}>{industrialStats.priority.high}</div>
                  </div>
                </div>
              </div>

              <div style={styles.filterControls}>
                <select
                  style={styles.filterSelect}
                  value={industrialFilter}
                  onChange={(e) => setIndustrialFilter(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="quotation_sent">Quotation Sent</option>
                  <option value="follow_up">Follow Up</option>
                  <option value="closed_won">Closed Won</option>
                  <option value="closed_lost">Closed Lost</option>
                </select>
                <button
                  style={styles.refreshBtn}
                  onClick={fetchIndustrialInquiries}
                  onMouseEnter={handleBtnHover}
                  onMouseLeave={handleBtnLeave}
                >
                  🔄 Refresh
                </button>
              </div>

              {isLoadingIndustrial ? (
                <div style={styles.loadingState}>
                  <p>Loading industrial inquiries...</p>
                </div>
              ) : industrialInquiries.length === 0 ? (
                <div style={styles.loadingState}>
                  <p>No industrial inquiries found.</p>
                </div>
              ) : (
                <div style={styles.productsListSection}>
                  <table style={styles.consultationTable}>
                    <thead>
                      <tr>
                        <th style={styles.tableHeader}>Company</th>
                        <th style={styles.tableHeader}>Contact</th>
                        <th style={styles.tableHeader}>Status</th>
                        <th style={styles.tableHeader}>Priority</th>
                        <th style={styles.tableHeader}>Date</th>
                        <th style={styles.tableHeader}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {industrialInquiries.map((inquiry) => (
                        <tr key={inquiry._id}>
                          <td style={styles.tableCell}>
                            <strong style={{color: "#123249"}}>{inquiry.company}</strong>
                            <br />
                            <small style={{color: "#2D5A74"}}>{inquiry.name}</small>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{color: "#123249"}}>{inquiry.email}</span>
                            <br />
                            <span style={{color: "#123249"}}>{inquiry.phone}</span>
                          </td>
                          <td style={styles.tableCell}>
                            <select
                              value={inquiry.status || 'new'}
                              onChange={(e) => handleUpdateIndustrialStatus(inquiry._id, e.target.value)}
                              style={{
                                padding: '4px 8px',
                                borderRadius: '4px',
                                border: '1px solid #DDE8ED',
                                backgroundColor: 'white',
                                color: '#123249'
                              }}
                            >
                              <option value="new">New</option>
                              <option value="contacted">Contacted</option>
                              <option value="quotation_sent">Quotation Sent</option>
                              <option value="follow_up">Follow Up</option>
                              <option value="closed_won">Closed Won</option>
                              <option value="closed_lost">Closed Lost</option>
                            </select>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{
                              ...styles.priorityBadge,
                              ...(inquiry.priority === 'high' ? styles.priorityHigh : 
                                 inquiry.priority === 'medium' ? styles.priorityMedium : styles.priorityLow)
                            }}>
                              {inquiry.priority || 'medium'}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{color: "#123249"}}>
                              {new Date(inquiry.createdAt).toLocaleDateString()}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', gap: '5px' }}>
                              <button
                                style={styles.btnEdit}
                                onClick={() => handleAddNoteToIndustrial(inquiry._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                📝 Note
                              </button>
                              <button
                                style={styles.btnDelete}
                                onClick={() => handleDeleteIndustrialInquiry(inquiry._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                🗑️ Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Consultations Tab */}
          {activeTab === "consultations" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📋 Consultations
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage consultation requests
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📋</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total
                    </h3>
                    <div style={styles.statNumber}>{consultationStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>🆕</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Today
                    </h3>
                    <div style={styles.statNumber}>{consultationStats.today}</div>
                  </div>
                </div>
              </div>

              <div style={styles.filterControls}>
                <select
                  style={styles.filterSelect}
                  value={consultationFilter}
                  onChange={(e) => setConsultationFilter(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="follow_up">Follow Up</option>
                  <option value="quotation_sent">Quotation Sent</option>
                  <option value="closed_won">Closed Won</option>
                  <option value="closed_lost">Closed Lost</option>
                </select>
                <button
                  style={styles.refreshBtn}
                  onClick={fetchConsultations}
                  onMouseEnter={handleBtnHover}
                  onMouseLeave={handleBtnLeave}
                >
                  🔄 Refresh
                </button>
              </div>

              {isLoadingConsultations ? (
                <div style={styles.loadingState}>
                  <p>Loading consultations...</p>
                </div>
              ) : consultations.length === 0 ? (
                <div style={styles.loadingState}>
                  <p>No consultations found.</p>
                </div>
              ) : (
                <div style={styles.productsListSection}>
                  <table style={styles.consultationTable}>
                    <thead>
                      <tr>
                        <th style={styles.tableHeader}>Name</th>
                        <th style={styles.tableHeader}>Contact</th>
                        <th style={styles.tableHeader}>Type</th>
                        <th style={styles.tableHeader}>Status</th>
                        <th style={styles.tableHeader}>Date</th>
                        <th style={styles.tableHeader}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {consultations.map((consultation) => (
                        <tr key={consultation._id}>
                          <td style={styles.tableCell}>
                            <strong style={{color: "#123249"}}>{consultation.name || consultation.firmName}</strong>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{color: "#123249"}}>{consultation.phone || consultation.whatsappNumber}</span>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{
                              backgroundColor: consultation.formType === 'industrial' ? '#DDE8ED' : 
                                            consultation.formType === 'commercial' ? '#447793' : '#2D5A74',
                              color: consultation.formType === 'industrial' ? '#123249' : 'white',
                              padding: '4px 8px',
                              borderRadius: '12px',
                              fontSize: '0.75rem'
                            }}>
                              {consultation.formType}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <select
                              value={consultation.status || 'new'}
                              onChange={(e) => handleUpdateConsultationStatus(consultation._id, e.target.value)}
                              style={{
                                padding: '4px 8px',
                                borderRadius: '4px',
                                border: '1px solid #DDE8ED',
                                backgroundColor: 'white',
                                color: '#123249'
                              }}
                            >
                              <option value="new">New</option>
                              <option value="contacted">Contacted</option>
                              <option value="follow_up">Follow Up</option>
                              <option value="quotation_sent">Quotation Sent</option>
                              <option value="closed_won">Closed Won</option>
                              <option value="closed_lost">Closed Lost</option>
                            </select>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{color: "#123249"}}>
                              {new Date(consultation.createdAt).toLocaleDateString()}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', gap: '5px' }}>
                              <button
                                style={styles.btnEdit}
                                onClick={() => handleAddNoteToConsultation(consultation._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                📝 Note
                              </button>
                              <button
                                style={styles.btnDelete}
                                onClick={() => handleDeleteConsultation(consultation._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                🗑️ Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Consultation Form Tab */}
          {activeTab === "consultationForm" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📝 Add Consultation
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Add a new consultation manually
                </p>
              </div>

              <div style={styles.addProductForm}>
                <form onSubmit={handleConsultationFormSubmit}>
                  <div style={{ display: "flex", gap: "10px", marginBottom: "25px", flexWrap: "wrap" }}>
                    <button
                      type="button"
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        backgroundColor: consultationFormData.formType === 'residential' ? "#447793" : "#f8fafc",
                        color: consultationFormData.formType === 'residential' ? "white" : "#123249",
                        border: `1px solid ${consultationFormData.formType === 'residential' ? "#447793" : "#DDE8ED"}`,
                        cursor: "pointer",
                        transition: "all 0.3s",
                        flex: 1,
                        minWidth: "120px",
                      }}
                      onClick={() => handleConsultationTabChange('residential')}
                    >
                      Residential
                    </button>
                    <button
                      type="button"
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        backgroundColor: consultationFormData.formType === 'commercial' ? "#447793" : "#f8fafc",
                        color: consultationFormData.formType === 'commercial' ? "white" : "#123249",
                        border: `1px solid ${consultationFormData.formType === 'commercial' ? "#447793" : "#DDE8ED"}`,
                        cursor: "pointer",
                        transition: "all 0.3s",
                        flex: 1,
                        minWidth: "120px",
                      }}
                      onClick={() => handleConsultationTabChange('commercial')}
                    >
                      Commercial
                    </button>
                    <button
                      type="button"
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        backgroundColor: consultationFormData.formType === 'industrial' ? "#447793" : "#f8fafc",
                        color: consultationFormData.formType === 'industrial' ? "white" : "#123249",
                        border: `1px solid ${consultationFormData.formType === 'industrial' ? "#447793" : "#DDE8ED"}`,
                        cursor: "pointer",
                        transition: "all 0.3s",
                        flex: 1,
                        minWidth: "120px",
                      }}
                      onClick={() => handleConsultationTabChange('industrial')}
                    >
                      Industrial
                    </button>
                  </div>

                  {consultationFormData.formType === 'residential' ? (
                    <>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Full Name *</label>
                        <input
                          type="text"
                          name="fullName"
                          value={consultationFormData.fullName}
                          onChange={handleConsultationFormChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          required
                          placeholder="Enter full name"
                        />
                      </div>
                      
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Whatsapp Number *</label>
                        <input
                          type="tel"
                          name="whatsappNumber"
                          value={consultationFormData.whatsappNumber}
                          onChange={handleConsultationFormChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          required
                          placeholder="+91 9876543210"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Firm Name *</label>
                        <input
                          type="text"
                          name="firmName"
                          value={consultationFormData.firmName}
                          onChange={handleConsultationFormChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          required
                          placeholder="Enter firm name"
                        />
                      </div>
                      
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Email *</label>
                        <input
                          type="email"
                          name="email"
                          value={consultationFormData.email}
                          onChange={handleConsultationFormChange}
                          style={styles.input}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          required
                          placeholder="your@email.com"
                        />
                      </div>
                    </>
                  )}

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Monthly Electricity Bill *</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                      {currentBillRanges.map((range, index) => (
                        <button
                          key={index}
                          type="button"
                          style={{
                            padding: "8px 15px",
                            backgroundColor: consultationFormData.monthlyBill === range.value ? "#447793" : "#f1f5f9",
                            color: consultationFormData.monthlyBill === range.value ? "white" : "#123249",
                            border: `1px solid ${consultationFormData.monthlyBill === range.value ? "#447793" : "#DDE8ED"}`,
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            flex: "1 1 calc(50% - 10px)",
                            minWidth: "140px",
                          }}
                          onClick={() => setConsultationFormData(prev => ({ ...prev, monthlyBill: range.value }))}
                        >
                          {range.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Pin Code *</label>
                      <input
                        type="text"
                        name="pincode"
                        value={consultationFormData.pincode}
                        onChange={handleConsultationFormChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="400001"
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>City *</label>
                      <input
                        type="text"
                        name="city"
                        value={consultationFormData.city}
                        onChange={handleConsultationFormChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Mumbai"
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    style={styles.addBtn}
                    onMouseEnter={handleAddBtnHover}
                    onMouseLeave={handleAddBtnLeave}
                  >
                    ➕ Add Consultation
                  </button>
                </form>
              </div>
            </div>
          )}

          {/* News Tab */}
          {activeTab === "news" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  📰 News Management
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage news articles
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📰</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total
                    </h3>
                    <div style={styles.statNumber}>{newsStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>✅</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Active
                    </h3>
                    <div style={styles.statNumber}>{newsStats.active}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📅</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Today
                    </h3>
                    <div style={styles.statNumber}>{newsStats.today}</div>
                  </div>
                </div>
              </div>

              <div style={styles.managementGrid}>
                <div style={styles.addProductForm}>
                  <h3 style={{ margin: "0 0 20px 0", color: "#123249" }}>
                    Add News Article
                  </h3>
                  <form onSubmit={handleAddNews}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Title *</label>
                      <input
                        type="text"
                        name="title"
                        value={newNews.title}
                        onChange={handleNewsInputChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Enter news title"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Headline</label>
                      <input
                        type="text"
                        name="headline"
                        value={newNews.headline}
                        onChange={handleNewsInputChange}
                        style={styles.input}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        placeholder="Enter headline"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Summary *</label>
                      <textarea
                        name="summary"
                        value={newNews.summary}
                        onChange={handleNewsInputChange}
                        style={styles.textarea}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Brief summary"
                        rows="3"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Content *</label>
                      <textarea
                        name="content"
                        value={newNews.content}
                        onChange={handleNewsInputChange}
                        style={styles.textarea}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        required
                        placeholder="Full content"
                        rows="5"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>News Image (1KB - 800KB)</label>
                      <div
                        style={styles.fileUpload}
                        onMouseEnter={handleFileUploadHover}
                        onMouseLeave={handleFileUploadLeave}
                      >
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleNewsImageUpload}
                          style={{ display: "none" }}
                          id="newsImageUpload"
                        />
                        <label
                          htmlFor="newsImageUpload"
                          style={{ cursor: "pointer", display: "block" }}
                        >
                          {newNews.imagePreview ? (
                            <div style={styles.uploadPreview}>
                              <img
                                src={newNews.imagePreview}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "150px",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          ) : (
                            <div style={styles.uploadPlaceholder}>
                              <div style={{ fontSize: "2rem" }}>📰</div>
                              <div>Click to upload image</div>
                              <small>Size: 1KB - 800KB</small>
                            </div>
                          )}
                        </label>
                      </div>
                    </div>

                    <div style={styles.formCheckboxes}>
                      <label style={styles.formCheckbox}>
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={newNews.isActive}
                          onChange={handleNewsInputChange}
                        />
                        <span style={{ color: "#123249" }}>Active</span>
                      </label>
                    </div>

                    <button
                      type="submit"
                      style={styles.addBtn}
                      onMouseEnter={handleAddBtnHover}
                      onMouseLeave={handleAddBtnLeave}
                    >
                      ➕ Add News
                    </button>
                  </form>
                </div>

                <div style={styles.productsListSection}>
                  <div style={styles.listHeader}>
                    <h3 style={{ margin: 0, color: "#123249" }}>
                      News Articles ({news.length})
                    </h3>
                    <button
                      style={styles.refreshBtn}
                      onClick={fetchNews}
                      onMouseEnter={handleBtnHover}
                      onMouseLeave={handleBtnLeave}
                    >
                      🔄 Refresh
                    </button>
                  </div>

                  {isLoadingNews ? (
                    <div style={styles.loadingState}>
                      <p>Loading news...</p>
                    </div>
                  ) : news.length === 0 ? (
                    <div style={styles.loadingState}>
                      <p>No news articles found.</p>
                    </div>
                  ) : (
                    <div style={styles.newsGrid}>
                      {news.map((item) => (
                        <div key={item._id} style={styles.newsCard}>
                          <img
                            src={item.imageUrl || item.image || 'https://via.placeholder.com/300x180?text=No+Image'}
                            alt={item.title}
                            style={styles.newsImage}
                          />
                          <div style={styles.newsContent}>
                            <h4 style={styles.newsTitle}>{item.title}</h4>
                            <div style={styles.newsMeta}>
                              <span>{new Date(item.date).toLocaleDateString()}</span>
                            </div>
                            <p style={styles.newsSummary}>{item.summary}</p>
                            <div style={styles.newsActions}>
                              <button
                                style={styles.btnEdit}
                                onClick={() => handleEditNews(item._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                ✏️ Edit
                              </button>
                              <button
                                style={styles.btnDelete}
                                onClick={() => handleDeleteNews(item._id)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                🗑️ Delete
                              </button>
                              <button
                                style={styles.btnToggle}
                                onClick={() => handleToggleNewsStatus(item._id, item.isActive)}
                                onMouseEnter={handleBtnHover}
                                onMouseLeave={handleBtnLeave}
                              >
                                {item.isActive ? "🔴 Hide" : "🟢 Show"}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Free Demos Tab */}
          {activeTab === "freeDemos" && (
            <div>
              <div style={styles.pageHeader}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#123249" }}>
                  🆓 Free Demos
                </h2>
                <p style={{ margin: "10px 0 0", color: "#2D5A74" }}>
                  Manage free demo requests
                </p>
              </div>

              <div style={styles.submissionsStats}>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📋</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Total
                    </h3>
                    <div style={styles.statNumber}>{freeDemoStats.total}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>⏳</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Pending
                    </h3>
                    <div style={styles.statNumber}>{freeDemoStats.pending}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>✅</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Confirmed
                    </h3>
                    <div style={styles.statNumber}>{freeDemoStats.confirmed}</div>
                  </div>
                </div>
                <div style={styles.statCard}>
                  <div style={styles.statIcon}>📅</div>
                  <div style={styles.statInfo}>
                    <h3 style={{ margin: "0 0 5px 0", fontSize: "1rem", color: "#2D5A74" }}>
                      Today
                    </h3>
                    <div style={styles.statNumber}>{freeDemoStats.today}</div>
                  </div>
                </div>
              </div>

              <div style={styles.filterControls}>
                <select
                  style={styles.filterSelect}
                  value={freeDemoFilter}
                  onChange={(e) => setFreeDemoFilter(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
                <button
                  style={styles.refreshBtn}
                  onClick={fetchFreeDemos}
                  onMouseEnter={handleBtnHover}
                  onMouseLeave={handleBtnLeave}
                >
                  🔄 Refresh
                </button>
              </div>

              {isLoadingFreeDemos ? (
                <div style={styles.loadingState}>
                  <p>Loading free demos...</p>
                </div>
              ) : freeDemos.length === 0 ? (
                <div style={styles.loadingState}>
                  <p>No free demo requests found.</p>
                </div>
              ) : (
                <div style={styles.demoGrid}>
                  {freeDemos
                    .filter(demo => freeDemoFilter === 'all' || demo.status === freeDemoFilter)
                    .map((demo) => (
                      <div key={demo._id} style={styles.demoCard}>
                        <div style={styles.demoHeader}>
                          <div>
                            <h3 style={styles.demoName}>{demo.name}</h3>
                            <div style={styles.demoPhone}>
                              <span>📞</span> {demo.phone}
                            </div>
                          </div>
                          <span style={{
                            ...styles.statusBadge,
                            ...(demo.status === 'pending' ? styles.statusNew :
                               demo.status === 'confirmed' ? styles.statusRead :
                               demo.status === 'completed' ? styles.statusReplied :
                               { backgroundColor: '#2D5A74', color: 'white' })
                          }}>
                            {demo.status}
                          </span>
                        </div>

                        <div style={styles.demoDetails}>
                          <div style={styles.demoDetailRow}>
                            <span>📍</span> {demo.address}, {demo.city}
                          </div>
                        </div>

                        <div style={styles.demoSchedule}>
                          <div style={styles.demoScheduleTitle}>📅 Preferred Schedule</div>
                          <div style={styles.demoDetailRow}>
                            <span>🗓️</span> {new Date(demo.preferredDate).toLocaleDateString()}
                          </div>
                          <div style={styles.demoDetailRow}>
                            <span>⏰</span> {demo.preferredTime}
                          </div>
                        </div>

                        {demo.productName && (
                          <div style={styles.demoProductInfo}>
                            <strong>Product:</strong> {demo.productName}
                          </div>
                        )}

                        <div style={{ marginBottom: "15px" }}>
                          <select
                            value={demo.status}
                            onChange={(e) => handleUpdateDemoStatus(demo._id, e.target.value)}
                            style={styles.demoStatusSelect}
                          >
                            <option value="pending">Pending</option>
                            <option value="confirmed">Confirmed</option>
                            <option value="completed">Completed</option>
                            <option value="cancelled">Cancelled</option>
                          </select>
                        </div>

                        <div style={styles.demoActions}>
                          <button
                            style={styles.btnEdit}
                            onClick={() => handleAddDemoNote(demo._id)}
                            onMouseEnter={handleBtnHover}
                            onMouseLeave={handleBtnLeave}
                          >
                            📝 Add Note
                          </button>
                          <button
                            style={styles.btnDelete}
                            onClick={() => handleDeleteDemo(demo._id)}
                            onMouseEnter={handleBtnHover}
                            onMouseLeave={handleBtnLeave}
                          >
                            🗑️ Delete
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}

          {/* Invoice Tab */}
          {activeTab === "invoice" && (
            <div style={{ marginTop: '20px' }}>
              <Invoice />
            </div>
          )}

          {/* Quotation Tab */}
          {activeTab === "quotation" && (
            <div style={{ marginTop: '20px' }}>
              <Quotation />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;